import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AlertService } from 'src/app/View/common/alert/alert.service';
import { ViewReportService } from './view-report.service';
import * as d3 from "d3";
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as  pdfFonts from 'pdfmake/build/vfs_fonts';
import html2canvas from 'html2canvas';
import { LoaderService } from 'src/app/View/common/preloader/loader.service';
import { AddressImageService } from 'src/app/View/core/analyze-sample/view-report/address-image.service';
import { SharedService } from 'src/app/View/service/shared.service';
import { USERTYPE } from 'src/app/View/common/constants/constant';
import { AnalyzeSampleInformationService } from '../analyze-sample-information/analyze-sample-information.service';
import { LineGraphFuelComponent } from '../line-graph/line-graph-fuel.component';
//  pdfMake.vfs = pdfFonts.pdfMake.vfs;

//  pdfMake.vfs = (pdfFonts as any).vfs; 
 pdfMake.vfs = pdfFonts.vfs;
@Component({
  selector: 'app-view-report',
  templateUrl: './view-report.component.html',
  styleUrls: ['./view-report.component.css']
})
export class ViewReportComponent implements OnInit {
  @ViewChild(LineGraphFuelComponent) child: LineGraphFuelComponent;
  userRole: string = '';
  readonly USERTYPE = USERTYPE;
  currentItem: any = [];
  showMoreInformationData: any = [];
  customerAndUnitInfoColumns: any[] = [];
  fluidAndFilterInfoColumns: any[] = [];
  fluidAndFilterInfoColumnsForFuel: any[] = [];
  sampleInfoColumns: any[] = [];
  oilHealth = [];
  allMetalInfo = [];
  keyIssueDetails: any = [];
  analysisComment: string = '';
  actionComment: string = '';
  applyPopSeverityDetails = {};

  //for graph
  popDatList1 = [];
  sampleDataList1 = [];
  unitDataList1 = [];
  paramName1: string = '';

  popDatList2 = [];
  sampleDataList2 = [];
  unitDataList2 = [];
  paramName2: string = '';

  popDatList3 = [];
  sampleDataList3 = [];
  unitDataList3 = [];
  paramName3: string = '';

  popDatList4 = [];
  sampleDataList4 = [];
  unitDataList4 = [];
  paramName4: string = '';

  imageData1: String = '';
  imageData2: String = '';
  imageData3: String = '';
  imageData4: String = '';
  allMetalInfoImg: '';
  oilHealthInfoImg: '';
  allMetalInfoImgLubricant: '';
  oilHealthInfoImgLubricant: '';
  coolant0Img: '';
  coolant1Img: '';
  coolant2Img: '';
  coolant3Img: '';
  coolant4Img: '';
  // lubricant1Img: '';
  // lubricant2Img: '';
  analysisactionImg: '';
  fuel1Img: '';
  fuel2Img: '';
  fuel3Img: '';
  isTwoGraphsInPDF: boolean = false;
  isFourGraphsInPDF: boolean = false;
  previewGraphList: any = [];

  labelAndLegends: boolean = false;
  yAxisLabel1: string = '';
  yAxisLabel2: string = '';
  yAxisLabel3: string = '';
  yAxisLabel4: string = '';

  isGraphDataAvailableFirst: boolean = false;
  isGraphDataAvailableTwo: boolean = false;
  isGraphDataAvailableThree: boolean = false;
  isGraphDataAvailableFour: boolean = false;

  //for pdf

  coolantContaminationForPDF: string = '';
  dustContaminationForPDF: string = '';
  sootContaminationForPDF: string = '';
  degradedOilForPDF: string = '';
  fuelContaminationForPDF: string = '';
  engineWearForPDF: string = '';
  waterContaminationForPDF: string = '';
  systemcorrosionContaminationForPDF: string = '';
  degradedcoolantContaminationForPDF: string = '';
  hardparticleContaminationForPDF: string = '';
  excessiveContaminationForPDF: string = '';
  eletricalConductivityForPDF: string = '';
  sulfurContaminationForPDF = '';
  bacteriaContentForPDF = '';
  traceMetalsForPDF = '';
  degradedFuelForPDF = '';
  fuelCleanlinessForPDF = '';
  fuelCharacteristicsForPDF = '';
  particleContaminationForPDF = '';
  metalWearForPDF = '';
  ccSevForPDF: string = '';
  dcSevForPDF: string = '';
  scSevForPDF: string = '';
  doSevForPDF: string = '';
  fcSevForPDF: string = '';
  ewSevForPDF: string = '';
  wcSevForPDF: string = '';
  pcSevForPDF: string = '';
  mwSevForPDF: string = '';
  hpcSevForPDF: string = '';
  ecSevForPDF: string = '';
  edSevForPDF: string = '';
  sccSevForPDF: string = '';
  dccSevForPDF: string = '';
  sulfurSevForPDF: string = '';
  bcSevForPDF: string = '';
  tmcSevForPDF: string = '';
  dfcSevForPDF: string = '';
  fclSevForPDF: string = '';
  fchSevForPDF: string = '';
  sampleIdForPDF = '';

  yAxisLabelPDF1: string = '';
  yAxisLabelPDF2: string = '';
  yAxisLabelPDF3: string = '';
  yAxisLabelPDF4: string = '';


  paramDesc1: string = '';
  paramDesc2: string = '';
  paramDesc3: string = '';
  paramDesc4: string = '';
  uomLabel: any;
  @Input() displayBackButton: boolean;
  isExpanded: boolean = false;
  fluidType: string = '';
  coolantAnalysisData: any = {};
  coolantHealthSampleRow = [];
  coolantHealthFirstRow = [];
  coolantHealthRemRow = [];
  allCoolantMetalFirstRow = [];
  allCoolantMetalRemRow = [];
  coolantHealth = [];
  allCoolantMetalInfo = [];
  fuelAnalysisData: any = {};
  fuelHealthSampleRow = [];
  fuelHealthFirstRow = [];
  fuelHealthRemRow = [];
  allFuelMetalFirstRow = [];
  allFuelMetalRemRow = [];
  fuelHealth = [];
  allFuelMetalInfo = [];

  reRunParameterList: any[] = [];
  isSetButtonDisabled: boolean = false;
  reasonComment: string = '';
  isSetCommentsClicked: boolean = false;
  thumbnailCount: any = [];
  showGraphComponent: boolean = false;
  sampleandEngineInfoColumns = [
    { code: 'sampleId', name: 'Sample ID' },
    { code: 'companyName', name: 'Company Name' },
    { code: 'unitId', name: 'Unit ID' },
    { code: 'esn', name: 'Component SN' },
    { code: 'sampledDate', name: 'Sampled Date' },
    { code: 'completedDate', name: 'Completed Date' },
    { code: 'unitDistance', name: 'Unit Distance ' },
    { code: 'fluidDistance', name: 'Fluid Distance' }
  ];
  isDisabledSelectThumbnails: boolean = false;
  astmData = {
    flashPointMin: '',
    distillationTempMin: '',
    distillationTempMax: '',
    kinematicViscMin: '',
    kinematicViscMax: '',
    sulfurMax: '',
    cetaneNumberMin: ''
  };
  min;
  max;
  sampleIdURL: any;
  sampleIdFinal: any;
  show_nitrite_TS_val: boolean;
  show_nitrite_val: boolean;
  show_molybdate_TS_val: boolean;
  show_molybdate_val: boolean;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private analyzeSampleInfoServ: AnalyzeSampleInformationService,
    private addressImageService: AddressImageService,
    private alertService: AlertService,
    private viewReportService: ViewReportService,
    private loaderService: LoaderService,
    private sharedService: SharedService) { }

  ngOnInit() {
    this.analyzeSampleInfoServ.getAstmData({}).subscribe(res => {
      this.astmData = res.astmId;
      this.min = this.astmData['distillationTempMin'];
      this.max = this.astmData['distillationTempMax'];
    });
    this.route.params.subscribe(
      (params: Params) => {
        // console.log(params);
        this.sampleIdURL = this.route.snapshot.params['sampleId'];
        // console.log("Sample Id URl", this.sampleIdURL);
        localStorage.setItem('sampleId', localStorage.getItem('emailSampleReport'));
        // console.log("local storage sampleId value:", localStorage.getItem('sampleId'));
        // console.log("local storage emailSampleReport value:", localStorage.getItem('emailSampleReport'));
      });

    this.userRole = this.sharedService.getUserRole();
    if (this.displayBackButton == undefined) {
      this.displayBackButton = false;
    }
    this.getViewReportData();
    this.currentItem = JSON.parse(localStorage.getItem('viewReportData'));
    // console.log(`this.currentItem value: ${JSON.stringify(this.currentItem)}`);
    //console.log(`type of value : ${typeof(this.currentItem.sampleId)}`);
    const sampleIdValue = localStorage.getItem("sampleId");
    // console.log("SampleIdValue :", sampleIdValue);
    if (sampleIdValue != 'undefined' && sampleIdValue != '' && sampleIdValue != null && sampleIdValue != 'null' && this.currentItem != 'null' && this.currentItem != null) {
      // console.log("Entering updated sample ID from routing param");
      this.currentItem.sampleId = sampleIdValue;
    }

    if (this.currentItem.uom == 'MILES') {
      this.uomLabel = '(mi)';
    } else if (this.currentItem.uom == 'KILOMETERS') {
      this.uomLabel = '(km)';
    } else if (this.currentItem.uom == 'HOURS') {
      this.uomLabel = '(hr)';
    }

    this.coolantContaminationForPDF = "Coolant Contamination  ";
    this.dustContaminationForPDF = "Dust Contamination  ";
    this.sootContaminationForPDF = "Soot Contamination  ";
    this.degradedOilForPDF = "Degraded Oil  ";
    this.fuelContaminationForPDF = "Fuel Contamination  ";
    this.engineWearForPDF = "Engine Wear  ";
    this.waterContaminationForPDF = "Water Contamination  ";
    this.systemcorrosionContaminationForPDF = "System Corrosion  ";
    this.degradedcoolantContaminationForPDF = "Degraded Coolant  ";
    this.hardparticleContaminationForPDF = "Hard Particle  ";
    this.excessiveContaminationForPDF = "Excessive Contamination";
    this.eletricalConductivityForPDF = "Electrical Conductivity  ";
    this.bacteriaContentForPDF = "Bacteria Content  ";
    this.traceMetalsForPDF = "Trace Metals  ";
    this.degradedFuelForPDF = "Degraded Fuel  ";
    this.fuelCleanlinessForPDF = "Fuel Cleanliness  ";
    this.fuelCharacteristicsForPDF = "Fuel Characteristics  ";
    this.sulfurContaminationForPDF = "Sulfur Content  ";
    this.particleContaminationForPDF = "Particle Contamination  ";
    this.metalWearForPDF = "Metal Wear  ";

    this.customerAndUnitInfoColumns = [
      { code: 'companyId', name: 'Company ID' },
      { code: 'companyName', name: 'Company Name' },
      { code: 'customerName', name: 'Customer Name' },
      { code: 'phoneNumber', name: 'Phone Number' },
      { code: 'componentId', name: 'Component ID' },
      { code: 'unitMake', name: 'Unit Make' },
      { code: 'unitModel', name: 'Unit Model' },
      { code: 'unitYear', name: 'Unit Year' },
      { code: 'esn', name: 'Equipment Serial No' },
    ];

    this.fluidAndFilterInfoColumns = [
      { code: 'fluidBrand', name: 'Fluid Brand' },
      { code: 'fluidProduct', name: 'Fluid Product' },
      { code: 'fluidGrade', name: 'Fluid Grade' },
      { code: 'filterBrand', name: 'Filter Brand' },
      { code: 'filterProduct', name: 'Filter Product' },
      { code: 'sampledLocation', name: 'Sampled Location' },
      { code: 'trackingNumber', name: 'Tracking Number' },
      { code: 'sampleRemarks', name: 'Sample Remarks' }
    ];

    this.fluidAndFilterInfoColumnsForFuel = [
      { code: 'fluidGrade', name: 'Diesel Fuel' },
      { code: 'filterBrand', name: 'Filter Brand' },
      { code: 'filterProduct', name: 'Filter Product' },
      { code: 'sampledLocation', name: 'Sampled Location' },
      { code: 'geographicLocation', name: 'Geographic Location' },
      { code: 'trackingNumber', name: 'Tracking Number' },
      { code: 'sampleRemarks', name: 'Sample Remarks' }
    ];

    this.sampleInfoColumns = [
      { code: 'sampleId', name: 'Sample ID' },
      { code: 'qrCodeId', name: 'QR Code' },
      { code: 'sampledDate', name: 'Sample Date' },
      { code: 'receivedDate', name: 'Received Date' },
      { code: 'completedDate', name: 'Completed Date' },
      { code: 'engineMake', name: 'Component Make' },
      { code: 'engineModel', name: 'Component Model' },
      { code: 'engineYear', name: 'Component Year' },
      { code: 'gsn', name: 'Component Serial No' },
    ];

    this.isGraphDataAvailableFirst = true;
    this.isGraphDataAvailableTwo = true;
    this.isGraphDataAvailableThree = true;
    this.isGraphDataAvailableFour = true;

    if (this.currentItem != null) {
      // console.log("Entered currentItem not null condition");
      this.getViewReportData();
    }
    //this.plotScatter();

    this.fluidType = localStorage.getItem('fluidType');
  }

  @Output("viewGraph") viewGraph: EventEmitter<any> = new EventEmitter();



  getViewReportData() {
    let self = this;
    if (this.userRole == USERTYPE.EXTERNAL && this.sampleIdURL) {
      this.sampleIdFinal = this.sampleIdURL;
      // console.log("sample Id Final 1", this.sampleIdFinal);
    } else {
      this.sampleIdFinal = this.currentItem.sampleId;
      // console.log("sample Id Final 2", this.sampleIdFinal);
    }

    // console.log("sampleIdURL boolean check");
    // console.log(`sampleIdURL value: ${this.sampleIdURL}`);
    if (this.sampleIdURL) {
      localStorage.setItem('sampleId', this.sampleIdURL);
      this.sampleIdFinal = localStorage.getItem('sampleId');
      this.currentItem.sampleId = this.sampleIdFinal;
    }
    this.sampleIdFinal = this.sampleIdURL;
    // console.log("sample Id Final ", this.sampleIdFinal);
    // console.log("sample Id Url ", this.sampleIdURL);
    let data = {
      sampleId: this.currentItem.sampleId,
      equipmentId: this.currentItem.equipmentId,
      analysisType: this.currentItem.analysisType

    };
    this.viewReportService.getViewReportData(data).subscribe(
      response => {
        if (response.statusCode == "1") {
          if (this.currentItem.analysisType == 'Coolant') {
            this.setDataForCoolant(response, self);
          } else if (this.currentItem.analysisType == 'Diesel Fuel') {
            this.setDataForFuel(response, self);
          } else if (this.currentItem.analysisType == 'Lubricants') {
            this.setDataForLubricant(response, self);
          } else {
            this.setDataForOilAndNaturalGas(response, self);
          }
        } else {
          this.alertService.error(response.statusMessage);
        }
      }, err => {
        this.alertService.error(err);
      }
    );
  }

  AddImagesAllMetalInfo(allMetalInfoImage: any) {
    this.allMetalInfoImg = allMetalInfoImage;
  }
  AddImagesOilHealthInfo(allOilHealthInfoImage: any) {
    this.oilHealthInfoImg = allOilHealthInfoImage;
  }
  AddImagesAllMetalInfoLubricant(allMetalInfoImage: any) {
    this.allMetalInfoImgLubricant = allMetalInfoImage;
  }
  AddImagesOilHealthInfoLubricant(allOilHealthInfoImage: any) {
    this.oilHealthInfoImgLubricant = allOilHealthInfoImage;
  }
  addanalysisactionImg(img: any) {
    this.analysisactionImg = img;
  }
  addCoolant0Img(img: any) {
    this.coolant0Img = img;
  }
  addCoolant1Img(img: any) {
    this.coolant1Img = img;
  }
  addCoolant2Img(img: any) {
    this.coolant2Img = img;
  }
  addCoolant3Img(img: any) {
    this.coolant3Img = img;
  }
  addCoolant4Img(img: any) {
    this.coolant4Img = img;
  }
  // addLubricant1Img(img:any){
  //   this.lubricant1Img = img;
  // }
  // addLubricant2Img(img:any){
  //   this.lubricant2Img = img;
  // }
  addFuel1Img(img: any) {
    this.fuel1Img = img;
  }
  addFuel2Img(img: any) {
    this.fuel2Img = img;
  }
  addFuel3Img(img: any) {
    this.fuel3Img = img;
  }

  //To plot graph

  plotScatter1() {
    this.labelAndLegends = true;
    let self = this;

    var yAxisLabel = '';
    if (this.paramName1 == 'Fe' || this.paramName1 == 'Cu' || this.paramName1 == 'Pb' || this.paramName1 == 'Cr'
      || this.paramName1 == 'Al' || this.paramName1 == 'K' || this.paramName1 == 'Na' || this.paramName1 == 'Ca'
      || this.paramName1 == 'Sn' || this.paramName1 == 'Zn' || this.paramName1 == 'Mg' || this.paramName1 == 'P'
      || this.paramName1 == 'Pb' || this.paramName1 == 'Mo' || this.paramName1 == 'Si' || this.paramName1 == 'Mn'
      || this.paramName1 == 'Ag' || this.paramName1 == 'Ba' || this.paramName1 == 'Bi' || this.paramName1 == 'In'
      || this.paramName1 == 'Ni') {

      this.yAxisLabel1 = this.paramDesc1 + ' ' + '(ppm)';
      yAxisLabel = this.paramDesc1 + ' (' + this.paramName1 + ')';
      this.yAxisLabelPDF1 = this.paramDesc1 + ' ' + '(ppm)' + ' vs Fluid Distance ' + self.uomLabel;

    } else if ((this.paramName1 == 'Soot') || (this.paramName1 == 'Fuel Dilution')) {
      this.yAxisLabel1 = this.paramDesc1 + ' ' + ' (%)';
      yAxisLabel = this.paramName1 + ' ' + ' (%)';
      this.yAxisLabelPDF1 = this.paramDesc1 + ' ' + ' (%)' + ' vs Fluid Distance ' + self.uomLabel;

    } else {

      this.yAxisLabel1 = this.paramName1 + ' ' + ' (abs/cm)';
      yAxisLabel = this.paramName1 + ' ' + ' (abs/cm)';
      this.yAxisLabelPDF1 = this.paramName1 + ' ' + ' (abs/cm)' + ' vs Fluid Distance ' + self.uomLabel;
    }

    var margin = { top: 20, right: 15, bottom: 60, left: 60 }
      , width = 540 - margin.left - margin.right
      , height = 450 - margin.top - margin.bottom;


    if (this.popDatList1.length > 0) {
      var xPopDataList = d3.max((this.popDatList1), function (d) { return d[0]; });

    } else {
      xPopDataList = 0;
    }
    if (this.unitDataList1.length > 0) {
      var xUnitDataList = d3.max((this.unitDataList1), function (d) { return d[0]; });

    } else {
      xUnitDataList = 0;
    }
    if (this.sampleDataList1.length > 0) {
      var xSampleDataList = d3.max((this.sampleDataList1), function (d) { return d[0]; });

    } else {
      xSampleDataList = 0;
    }

    var xMax = Math.max(xPopDataList, xUnitDataList, xSampleDataList);


    if (this.popDatList1.length > 0) {
      var yPopDataList = d3.max((this.popDatList1), function (d) { return d[1]; });

    } else {
      yPopDataList = 0;
    }
    if (this.unitDataList1.length > 0) {
      var yUnitDataList = d3.max((this.unitDataList1), function (d) { return d[1]; });

    } else {
      yUnitDataList = 0;
    }
    if (this.sampleDataList1.length > 0) {
      var ySampleDataList = d3.max((this.sampleDataList1), function (d) { return d[1]; });

    } else {
      ySampleDataList = 0;
    }

    var yMax = Math.max(yPopDataList, yUnitDataList, ySampleDataList);

    //setting up X-axis data
    var x = d3.scaleLinear()
      .domain([0, xMax])
      .range([0, width]);


    //setting up Y-axis data
    var y = d3.scaleLinear()
      .domain([0, yMax])
      .range([height, 0]);

    var svg = d3.select('#scatter1')
      .append('svg')
      .attr('width', width + margin.right + margin.left)
      .attr('height', height + margin.top + margin.bottom);
    // Y-axis label
    svg.append("text")
      .attr("transform", "rotate(-90)")
      .attr("y", 0)
      .attr("x", 0 - (height / 2) - 10)
      .attr("dy", "1em")
      .style("text-anchor", "middle")
      .text(yAxisLabel).style("font-weight", "bold").style("font-size", "12px");

    //X-axis label
    svg.append("text")
      .attr("transform",
        "translate(" + (width / 2) + " ," +
        (height + margin.top + 20) + ")")
      .attr("x", 60)
      .attr("y", 40)
      .style("text-anchor", "middle")
      .text("Fluid Distance " + self.uomLabel).style("font-weight", "bold").style("font-size", "12px");


    var main = svg.append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')
      .attr('width', width)
      .attr('height', height)
      .attr('class', 'main');

    // draw the X-axis
    var xAxis = d3.axisBottom(x).tickSize(-height);

    main.append('g')
      .attr('transform', 'translate(0,' + height + ')')
      .attr('class', 'main axis date').style("stroke-dasharray", "5,5").style("color", "lightgray")
      .call(xAxis).selectAll("text").style("color", "black")
      .attr("transform", function (d) {
        return "rotate(-60)"
      }).attr("x", -22).attr("y", -3);

    // draw the Y-axis
    var yAxis = d3.axisLeft(y).tickSize(-width);
    // var yAxis1 = d3.axisRight(y1);

    main.append('g')
      .attr('transform', 'translate(0,0)')
      .attr('class', 'main axis date').style("stroke-dasharray", "5,5").style("color", "lightgray")
      .call(yAxis).selectAll("text").style("color", "black");

    var g = main.append("g");

    //scatter circle placement in graph
    g.selectAll("scatter-dots")
      .data(this.popDatList1)
      .enter().append("circle")
      .attr("cx", function (d, i) { return x(d[0]); })
      .attr("cy", function (d) { return y(d[1]); })
      .attr("r", 8)
      .style("fill", "#87CEFA");// radius and color of each spot

    g.selectAll("scatter-dots")
      .data(this.unitDataList1)
      .enter().append("circle")
      .attr("cx", function (d, i) { return x(d[0]); })
      .attr("cy", function (d) { return y(d[1]); })
      .attr("r", 8)
      .style("fill", "blue");// radius and color of each spot


    g.selectAll("scatter-dots")
      .data(this.sampleDataList1)
      .enter().append("circle")
      .attr("cx", function (d, i) { return x(d[0]); })
      .attr("cy", function (d) { return y(d[1]); })
      .attr("r", 8)
      .style("fill", "red");// radius and color of each spot
  }

  setDataForCoolant(response, self) {
    this.keyIssueDetails = response.coolantAnalysisData;

    this.ecSevForPDF = response.coolantAnalysisData.ecSeverity;
    this.hpcSevForPDF = response.coolantAnalysisData.hpcSeverity;
    this.dccSevForPDF = response.coolantAnalysisData.dccSeverity;
    this.sccSevForPDF = response.coolantAnalysisData.sccSeverity;
    this.edSevForPDF = response.coolantAnalysisData.e_c_Severity;

    this.showMoreInformationData = response.sampleInfo;
    this.coolantHealth = response.coolantHealthInfoList;
    this.allCoolantMetalInfo = response.coolantAnalyzeSampleAllMetalsList;
    this.analysisComment = response.coolantAnalysisData.analysisComment;
    this.actionComment = response.coolantAnalysisData.actionComment;
    this.setPopSeverityDetails();

    this.coolantHealthFirstRow.push([...this.coolantHealth].shift());
    this.coolantHealthRemRow = ([...this.coolantHealth].splice(1, this.coolantHealth.length));
    this.allCoolantMetalFirstRow.push([...this.allCoolantMetalInfo].shift());
    this.allCoolantMetalFirstRow.forEach(row => {
      if(!(row.nitriteTS.value === ' ')){
        this.show_nitrite_TS_val = true;
      }else if(row.nitriteTS.value == ' '){
        this.show_nitrite_TS_val = false;
        this.show_nitrite_val = true;
      } else{
        this.show_nitrite_TS_val = false;
        this.show_nitrite_val = true;
      }  

      if (!(row.molybdateTS.value === ' ')) {
        this.show_molybdate_TS_val = true;
      } else if (row.molybdateTS.value == ' ') {
        this.show_molybdate_TS_val = false;
        this.show_molybdate_val = true;
      } else {
        this.show_molybdate_TS_val = false;
        this.show_molybdate_val = true;
      }        
    });
    
    this.allCoolantMetalRemRow = ([...this.allCoolantMetalInfo].splice(1, this.allCoolantMetalInfo.length));
    this.allCoolantMetalRemRow.forEach(row => {
      if(!(row.nitriteTS.value === ' ')){
        this.show_nitrite_TS_val = true;
      }else if(row.nitriteTS.value == ' '){
        this.show_nitrite_TS_val = false;
        this.show_nitrite_val = true;
      }else{
        this.show_nitrite_TS_val = false;
        this.show_nitrite_val = true;
      }
    
      if(!(row.molybdateTS.value === ' ')){
        this.show_molybdate_TS_val = true;
      }else if(row.molybdateTS.value == ' '){
        this.show_molybdate_TS_val = false;
        this.show_molybdate_val = true;
      } else{
        this.show_molybdate_TS_val = false;
        this.show_molybdate_val = true;
      }
    });
    
    this.allCoolantMetalFirstRow.push([...this.allCoolantMetalInfo].shift());
    this.allCoolantMetalRemRow = ([...this.allCoolantMetalInfo].splice(1, this.allCoolantMetalInfo.length));

    //merge data into a single object
    if (this.coolantHealthFirstRow.length > 0 && this.allCoolantMetalFirstRow.length > 0) {
      Object.assign(this.coolantHealthFirstRow[0], this.coolantHealthFirstRow[0], this.allCoolantMetalFirstRow[0]);
    }
    if (this.coolantHealthRemRow.length > 0 && this.allCoolantMetalRemRow.length > 0) {
      this.coolantHealthRemRow.forEach(outer => {
        this.allCoolantMetalRemRow.forEach(inner => {
          if (outer.sampleId == inner.sampleId) {
            Object.assign(outer, outer, inner);
          }
        });
      });
    }

    this.popDatList1 = response.graph1PopulationDataList;
    this.sampleDataList1 = response.graph1SampleDataList;
    this.unitDataList1 = response.graph1UnitDataList;
    this.paramDesc1 = response.coolantAnalysisData.graph1ParamDesc;
    this.paramName1 = response.coolantAnalysisData.graph1ParamName;


    this.popDatList2 = response.graph2PopulationDataList;
    this.sampleDataList2 = response.graph2SampleDataList;
    this.unitDataList2 = response.graph2UnitDataList;
    this.paramDesc2 = response.coolantAnalysisData.graph2ParamDesc;
    this.paramName2 = response.coolantAnalysisData.graph2ParamName;

    this.popDatList3 = response.graph3PopulationDataList;
    this.sampleDataList3 = response.graph3SampleDataList;
    this.unitDataList3 = response.graph3UnitDataList;
    this.paramDesc3 = response.coolantAnalysisData.graph3ParamDesc;
    this.paramName3 = response.coolantAnalysisData.graph3ParamName;


    this.popDatList4 = response.graph4PopulationDataList;
    this.sampleDataList4 = response.graph4SampleDataList;
    this.unitDataList4 = response.graph4UnitDataList;
    this.paramDesc4 = response.coolantAnalysisData.graph4ParamDesc;
    this.paramName4 = response.coolantAnalysisData.graph4ParamName;

    if (this.sampleDataList1.length > 0) {
      this.yAxisLabel1 = this.getHeaderLable(this.paramName1, this.paramDesc1);
      this.yAxisLabelPDF1 = this.getHeaderLable(this.paramName1, this.paramDesc1) + ' vs Fluid Distance ' + this.uomLabel;
      self.AddImagesResource1(response.coolantAnalysisData.graph1ImageData);
    }
    else {
      this.isGraphDataAvailableFirst = false;
    }
    if (this.sampleDataList2.length > 0) {
      this.yAxisLabel2 = this.getHeaderLable(this.paramName2, this.paramDesc2);
      this.yAxisLabelPDF2 = this.getHeaderLable(this.paramName2, this.paramDesc2) + ' vs Fluid Distance ' + this.uomLabel;
      self.AddImagesResource2(response.coolantAnalysisData.graph2ImageData);

      this.isFourGraphsInPDF = false;
      this.isTwoGraphsInPDF = true;
    } else {
      this.isGraphDataAvailableTwo = false;
    }
    if (this.sampleDataList3.length > 0) {
      this.yAxisLabel3 = this.getHeaderLable(this.paramName3, this.paramDesc3);
      this.yAxisLabelPDF3 = this.getHeaderLable(this.paramName3, this.paramDesc3) + ' vs Fluid Distance ' + this.uomLabel;
      self.AddImagesResource3(response.coolantAnalysisData.graph3ImageData);

      this.isFourGraphsInPDF = true;
      this.isTwoGraphsInPDF = false;
    } else {
      this.isGraphDataAvailableThree = false;
    }
    if (this.sampleDataList4.length > 0) {
      this.yAxisLabel4 = this.getHeaderLable(this.paramName4, this.paramDesc4);
      this.yAxisLabelPDF4 = this.getHeaderLable(this.paramName4, this.paramDesc4) + ' vs Fluid Distance ' + this.uomLabel;
      self.AddImagesResource4(response.coolantAnalysisData.graph4ImageData);

      this.isFourGraphsInPDF = true;
      this.isTwoGraphsInPDF = false;

    } else {
      this.isGraphDataAvailableFour = false;
    }
  }

  setDataForFuel(response, self) {
    this.analyzeSampleInfoServ.getAstmData({}).subscribe(res => {
      this.astmData = res.astmId;
    });

    this.keyIssueDetails = response.fuelAnalysisData;

    this.sulfurSevForPDF = response.fuelAnalysisData.scSeverity;
    this.bcSevForPDF = response.fuelAnalysisData.bcSeverity;
    this.tmcSevForPDF = response.fuelAnalysisData.tmcSeverity;
    this.dfcSevForPDF = response.fuelAnalysisData.dfcSeverity;
    this.fclSevForPDF = response.fuelAnalysisData.fclSeverity;
    this.fchSevForPDF = response.fuelAnalysisData.fchSeverity;

    this.showMoreInformationData = response.sampleInfo;
    this.fuelHealth = response.fuelHealthInfoList;
    this.allFuelMetalInfo = response.fuelAnalyzeSampleAllMetalsList;
    this.analysisComment = response.fuelAnalysisData.analysisComment;
    this.actionComment = response.fuelAnalysisData.actionComment;
    this.setFuelPopSeverityDetails();

    this.fuelHealthFirstRow.push([...this.fuelHealth].shift());
    this.fuelHealthRemRow = ([...this.fuelHealth].splice(1, this.fuelHealth.length));
    this.allFuelMetalFirstRow.push([...this.allFuelMetalInfo].shift());
    this.allFuelMetalRemRow = ([...this.allFuelMetalInfo].splice(1, this.allFuelMetalInfo.length));

    //merge data into a single object
    if (this.fuelHealthFirstRow.length > 0 && this.allFuelMetalFirstRow.length > 0) {
      Object.assign(this.fuelHealthFirstRow[0], this.fuelHealthFirstRow[0], this.allFuelMetalFirstRow[0]);
    }
    if (this.fuelHealthRemRow.length > 0 && this.allFuelMetalRemRow.length > 0) {
      this.fuelHealthRemRow.forEach(outer => {
        this.allFuelMetalRemRow.forEach(inner => {
          if (outer.sampleId == inner.sampleId) {
            Object.assign(outer, outer, inner);
          }
        });
      });
    }
    this.child.generateGraph(this.fuelHealthFirstRow[0], this.fuelHealthRemRow, this.max, this.min);
  }

  setPopSeverityDetails() {
    this.applyPopSeverityDetails = {};
    this.applyPopSeverityDetails['glycolSeverity'] = this.coolantHealth[0].glycol.severity;
    this.applyPopSeverityDetails['phSeverity'] = this.coolantHealth[0].ph.severity;
    this.applyPopSeverityDetails['glycolateSeverity'] = this.coolantHealth[0].glycolate.severity;
    this.applyPopSeverityDetails['formateSeverity'] = this.coolantHealth[0].formate.severity;
    this.applyPopSeverityDetails['oxalateSeverity'] = this.coolantHealth[0].oxalate.severity;
    this.applyPopSeverityDetails['scaSeverity'] = this.coolantHealth[0].sca.severity;
    this.applyPopSeverityDetails['znSeverity'] = this.allCoolantMetalInfo[0].zn.severity;
    this.applyPopSeverityDetails['feSeverity'] = this.allCoolantMetalInfo[0].fe.severity;
    this.applyPopSeverityDetails['alSeverity'] = this.allCoolantMetalInfo[0].al.severity;
    this.applyPopSeverityDetails['pbSeverity'] = this.allCoolantMetalInfo[0].pb.severity;
    this.applyPopSeverityDetails['crSeverity'] = this.allCoolantMetalInfo[0].cr.severity;
    this.applyPopSeverityDetails['cuSeverity'] = this.allCoolantMetalInfo[0].cu.severity;
    this.applyPopSeverityDetails['chlorideSeverity'] = this.allCoolantMetalInfo[0].chloride.severity;
    this.applyPopSeverityDetails['fluorideSeverity'] = this.allCoolantMetalInfo[0].fluoride.severity;
    this.applyPopSeverityDetails['bromideSeverity'] = this.allCoolantMetalInfo[0].bromide.severity;
    this.applyPopSeverityDetails['sulfateSeverity'] = this.allCoolantMetalInfo[0].sulfate.severity;
    this.applyPopSeverityDetails['sulfurSeverity'] = this.allCoolantMetalInfo[0].sulfur.severity;
    this.applyPopSeverityDetails['mgSeverity'] = this.allCoolantMetalInfo[0].mg.severity;
    this.applyPopSeverityDetails['caSeverity'] = this.allCoolantMetalInfo[0].ca.severity;
    this.applyPopSeverityDetails['btSeverity'] = this.allCoolantMetalInfo[0].bt.severity;
    this.applyPopSeverityDetails['ttSeverity'] = this.allCoolantMetalInfo[0].tt.severity;
    this.applyPopSeverityDetails['mbtSeverity'] = this.allCoolantMetalInfo[0].mbt.severity;
    this.applyPopSeverityDetails['eHa2Severity'] = this.allCoolantMetalInfo[0].eHa2.severity;
    this.applyPopSeverityDetails['baSeverity'] = this.allCoolantMetalInfo[0].ba.severity;
    this.applyPopSeverityDetails['tBa4Severity'] = this.allCoolantMetalInfo[0].tBa4.severity;
    this.applyPopSeverityDetails['aaSeverity'] = this.allCoolantMetalInfo[0].aa.severity;
    this.applyPopSeverityDetails['saSeverity'] = this.allCoolantMetalInfo[0].sa.severity;
    this.applyPopSeverityDetails['ddaSeverity'] = this.allCoolantMetalInfo[0].dda.severity;
    this.applyPopSeverityDetails['pTaSeverity'] = this.allCoolantMetalInfo[0].pTa.severity;
    this.applyPopSeverityDetails['nitrateSeverity'] = this.allCoolantMetalInfo[0].nitrate.severity;
    this.applyPopSeverityDetails['nitriteSeverity'] = this.allCoolantMetalInfo[0].nitrite.severity;
    this.applyPopSeverityDetails['nitriteTSSeverity'] = this.allCoolantMetalInfo[0].nitriteTS.severity;
    this.applyPopSeverityDetails['molybdateSeverity'] = this.allCoolantMetalInfo[0].molybdate.severity;
    this.applyPopSeverityDetails['molybdateTSSeverity'] = this.allCoolantMetalInfo[0].molybdateTS.severity;
    this.applyPopSeverityDetails['moSeverity'] = this.allCoolantMetalInfo[0].mo.severity;
    this.applyPopSeverityDetails['siSeverity'] = this.allCoolantMetalInfo[0].si.severity;
    this.applyPopSeverityDetails['phosphateSeverity'] = this.allCoolantMetalInfo[0].phosphate.severity;
    this.applyPopSeverityDetails['pSeverity'] = this.allCoolantMetalInfo[0].p.severity;
    this.applyPopSeverityDetails['bSeverity'] = this.allCoolantMetalInfo[0].b.severity;
  }

  setFuelPopSeverityDetails() {
    this.applyPopSeverityDetails = {};
    this.applyPopSeverityDetails['spGravitySeverity'] = this.allFuelMetalInfo[0].spGravity?.severity;
    this.applyPopSeverityDetails['bioDieselSeverity'] = this.allFuelMetalInfo[0].bioDiesel?.severity;
    this.applyPopSeverityDetails['waterContentSeverity'] = this.allFuelMetalInfo[0].waterContent?.severity;
    this.applyPopSeverityDetails['vis40Severity'] = this.allFuelMetalInfo[0].vis40?.severity;
    this.applyPopSeverityDetails['feSeverity'] = this.allFuelMetalInfo[0].fe?.severity;
    this.applyPopSeverityDetails['snSeverity'] = this.allFuelMetalInfo[0].sn?.severity;
    this.applyPopSeverityDetails['pbSeverity'] = this.allFuelMetalInfo[0].pb?.severity;
    this.applyPopSeverityDetails['indSeverity'] = this.allFuelMetalInfo[0].ind?.severity;
    this.applyPopSeverityDetails['cuSeverity'] = this.allFuelMetalInfo[0].cu?.severity;
    this.applyPopSeverityDetails['crSeverity'] = this.allFuelMetalInfo[0].cr?.severity;
    this.applyPopSeverityDetails['alSeverity'] = this.allFuelMetalInfo[0].al?.severity;
    this.applyPopSeverityDetails['moSeverity'] = this.allFuelMetalInfo[0].mo?.severity;
    this.applyPopSeverityDetails['siSeverity'] = this.allFuelMetalInfo[0].si?.severity;
    this.applyPopSeverityDetails['naSeverity'] = this.allFuelMetalInfo[0].na?.severity;
    this.applyPopSeverityDetails['kSeverity'] = this.allFuelMetalInfo[0].k?.severity;
    this.applyPopSeverityDetails['caSeverity'] = this.allFuelMetalInfo[0].ca?.severity;
    this.applyPopSeverityDetails['baSeverity'] = this.allFuelMetalInfo[0].ba?.severity;
    this.applyPopSeverityDetails['mgSeverity'] = this.allFuelMetalInfo[0].mg?.severity;
    this.applyPopSeverityDetails['znSeverity'] = this.allFuelMetalInfo[0].zn?.severity;
    this.applyPopSeverityDetails['pSeverity'] = this.allFuelMetalInfo[0].p?.severity;
    this.applyPopSeverityDetails['bSeverity'] = this.allFuelMetalInfo[0].b?.severity;
    this.applyPopSeverityDetails['mnSeverity'] = this.allFuelMetalInfo[0].mn?.severity;
    this.applyPopSeverityDetails['biSeverity'] = this.allFuelMetalInfo[0].bi?.severity;
    this.applyPopSeverityDetails['niSeverity'] = this.allFuelMetalInfo[0].ni?.severity;
    this.applyPopSeverityDetails['agSeverity'] = this.allFuelMetalInfo[0].ag?.severity;
    this.applyPopSeverityDetails['flashPointSeverity'] = this.allFuelMetalInfo[0].flashPoint?.severity;
    this.applyPopSeverityDetails['cloudPointSeverity'] = this.allFuelMetalInfo[0]?.cloudPoint?.severity;
    this.applyPopSeverityDetails['atpSeverity'] = this.allFuelMetalInfo[0].atp?.severity;
    this.applyPopSeverityDetails['filterBlockingSeverity'] = this.allFuelMetalInfo[0].filterBlocking?.severity;
    this.applyPopSeverityDetails['particleCountSeverity'] = this.allFuelMetalInfo[0].particleCount?.severity;
    this.applyPopSeverityDetails['sulfurSeverity'] = this.allFuelMetalInfo[0].sulfur?.severity;
    this.applyPopSeverityDetails['cetaneIndexSeverity'] = this.allFuelMetalInfo[0].cetaneIndex?.severity;
    this.applyPopSeverityDetails['percent10Severity'] = this.allFuelMetalInfo[0].percent10?.severity;
    this.applyPopSeverityDetails['percent20Severity'] = this.allFuelMetalInfo[0].percent20?.severity;
    this.applyPopSeverityDetails['percent30Severity'] = this.allFuelMetalInfo[0].percent30?.severity;
    this.applyPopSeverityDetails['percent50Severity'] = this.allFuelMetalInfo[0].percent50?.severity;
    this.applyPopSeverityDetails['percent70Severity'] = this.allFuelMetalInfo[0].percent70?.severity;
    this.applyPopSeverityDetails['percent80Severity'] = this.allFuelMetalInfo[0].percent80?.severity;
    this.applyPopSeverityDetails['percent90Severity'] = this.allFuelMetalInfo[0].percent90?.severity;
    this.applyPopSeverityDetails['ibpSeverity'] = this.allFuelMetalInfo[0].ibp?.severity;
    this.applyPopSeverityDetails['fbpSeverity'] = this.allFuelMetalInfo[0].fbp?.severity;
    // this.applyPopSeverityDetails['thermalStabilitySeverity'] = this.allFuelMetalInfo[0].thermalStability?.severity;
    this.applyPopSeverityDetails['vSeverity'] = this.allFuelMetalInfo[0].v?.severity;
    this.applyPopSeverityDetails['waterSedimentSeverity'] = this.allFuelMetalInfo[0].waterSediment?.severity;
    this.applyPopSeverityDetails['tanSeverity'] = this.allFuelMetalInfo[0].tan?.severity;
    this.applyPopSeverityDetails['oxidationStabilitySeverity'] = this.allFuelMetalInfo[0].oxidationStability?.severity;
  }


  setDataForOilAndNaturalGas(response, self) {
    this.keyIssueDetails = response.analysisData;
    this.ccSevForPDF = response.analysisData.ccSeverity;
    this.dcSevForPDF = response.analysisData.dcSeverity;
    this.scSevForPDF = response.analysisData.scSeverity;
    this.doSevForPDF = response.analysisData.doSeverity;
    this.fcSevForPDF = response.analysisData.fcSeverity;
    this.ewSevForPDF = response.analysisData.ewSeverity;
    this.wcSevForPDF = response.analysisData.wcSeverity;

    this.showMoreInformationData = response.sampleInfo;
    this.oilHealth = response.oilHealthInfoList;
    this.allMetalInfo = response.allMetalInfoList;
    this.analysisComment = response.analysisData.analysisComment;
    this.actionComment = response.analysisData.actionComment;

    this.popDatList1 = response.graph1PopulationDataList;
    this.sampleDataList1 = response.graph1SampleDataList;
    this.unitDataList1 = response.graph1UnitDataList;
    this.paramDesc1 = response.analysisData.graph1ParamDesc;
    this.paramName1 = response.analysisData.graph1ParamName;


    this.popDatList2 = response.graph2PopulationDataList;
    this.sampleDataList2 = response.graph2SampleDataList;
    this.unitDataList2 = response.graph2UnitDataList;
    this.paramDesc2 = response.analysisData.graph2ParamDesc;
    this.paramName2 = response.analysisData.graph2ParamName;

    this.popDatList3 = response.graph3PopulationDataList;
    this.sampleDataList3 = response.graph3SampleDataList;
    this.unitDataList3 = response.graph3UnitDataList;
    this.paramDesc3 = response.analysisData.graph3ParamDesc;
    this.paramName3 = response.analysisData.graph3ParamName;


    this.popDatList4 = response.graph4PopulationDataList;
    this.sampleDataList4 = response.graph4SampleDataList;
    this.unitDataList4 = response.graph4UnitDataList;
    this.paramDesc4 = response.analysisData.graph4ParamDesc;
    this.paramName4 = response.analysisData.graph4ParamName;

    if (this.popDatList1.length > 0) {

      // this.plotScatter1();
      this.yAxisLabel1 = this.getHeaderLable(this.paramName1, this.paramDesc1);
      this.yAxisLabelPDF1 = this.getHeaderLable(this.paramName1, this.paramDesc1) + ' vs Fluid Distance ' + this.uomLabel;
      self.AddImagesResource1(response.analysisData.graph1ImageData);



    }
    else {
      this.isGraphDataAvailableFirst = false;
    }
    if (this.popDatList2.length > 0) {

      // this.plotScatter2();

      this.yAxisLabel2 = this.getHeaderLable(this.paramName2, this.paramDesc2);
      this.yAxisLabelPDF2 = this.getHeaderLable(this.paramName2, this.paramDesc2) + ' vs Fluid Distance ' + this.uomLabel;
      self.AddImagesResource2(response.analysisData.graph2ImageData);


      this.isFourGraphsInPDF = false;
      this.isTwoGraphsInPDF = true;
    } else {
      this.isGraphDataAvailableTwo = false;
    }
    if (this.popDatList3.length > 0) {

      //            this.plotScatter3();

      this.yAxisLabel3 = this.getHeaderLable(this.paramName3, this.paramDesc3);
      this.yAxisLabelPDF3 = this.getHeaderLable(this.paramName3, this.paramDesc3) + ' vs Fluid Distance ' + this.uomLabel;
      self.AddImagesResource3(response.analysisData.graph3ImageData);


    } else {
      this.isGraphDataAvailableThree = false;
    }
    if (this.popDatList4.length > 0) {

      this.yAxisLabel4 = this.getHeaderLable(this.paramName4, this.paramDesc4);
      this.yAxisLabelPDF4 = this.getHeaderLable(this.paramName4, this.paramDesc4) + ' vs Fluid Distance ' + this.uomLabel;
      self.AddImagesResource4(response.analysisData.graph4ImageData);

      this.isFourGraphsInPDF = true;
      this.isTwoGraphsInPDF = false;

    } else {
      this.isGraphDataAvailableFour = false;
    }
  }

  setDataForLubricant(response, self) {
    // console.log(response);
    this.keyIssueDetails = response.lubricantAnalysisData;
    this.ccSevForPDF = response.lubricantAnalysisData.ccSeverity;
    this.doSevForPDF = response.lubricantAnalysisData.doSeverity;
    this.wcSevForPDF = response.lubricantAnalysisData.wcSeverity;
    this.pcSevForPDF = response.lubricantAnalysisData.pcSeverity;
    this.mwSevForPDF = response.lubricantAnalysisData.mwSeverity;

    this.showMoreInformationData = response.sampleInfo;
    this.oilHealth = response.lubricantHealthInfoList;
    this.allMetalInfo = response.lubricantAnalyzeSampleAllMetalsList;
    this.analysisComment = response.lubricantAnalysisData.analysisComment;
    this.actionComment = response.lubricantAnalysisData.actionComment;

    this.popDatList1 = response.graph1PopulationDataList;
    this.sampleDataList1 = response.graph1SampleDataList;
    this.unitDataList1 = response.graph1UnitDataList;
    this.paramDesc1 = response.lubricantAnalysisData.graph1ParamDesc;
    this.paramName1 = response.lubricantAnalysisData.graph1ParamName;


    this.popDatList2 = response.graph2PopulationDataList;
    this.sampleDataList2 = response.graph2SampleDataList;
    this.unitDataList2 = response.graph2UnitDataList;
    this.paramDesc2 = response.lubricantAnalysisData.graph2ParamDesc;
    this.paramName2 = response.lubricantAnalysisData.graph2ParamName;

    this.popDatList3 = response.graph3PopulationDataList;
    this.sampleDataList3 = response.graph3SampleDataList;
    this.unitDataList3 = response.graph3UnitDataList;
    this.paramDesc3 = response.lubricantAnalysisData.graph3ParamDesc;
    this.paramName3 = response.lubricantAnalysisData.graph3ParamName;


    this.popDatList4 = response.graph4PopulationDataList;
    this.sampleDataList4 = response.graph4SampleDataList;
    this.unitDataList4 = response.graph4UnitDataList;
    this.paramDesc4 = response.lubricantAnalysisData.graph4ParamDesc;
    this.paramName4 = response.lubricantAnalysisData.graph4ParamName;

    if (this.sampleDataList1.length > 0) {
      this.yAxisLabel1 = this.getHeaderLable(this.paramName1, this.paramDesc1);
      this.yAxisLabelPDF1 = this.getHeaderLable(this.paramName1, this.paramDesc1) + ' vs Fluid Distance ' + this.uomLabel;
      self.AddImagesResource1(response.lubricantAnalysisData.graph1ImageData);
    }
    else {
      this.isGraphDataAvailableFirst = false;
    }
    if (this.sampleDataList2.length > 0) {
      this.yAxisLabel2 = this.getHeaderLable(this.paramName2, this.paramDesc2);
      this.yAxisLabelPDF2 = this.getHeaderLable(this.paramName2, this.paramDesc2) + ' vs Fluid Distance ' + this.uomLabel;
      self.AddImagesResource2(response.lubricantAnalysisData.graph2ImageData);

      this.isFourGraphsInPDF = false;
      this.isTwoGraphsInPDF = true;
    } else {
      this.isGraphDataAvailableTwo = false;
    }
    if (this.sampleDataList3.length > 0) {
      this.yAxisLabel3 = this.getHeaderLable(this.paramName3, this.paramDesc3);
      this.yAxisLabelPDF3 = this.getHeaderLable(this.paramName3, this.paramDesc3) + ' vs Fluid Distance ' + this.uomLabel;
      self.AddImagesResource3(response.lubricantAnalysisData.graph3ImageData);

      this.isFourGraphsInPDF = true;
      this.isTwoGraphsInPDF = false;
    } else {
      this.isGraphDataAvailableThree = false;
    }
    if (this.sampleDataList4.length > 0) {
      this.yAxisLabel4 = this.getHeaderLable(this.paramName4, this.paramDesc4);
      this.yAxisLabelPDF4 = this.getHeaderLable(this.paramName4, this.paramDesc4) + ' vs Fluid Distance ' + this.uomLabel;
      self.AddImagesResource4(response.lubricantAnalysisData.graph4ImageData);

      this.isFourGraphsInPDF = true;
      this.isTwoGraphsInPDF = false;

    } else {
      this.isGraphDataAvailableFour = false;
    }
  }

  AddImagesResource1(graphImgData: any) {
    this.imageData1 = graphImgData;
  }

  plotScatter2() {

    this.labelAndLegends = true;
    let self = this;

    var yAxisLabel = '';
    if (this.paramName2 == 'Fe' || this.paramName2 == 'Cu' || this.paramName2 == 'Pb' || this.paramName2 == 'Cr'
      || this.paramName2 == 'Al' || this.paramName2 == 'K' || this.paramName2 == 'Na' || this.paramName2 == 'Ca'
      || this.paramName2 == 'Sn' || this.paramName2 == 'Zn' || this.paramName2 == 'Mg' || this.paramName2 == 'P'
      || this.paramName2 == 'Pb' || this.paramName2 == 'Mo' || this.paramName2 == 'Si' || this.paramName2 == 'Mn'
      || this.paramName2 == 'Ag' || this.paramName2 == 'Ba' || this.paramName2 == 'Bi' || this.paramName2 == 'In'
      || this.paramName2 == 'Ni') {
      //this.yAxisLabel = this.paramDescripton + ' (' + this.parameterName + ')';
      this.yAxisLabel2 = this.paramDesc2 + ' ' + '(ppm)';
      yAxisLabel = this.paramDesc2 + ' (' + this.paramName2 + ')';

      this.yAxisLabelPDF2 = this.paramDesc2 + ' ' + '(ppm)' + ' vs Fluid Distance ' + self.uomLabel;

    } else if ((this.paramName2 == 'Soot') || (this.paramName2 == 'Fuel Dilution')) {
      this.yAxisLabel2 = this.paramDesc2 + ' ' + ' (%)';
      yAxisLabel = this.paramName2 + ' ' + ' (%)';
      this.yAxisLabelPDF2 = this.paramDesc2 + ' ' + ' (%)' + ' vs Fluid Distance ' + self.uomLabel;

    } else {
      //this.yAxisLabel = this.paramDescripton;
      this.yAxisLabel2 = this.paramName2 + ' ' + ' (abs/cm)';
      yAxisLabel = this.paramName2 + ' ' + ' (abs/cm)';
      this.yAxisLabelPDF2 = this.paramDesc2 + ' ' + ' (abs/cm)' + ' vs Fluid Distance ' + self.uomLabel;

    }
    //this.yAxisLabel2 = this.paramName2 + ' ' + '(Abs/cm)';

    var margin = { top: 20, right: 15, bottom: 60, left: 60 }
      , width = 550 - margin.left - margin.right
      , height = 450 - margin.top - margin.bottom;


    if (this.popDatList2.length > 0) {
      var xPopDataList = d3.max((this.popDatList2), function (d) { return d[0]; });

    } else {
      xPopDataList = 0;
    }
    if (this.unitDataList2.length > 0) {
      var xUnitDataList = d3.max((this.unitDataList2), function (d) { return d[0]; });

    } else {
      xUnitDataList = 0;
    }
    if (this.sampleDataList2.length > 0) {
      var xSampleDataList = d3.max((this.sampleDataList2), function (d) { return d[0]; });

    } else {
      xSampleDataList = 0;
    }

    var xMax = Math.max(xPopDataList, xUnitDataList, xSampleDataList);


    if (this.popDatList2.length > 0) {
      var yPopDataList = d3.max((this.popDatList2), function (d) { return d[1]; });

    } else {
      yPopDataList = 0;
    }
    if (this.unitDataList2.length > 0) {
      var yUnitDataList = d3.max((this.unitDataList2), function (d) { return d[1]; });

    } else {
      yUnitDataList = 0;
    }
    if (this.sampleDataList2.length > 0) {
      var ySampleDataList = d3.max((this.sampleDataList2), function (d) { return d[1]; });

    } else {
      ySampleDataList = 0;
    }

    var yMax = Math.max(yPopDataList, yUnitDataList, ySampleDataList);

    //setting up X-axis data
    var x = d3.scaleLinear()
      .domain([0, xMax])
      .range([0, width]);


    //setting up Y-axis data
    var y = d3.scaleLinear()
      .domain([0, yMax])
      .range([height, 0]);

    var svg = d3.select('#scatter2')
      .append('svg')
      .attr('width', width + margin.right + margin.left)
      .attr('height', height + margin.top + margin.bottom);
    // Y-axis label
    svg.append("text")
      .attr("transform", "rotate(-90)")
      .attr("y", 0)
      .attr("x", 0 - (height / 2) - 10)
      .attr("dy", "1em")
      .style("text-anchor", "middle")
      .text(yAxisLabel).style("font-weight", "bold").style("font-size", "12px");

    //X-axis label
    svg.append("text")
      .attr("transform",
        "translate(" + (width / 2) + " ," +
        (height + margin.top + 20) + ")")
      .attr("x", 60)
      .attr("y", 40)
      .style("text-anchor", "middle")
      .text("Fluid Distance " + self.uomLabel).style("font-weight", "bold").style("font-size", "12px");


    var main = svg.append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')
      .attr('width', width)
      .attr('height', height)
      .attr('class', 'main');

    // draw the X-axis
    var xAxis = d3.axisBottom(x).tickSize(-height);

    main.append('g')
      .attr('transform', 'translate(0,' + height + ')')
      .attr('class', 'main axis date').style("stroke-dasharray", "5,5").style("color", "lightgray")
      .call(xAxis).selectAll("text").style("color", "black")
      .attr("transform", function (d) {
        return "rotate(-60)"
      }).attr("x", -22).attr("y", -3);

    // draw the Y-axis
    var yAxis = d3.axisLeft(y).tickSize(-width);
    yAxis.ticks(12);

    main.append('g')
      .attr('transform', 'translate(0,0)')
      .attr('class', 'main axis date').style("stroke-dasharray", "5,5").style("color", "lightgray")
      .call(yAxis).selectAll("text").style("color", "black");

    var g = main.append("g");

    //scatter circle placement in graph
    g.selectAll("scatter-dots")
      .data(this.popDatList2)
      .enter().append("circle")
      .attr("cx", function (d, i) { return x(d[0]); })
      .attr("cy", function (d) { return y(d[1]); })
      .attr("r", 8)
      .style("fill", "#87CEFA");// radius and color of each spot

    g.selectAll("scatter-dots")
      .data(this.unitDataList2)
      .enter().append("circle")
      .attr("cx", function (d, i) { return x(d[0]); })
      .attr("cy", function (d) { return y(d[1]); })
      .attr("r", 8)
      .style("fill", "blue");// radius and color of each spot


    g.selectAll("scatter-dots")
      .data(this.sampleDataList2)
      .enter().append("circle")
      .attr("cx", function (d, i) { return x(d[0]); })
      .attr("cy", function (d) { return y(d[1]); })
      .attr("r", 8)
      .style("fill", "red");// radius and color of each spot  
  }

  AddImagesResource2(graphImageData: any) {
    this.imageData2 = graphImageData;
  }

  plotScatter3() {

    this.labelAndLegends = true;
    let self = this;

    var yAxisLabel = '';
    if (this.paramName3 == 'Fe' || this.paramName3 == 'Cu' || this.paramName3 == 'Pb' || this.paramName3 == 'Cr'
      || this.paramName3 == 'Al' || this.paramName3 == 'K' || this.paramName3 == 'Na' || this.paramName3 == 'Ca'
      || this.paramName3 == 'Sn' || this.paramName3 == 'Zn' || this.paramName3 == 'Mg' || this.paramName3 == 'P'
      || this.paramName3 == 'Pb' || this.paramName3 == 'Mo' || this.paramName3 == 'Si' || this.paramName3 == 'Mn'
      || this.paramName3 == 'Ag' || this.paramName3 == 'Ba' || this.paramName3 == 'Bi' || this.paramName3 == 'In'
      || this.paramName3 == 'Ni') {
      //this.yAxisLabel = this.paramDescripton + ' (' + this.parameterName + ')';
      this.yAxisLabel3 = this.paramDesc3 + ' ' + '(ppm)';
      yAxisLabel = this.paramDesc3 + ' (' + this.paramName3 + ')';
      this.yAxisLabelPDF3 = this.paramDesc3 + ' ' + ' (ppm)' + ' vs Fluid Distance ' + self.uomLabel;

    } else if ((this.paramName3 == 'Soot') || (this.paramName3 == 'Fuel Dilution')) {
      this.yAxisLabel3 = this.paramDesc3 + ' ' + ' (%)';
      yAxisLabel = this.paramName3 + ' ' + ' (%)';
      this.yAxisLabelPDF3 = this.paramDesc3 + ' ' + ' (%)' + ' vs Fluid Distance ' + self.uomLabel;

    } else {
      //this.yAxisLabel = this.paramDescripton;
      this.yAxisLabel3 = this.paramName3 + ' ' + ' (abs/cm)';
      yAxisLabel = this.paramName3 + ' ' + ' (abs/cm)';
      this.yAxisLabelPDF3 = this.paramDesc3 + ' ' + ' (abs/cm)' + 'vs Fluid Distance ' + self.uomLabel;

    }
    // this.yAxisLabel3 = this.paramName3 + ' ' + '(Abs/cm)';

    var margin = { top: 20, right: 15, bottom: 60, left: 60 }
      , width = 540 - margin.left - margin.right
      , height = 450 - margin.top - margin.bottom;


    if (this.popDatList3.length > 0) {
      var xPopDataList = d3.max((this.popDatList3), function (d) { return d[0]; });

    } else {
      xPopDataList = 0;
    }
    if (this.unitDataList3.length > 0) {
      var xUnitDataList = d3.max((this.unitDataList3), function (d) { return d[0]; });

    } else {
      xUnitDataList = 0;
    }
    if (this.sampleDataList3.length > 0) {
      var xSampleDataList = d3.max((this.sampleDataList3), function (d) { return d[0]; });

    } else {
      xSampleDataList = 0;
    }

    var xMax = Math.max(xPopDataList, xUnitDataList, xSampleDataList);


    if (this.popDatList3.length > 0) {
      var yPopDataList = d3.max((this.popDatList3), function (d) { return d[1]; });

    } else {
      yPopDataList = 0;
    }
    if (this.unitDataList3.length > 0) {
      var yUnitDataList = d3.max((this.unitDataList3), function (d) { return d[1]; });

    } else {
      yUnitDataList = 0;
    }
    if (this.sampleDataList3.length > 0) {
      var ySampleDataList = d3.max((this.sampleDataList3), function (d) { return d[1]; });

    } else {
      ySampleDataList = 0;
    }

    var yMax = Math.max(yPopDataList, yUnitDataList, ySampleDataList);


    //setting up X-axis data
    var x = d3.scaleLinear()
      .domain([0, xMax])
      .range([0, width]);


    //setting up Y-axis data
    var y = d3.scaleLinear()
      .domain([0, yMax])
      .range([height, 0]);

    var svg = d3.select('#scatter3')
      .append('svg')
      .attr('width', width + margin.right + margin.left)
      .attr('height', height + margin.top + margin.bottom);
    // Y-axis label
    svg.append("text")
      .attr("transform", "rotate(-90)")
      .attr("y", 0)
      .attr("x", 0 - (height / 2) - 10)
      .attr("dy", "1em")
      .style("text-anchor", "middle")
      .text(yAxisLabel).style("font-weight", "bold").style("font-size", "12px");

    //X-axis label
    svg.append("text")
      .attr("transform",
        "translate(" + (width / 2) + " ," +
        (height + margin.top + 20) + ")")
      .attr("x", 60)
      .attr("y", 40)
      .style("text-anchor", "middle")
      .text("Fluid Distance " + self.uomLabel).style("font-weight", "bold").style("font-size", "12px");


    var main = svg.append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')
      .attr('width', width)
      .attr('height', height)
      .attr('class', 'main');

    // draw the X-axis
    var xAxis = d3.axisBottom(x).tickSize(-height);

    main.append('g')
      .attr('transform', 'translate(0,' + height + ')')
      .attr('class', 'main axis date').style("stroke-dasharray", "5,5").style("color", "lightgray")
      .call(xAxis).selectAll("text").style("color", "black")
      .attr("transform", function (d) {
        return "rotate(-60)"
      }).attr("x", -22).attr("y", -3);

    // draw the Y-axis
    var yAxis = d3.axisLeft(y).tickSize(-width);
    // var yAxis1 = d3.axisRight(y1);

    main.append('g')
      .attr('transform', 'translate(0,0)')
      .attr('class', 'main axis date').style("stroke-dasharray", "5,5").style("color", "lightgray")
      .call(yAxis).selectAll("text").style("color", "black");

    var g = main.append("g");

    //scatter circle placement in graph
    g.selectAll("scatter-dots")
      .data(this.popDatList3)
      .enter().append("circle")
      .attr("cx", function (d, i) { return x(d[0]); })
      .attr("cy", function (d) { return y(d[1]); })
      .attr("r", 8)
      .style("fill", "#87CEFA");// radius and color of each spot

    g.selectAll("scatter-dots")
      .data(this.unitDataList3)
      .enter().append("circle")
      .attr("cx", function (d, i) { return x(d[0]); })
      .attr("cy", function (d) { return y(d[1]); })
      .attr("r", 8)
      .style("fill", "blue");// radius and color of each spot


    g.selectAll("scatter-dots")
      .data(this.sampleDataList3)
      .enter().append("circle")
      .attr("cx", function (d, i) { return x(d[0]); })
      .attr("cy", function (d) { return y(d[1]); })
      .attr("r", 8)
      .style("fill", "red");// radius and color of each spot
  }

  AddImagesResource3(graphImageData: any) {
    this.imageData3 = graphImageData;
  }

  plotScatter4() {
    this.labelAndLegends = true;
    let self = this;

    var yAxisLabel = '';
    if (this.paramName4 == 'Fe' || this.paramName4 == 'Cu' || this.paramName4 == 'Pb' || this.paramName4 == 'Cr'
      || this.paramName4 == 'Al' || this.paramName4 == 'K' || this.paramName4 == 'Na' || this.paramName4 == 'Ca'
      || this.paramName4 == 'Sn' || this.paramName4 == 'Zn' || this.paramName4 == 'Mg' || this.paramName4 == 'P'
      || this.paramName4 == 'Pb' || this.paramName4 == 'Mo' || this.paramName4 == 'Si' || this.paramName4 == 'Mn'
      || this.paramName4 == 'Ag' || this.paramName4 == 'Ba' || this.paramName4 == 'Bi' || this.paramName4 == 'In'
      || this.paramName4 == 'Ni') {
      //this.yAxisLabel = this.paramDescripton + ' (' + this.parameterName + ')';
      this.yAxisLabel4 = this.paramDesc4 + ' ' + '(ppm)';
      yAxisLabel = this.paramDesc4 + ' (' + this.paramName4 + ')';
      this.yAxisLabelPDF4 = this.paramDesc4 + ' ' + ' (ppm)' + ' vs Fluid Distance ' + self.uomLabel;

    } else if ((this.paramName4 == 'Soot') || (this.paramName4 == 'Fuel Dilution')) {
      this.yAxisLabel4 = this.paramDesc4 + ' ' + ' (%)';
      yAxisLabel = this.paramName4 + ' ' + ' (%)';
      this.yAxisLabelPDF4 = this.paramDesc4 + ' ' + ' (%)' + ' vs Fluid Distance ' + self.uomLabel;

    } else {
      this.yAxisLabel4 = this.paramName4 + ' ' + ' (abs/cm)';
      yAxisLabel = this.paramName4 + ' ' + ' (abs/cm)';
      this.yAxisLabelPDF4 = this.paramDesc4 + ' ' + ' (abs/cm)' + 'vs Fluid Distance ' + self.uomLabel;

    }

    var margin = { top: 20, right: 15, bottom: 60, left: 60 }
      , width = 550 - margin.left - margin.right
      , height = 450 - margin.top - margin.bottom;

    if (this.popDatList4.length > 0) {
      var xPopDataList = d3.max((this.popDatList4), function (d) { return d[0]; });

    } else {
      xPopDataList = 0;
    }
    if (this.unitDataList4.length > 0) {
      var xUnitDataList = d3.max((this.unitDataList4), function (d) { return d[0]; });

    } else {
      xUnitDataList = 0;
    }
    if (this.sampleDataList4.length > 0) {
      var xSampleDataList = d3.max((this.sampleDataList4), function (d) { return d[0]; });

    } else {
      xSampleDataList = 0;
    }

    var xMax = Math.max(xPopDataList, xUnitDataList, xSampleDataList);


    if (this.popDatList4.length > 0) {
      var yPopDataList = d3.max((this.popDatList4), function (d) { return d[1]; });

    } else {
      yPopDataList = 0;
    }
    if (this.unitDataList4.length > 0) {
      var yUnitDataList = d3.max((this.unitDataList4), function (d) { return d[1]; });

    } else {
      yUnitDataList = 0;
    }
    if (this.sampleDataList4.length > 0) {
      var ySampleDataList = d3.max((this.sampleDataList4), function (d) { return d[1]; });

    } else {
      ySampleDataList = 0;
    }

    var yMax = Math.max(yPopDataList, yUnitDataList, ySampleDataList);

    //setting up X-axis data
    var x = d3.scaleLinear()
      .domain([0, xMax])
      .range([0, width]);


    //setting up Y-axis data
    var y = d3.scaleLinear()
      .domain([0, yMax])
      .range([height, 0]);

    var svg = d3.select('#scatter4')
      .append('svg')
      .attr('width', width + margin.right + margin.left)
      .attr('height', height + margin.top + margin.bottom);
    // Y-axis label
    svg.append("text")
      .attr("transform", "rotate(-90)")
      .attr("y", 0)
      .attr("x", 0 - (height / 2) - 10)
      .attr("dy", "1em")
      .style("text-anchor", "middle")
      .text(yAxisLabel).style("font-weight", "bold").style("font-size", "12px");

    //X-axis label
    svg.append("text")
      .attr("transform",
        "translate(" + (width / 2) + " ," +
        (height + margin.top + 20) + ")")
      .attr("x", 60)
      .attr("y", 40)
      .style("text-anchor", "middle")
      .text("Fluid Distance " + self.uomLabel).style("font-weight", "bold").style("font-size", "12px");


    var main = svg.append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')
      .attr('width', width)
      .attr('height', height)
      .attr('class', 'main');

    // draw the X-axis
    var xAxis = d3.axisBottom(x).tickSize(-height);

    main.append('g')
      .attr('transform', 'translate(0,' + height + ')')
      .attr('class', 'main axis date').style("stroke-dasharray", "5,5").style("color", "lightgray")
      .call(xAxis).selectAll("text").style("color", "black")
      .attr("transform", function (d) {
        return "rotate(-60)"
      }).attr("x", -22).attr("y", -3);

    // draw the Y-axis
    var yAxis = d3.axisLeft(y).tickSize(-width);

    main.append('g')
      .attr('transform', 'translate(0,0)')
      .attr('class', 'main axis date').style("stroke-dasharray", "5,5").style("color", "lightgray")
      .call(yAxis).selectAll("text").style("color", "black");

    var g = main.append("g");

    //scatter circle placement in graph
    g.selectAll("scatter-dots")
      .data(this.popDatList4)
      .enter().append("circle")
      .attr("cx", function (d, i) { return x(d[0]); })
      .attr("cy", function (d) { return y(d[1]); })
      .attr("r", 8)
      .style("fill", "#87CEFA");// radius and color of each spot

    g.selectAll("scatter-dots")
      .data(this.unitDataList4)
      .enter().append("circle")
      .attr("cx", function (d, i) { return x(d[0]); })
      .attr("cy", function (d) { return y(d[1]); })
      .attr("r", 8)
      .style("fill", "blue");// radius and color of each spot


    g.selectAll("scatter-dots")
      .data(this.sampleDataList4)
      .enter().append("circle")
      .attr("cx", function (d, i) { return x(d[0]); })
      .attr("cy", function (d) { return y(d[1]); })
      .attr("r", 8)
      .style("fill", "red");// radius and color of each spot
  }

  AddImagesResource4(graphImageData: any) {
    this.imageData4 = graphImageData;
  }

  // --------------------------------for pdf generation and download------------------------ start-----------

  oilHealthForPdfFinalArray: any = [];
  allMetalForPdfArrar: any = [];
  oilHealthArrForPdf: any = {};
  allMetaForPdfObj: any = {};

  buildTableBody(data, columns) {
    var body = [];
    //body.push(columns);
    data.forEach(function (row) {
      var dataRow = [];
      columns.forEach(function (column) {
        dataRow.push(row[column] ? row[column].toString().toUpperCase() : '');
      })
      body.push(dataRow);
    });
    return body;
  }

  table(data, columns) {
    return {
      table: {
        headerRows: 1,
        body: this.buildTableBody(data, columns),

      }
    };

  }
  ;

  buildTableBodyForOil(data, columns, headers) {
    var body = [];
    body.push(headers);
    data.forEach(function (row) {
      var dataRow = [];
      columns.forEach(function (column) {

        if (row.niSev == '2' && column == 'nitration') {
          var sevColor = '#F8E71C';
        }
        if (row.niSev == '3' && column == 'nitration') {
          var sevColor = '#F19806';
        }
        if (row.niSev == '4' && column == 'nitration') {
          var sevColor = '#DA291C';
        }

        if (row.oxSev == '2' && column == 'oxidation') {
          var sevColor = '#F8E71C';
        }
        if (row.oxSev == '3' && column == 'oxidation') {
          var sevColor = '#F19806';
        }
        if (row.oxSev == '4' && column == 'oxidation') {
          var sevColor = '#DA291C';
        }

        if (row.fuelSev == '2' && column == 'fuelDilution') {
          var sevColor = '#F8E71C';
        }
        if (row.fuelSev == '3' && column == 'fuelDilution') {
          var sevColor = '#F19806';
        }
        if (row.fuelSev == '4' && column == 'fuelDilution') {
          var sevColor = '#DA291C';
        }

        if (row.vis100Sev == '2' && column == 'vis100') {
          var sevColor = '#F8E71C';
        }
        if (row.vis100Sev == '3' && column == 'vis100') {
          var sevColor = '#F19806';
        }
        if (row.vis100Sev == '4' && column == 'vis100') {
          var sevColor = '#DA291C';
        }
        if (row.vis40Sev == '2' && column == 'vis40') {
          var sevColor = '#F8E71C';
        }
        if (row.vis40Sev == '3' && column == 'vis40') {
          var sevColor = '#F19806';
        }
        if (row.vis40Sev == '4' && column == 'vis40') {
          var sevColor = '#DA291C';
        }

        if (row.sootSev == '2' && column == 'soot') {
          var sevColor = '#F8E71C';
        }
        if (row.sootSev == '3' && column == 'soot') {
          var sevColor = '#F19806';
        }
        if (row.sootSev == '4' && column == 'soot') {
          var sevColor = '#DA291C';
        }

        if (row.tbnSev == '2' && column == 'tbn') {
          var sevColor = '#F8E71C';
        }
        if (row.tbnSev == '3' && column == 'tbn') {
          var sevColor = '#F19806';
        }
        if (row.tbnSev == '4' && column == 'tbn') {
          var sevColor = '#DA291C';
        }

        if (row.tanSev == '2' && column == 'tan') {
          var sevColor = '#F8E71C';
        }
        if (row.tanSev == '3' && column == 'tan') {
          var sevColor = '#F19806';
        }
        if (row.tanSev == '4' && column == 'tan') {
          var sevColor = '#DA291C';
        }


        if (row.water == '2' && column == 'water') {
          var sevColor = '#F8E71C';
        }
        if (row.water == '3' && column == 'water') {
          var sevColor = '#F19806';
        }
        if (row.water == '4' && column == 'water') {
          var sevColor = '#DA291C';
        }
        dataRow.push({ fillColor: sevColor, text: row[column].toString() });
      });
      body.push(dataRow);
    });
    return body;
  }

  tableForOil(data, columns, headers) {
    return {
      table: {
        headerRows: 1,
        body: this.buildTableBodyForOil(data, columns, headers),

      },
      layout: {
        hLineWidth: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
        },
        vLineWidth: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
        },
        hLineColor: function (i, node) {
          return 'lightGray';
        },
        vLineColor: function (i, node) {
          return 'lightGray';
        },
      }
    };

  }

  buildTableBodyForMetal(data, columns, headers) {
    var body = [];
    body.push(headers);
    data.forEach(function (row) {
      var dataRow = [];
      columns.forEach(function (column) {

        if (row.pbSev == '2' && column == 'pb') {
          var sevColor = '#F8E71C';
        }
        if (row.pbSev == '3' && column == 'pb') {
          var sevColor = '#F19806';
        }
        if (row.pbSev == '4' && column == 'pb') {
          var sevColor = '#DA291C';
        }
        if (row.agSev == '2' && column == 'ag') {
          var sevColor = '#F8E71C';
        }
        if (row.agSev == '3' && column == 'ag') {
          var sevColor = '#F19806';
        }
        if (row.agSev == '4' && column == 'ag') {
          var sevColor = '#DA291C';
        }

        if (row.alSev == '2' && column == 'al') {
          var sevColor = '#F8E71C';
        }
        if (row.alSev == '3' && column == 'al') {
          var sevColor = '#F19806';
        }
        if (row.alSev == '4' && column == 'al') {
          var sevColor = '#DA291C';
        }

        if (row.bSev == '2' && column == 'b') {
          var sevColor = '#F8E71C';
        }
        if (row.bSev == '3' && column == 'b') {
          var sevColor = '#F19806';
        }
        if (row.bSev == '4' && column == 'b') {
          var sevColor = '#DA291C';
        }


        if (row.baSev == '2' && column == 'ba') {
          var sevColor = '#F8E71C';
        }
        if (row.baSev == '3' && column == 'ba') {
          var sevColor = '#F19806';
        }
        if (row.baSev == '4' && column == 'ba') {
          var sevColor = '#DA291C';
        }

        if (row.biSev == '2' && column == 'bi') {
          var sevColor = '#F8E71C';
        }
        if (row.biSev == '3' && column == 'bi') {
          var sevColor = '#F19806';
        }
        if (row.biSev == '4' && column == 'bi') {
          var sevColor = '#DA291C';
        }

        if (row.caSev == '2' && column == 'ca') {
          var sevColor = '#F8E71C';
        }
        if (row.caSev == '3' && column == 'ca') {
          var sevColor = '#F19806';
        }
        if (row.caSev == '4' && column == 'ca') {
          var sevColor = '#DA291C';
        }

        if (row.crSev == '2' && column == 'cr') {
          var sevColor = '#F8E71C';
        }
        if (row.crSev == '3' && column == 'cr') {
          var sevColor = '#F19806';
        }
        if (row.crSev == '4' && column == 'cr') {
          var sevColor = '#DA291C';
        }


        if (row.cuSev == '2' && column == 'cu') {
          var sevColor = '#F8E71C';
        }
        if (row.cuSev == '3' && column == 'cu') {
          var sevColor = '#F19806';
        }
        if (row.cuSev == '4' && column == 'cu') {
          var sevColor = '#DA291C';
        }

        if (row.feSev == '2' && column == 'fe') {
          var sevColor = '#F8E71C';
        }
        if (row.feSev == '3' && column == 'fe') {
          var sevColor = '#F19806';
        }
        if (row.feSev == '4' && column == 'fe') {
          var sevColor = '#DA291C';
        }

        if (row.inSev == '2' && column == 'in') {
          var sevColor = '#F8E71C';
        }
        if (row.inSev == '3' && column == 'in') {
          var sevColor = '#F19806';
        }
        if (row.inSev == '4' && column == 'in') {
          var sevColor = '#DA291C';
        }

        if (row.kSev == '2' && column == 'k') {
          var sevColor = '#F8E71C';
        }
        if (row.kSev == '3' && column == 'k') {
          var sevColor = '#F19806';
        }
        if (row.kSev == '4' && column == 'k') {
          var sevColor = '#DA291C';
        }

        if (row.mgSev == '2' && column == 'mg') {
          var sevColor = '#F8E71C';
        }
        if (row.mgSev == '3' && column == 'mg') {
          var sevColor = '#F19806';
        }
        if (row.mgSev == '4' && column == 'mg') {
          var sevColor = '#DA291C';
        }


        if (row.mnSev == '2' && column == 'mn') {
          var sevColor = '#F8E71C';
        }
        if (row.mnSev == '3' && column == 'mn') {
          var sevColor = '#F19806';
        }
        if (row.mnSev == '4' && column == 'mn') {
          var sevColor = '#DA291C';
        }

        if (row.moSev == '2' && column == 'mo') {
          var sevColor = '#F8E71C';
        }
        if (row.moSev == '3' && column == 'mo') {
          var sevColor = '#F19806';
        }
        if (row.moSev == '4' && column == 'mo') {
          var sevColor = '#DA291C';
        }


        if (row.naSev == '2' && column == 'na') {
          var sevColor = '#F8E71C';
        }
        if (row.naSev == '3' && column == 'na') {
          var sevColor = '#F19806';
        }
        if (row.naSev == '4' && column == 'na') {
          var sevColor = '#DA291C';
        }

        if (row.niSev == '2' && column == 'ni') {
          var sevColor = '#F8E71C';
        }
        if (row.niSev == '3' && column == 'ni') {
          var sevColor = '#F19806';
        }
        if (row.niSev == '4' && column == 'ni') {
          var sevColor = '#DA291C';
        }


        if (row.pSev == '2' && column == 'p') {
          var sevColor = '#F8E71C';
        }
        if (row.pSev == '3' && column == 'p') {
          var sevColor = '#F19806';
        }
        if (row.pSev == '4' && column == 'p') {
          var sevColor = '#DA291C';
        }


        if (row.siSev == '2' && column == 'si') {
          var sevColor = '#F8E71C';
        }
        if (row.siSev == '3' && column == 'si') {
          var sevColor = '#F19806';
        }
        if (row.siSev == '4' && column == 'si') {
          var sevColor = '#DA291C';
        }

        if (row.snSev == '2' && column == 'sn') {
          var sevColor = '#F8E71C';
        }
        if (row.snSev == '3' && column == 'sn') {
          var sevColor = '#F19806';
        }
        if (row.snSev == '4' && column == 'sn') {
          var sevColor = '#DA291C';
        }


        if (row.znSev == '2' && column == 'zn') {
          var sevColor = '#F8E71C';
        }
        if (row.znSev == '3' && column == 'zn') {
          var sevColor = '#F19806';
        }
        if (row.znSev == '4' && column == 'zn') {
          var sevColor = '#DA291C';
        }
        dataRow.push({ fillColor: sevColor, text: row[column].toString(), maxWidth: 10 });
      });
      body.push(dataRow);

    });
    return body;
  }

  tableForMetal(data, columns, headers) {
    return {
      table: {
        headerRows: 1,
        body: this.buildTableBodyForMetal(data, columns, headers),

      },
      layout: {
        hLineWidth: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
        },
        vLineWidth: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
        },
        hLineColor: function (i, node) {
          return 'lightGray';
        },
        vLineColor: function (i, node) {
          return 'lightGray';
        },
        paddingRight: function setWidth() {
          if (data.length === 1) {
            return 4.8;
          }
          else if (data.length === 2) {
            return 4.6;
          }
          else if (data.length === 3) {
            return 4.4;
          }
          else if (data.length === 4) {
            return 4.2;
          } else {
            return 4.4;
          }
        }

      }
    };
  }

  getCoolantContaminationSevColor() {
    if (this.coolantContaminationForPDF && this.ccSevForPDF == '1') {
      var fillColor = '#0AB50A';
    }
    if (this.coolantContaminationForPDF && this.ccSevForPDF == '2') {
      var fillColor = '#F8E71C';
    }
    if (this.coolantContaminationForPDF && this.ccSevForPDF == '3') {
      var fillColor = '#F19806';
    }
    if (this.coolantContaminationForPDF && this.ccSevForPDF == '4') {
      var fillColor = '#DA291C';
    }
    return fillColor;
  }

  getParticleContaminationSevColor() {
    if (this.particleContaminationForPDF && this.pcSevForPDF == '1') {
      var fillColor = '#0AB50A';
    }
    if (this.particleContaminationForPDF && this.pcSevForPDF == '2') {
      var fillColor = '#F8E71C';
    }
    if (this.particleContaminationForPDF && this.pcSevForPDF == '3') {
      var fillColor = '#F19806';
    }
    if (this.particleContaminationForPDF && this.pcSevForPDF == '4') {
      var fillColor = '#DA291C';
    }
    return fillColor;
  }

  getMetalWearSevColor() {
    if (this.metalWearForPDF && this.mwSevForPDF == '1') {
      var fillColor = '#0AB50A';
    }
    if (this.metalWearForPDF && this.mwSevForPDF == '2') {
      var fillColor = '#F8E71C';
    }
    if (this.metalWearForPDF && this.mwSevForPDF == '3') {
      var fillColor = '#F19806';
    }
    if (this.metalWearForPDF && this.mwSevForPDF == '4') {
      var fillColor = '#DA291C';
    }
    return fillColor;
  }
  getDustContaminationSevColor() {
    if (this.dustContaminationForPDF && this.dcSevForPDF == '1') {
      var fillColor = '#0AB50A';
    }

    if (this.dustContaminationForPDF && this.dcSevForPDF == '2') {
      var fillColor = '#F8E71C';
    }
    if (this.dustContaminationForPDF && this.dcSevForPDF == '3') {
      var fillColor = '#F19806';
    }
    if (this.dustContaminationForPDF && this.dcSevForPDF == '4') {
      var fillColor = '#DA291C';
    }
    return fillColor;
  }

  getSootContaminationSevColor() {
    if (this.sootContaminationForPDF && this.scSevForPDF == '1') {
      var fillColor = '#0AB50A';
    }
    if (this.sootContaminationForPDF && this.scSevForPDF == '2') {
      var fillColor = '#F8E71C';
    }

    if (this.sootContaminationForPDF && this.scSevForPDF == '3') {
      var fillColor = '#F19806';
    }

    if (this.sootContaminationForPDF && this.scSevForPDF == '4') {
      var fillColor = '#DA291C';
    }
    return fillColor;
  }

  getDOContaminationSevColor() {
    if (this.degradedOilForPDF && this.doSevForPDF == '1') {
      var fillColor = '#0AB50A';
    }
    if (this.degradedOilForPDF && this.doSevForPDF == '2') {
      var fillColor = '#F8E71C';
    }
    if (this.degradedOilForPDF && this.doSevForPDF == '3') {
      var fillColor = '#F19806';
    }
    if (this.degradedOilForPDF && this.doSevForPDF == '4') {
      var fillColor = '#DA291C';
    }
    return fillColor;
  }

  getFuelContaminationSevColor() {
    if (this.fuelContaminationForPDF && this.fcSevForPDF == '1') {
      var fillColor = '#0AB50A';
    }
    if (this.fuelContaminationForPDF && this.fcSevForPDF == '2') {
      var fillColor = '#F8E71C';
    }
    if (this.fuelContaminationForPDF && this.fcSevForPDF == '3') {
      var fillColor = '#F19806';
    }
    if (this.fuelContaminationForPDF && this.fcSevForPDF == '4') {
      var fillColor = '#DA291C';
    }

    return fillColor;
  }

  getEWContaminationSevColor() {
    if (this.engineWearForPDF && this.ewSevForPDF == '1') {
      var fillColor = '#0AB50A';
    }
    if (this.engineWearForPDF && this.ewSevForPDF == '2') {
      var fillColor = '#F8E71C';
    }
    if (this.engineWearForPDF && this.ewSevForPDF == '3') {
      var fillColor = '#F19806';
    }
    if (this.engineWearForPDF && this.ewSevForPDF == '4') {
      var fillColor = '#DA291C';
    }
    return fillColor;
  }
  getWaterContaminationSevColor() {
    if (this.waterContaminationForPDF && this.wcSevForPDF == '1') {
      var fillColor = '#0AB50A';
    }
    if (this.waterContaminationForPDF && this.wcSevForPDF == '2') {
      var fillColor = '#F8E71C';
    }
    if (this.waterContaminationForPDF && this.wcSevForPDF == '3') {
      var fillColor = '#F19806';
    }
    if (this.waterContaminationForPDF && this.wcSevForPDF == '4') {
      var fillColor = '#DA291C';
    }
    return fillColor;
  }
  getSystemContaminationSevColor() {
    if (this.systemcorrosionContaminationForPDF && this.sccSevForPDF == '1') {
      var fillColor = '#0AB50A';
    }
    if (this.systemcorrosionContaminationForPDF && this.sccSevForPDF == '2') {
      var fillColor = '#F8E71C';
    }
    if (this.systemcorrosionContaminationForPDF && this.sccSevForPDF == '3') {
      var fillColor = '#F19806';
    }
    if (this.systemcorrosionContaminationForPDF && this.sccSevForPDF == '4') {
      var fillColor = '#DA291C';
    }
    return fillColor;
  }
  getDegradedContaminationSevColor() {
    if (this.degradedcoolantContaminationForPDF && this.dccSevForPDF == '1') {
      var fillColor = '#0AB50A';
    }
    if (this.degradedcoolantContaminationForPDF && this.dccSevForPDF == '2') {
      var fillColor = '#F8E71C';
    }
    if (this.degradedcoolantContaminationForPDF && this.dccSevForPDF == '3') {
      var fillColor = '#F19806';
    }
    if (this.degradedcoolantContaminationForPDF && this.dccSevForPDF == '4') {
      var fillColor = '#DA291C';
    }
    return fillColor;
  }
  getHardParticleContaminationSevColor() {
    if (this.hardparticleContaminationForPDF && this.hpcSevForPDF == '1') {
      var fillColor = '#0AB50A';
    }
    if (this.hardparticleContaminationForPDF && this.hpcSevForPDF == '2') {
      var fillColor = '#F8E71C';
    }
    if (this.hardparticleContaminationForPDF && this.hpcSevForPDF == '3') {
      var fillColor = '#F19806';
    }
    if (this.hardparticleContaminationForPDF && this.hpcSevForPDF == '4') {
      var fillColor = '#DA291C';
    }
    return fillColor;
  }

   /* Electrical conductivity method */
  getElectricalConductivitySevColor() {
    if (this.eletricalConductivityForPDF && this.edSevForPDF == '1') {
      var fillColor = '#0AB50A';
    }
    if (this.eletricalConductivityForPDF && this.edSevForPDF == '2') {
      var fillColor = '#F8E71C';
    }
    if (this.eletricalConductivityForPDF && this.edSevForPDF == '3') {
      var fillColor = '#F19806';
    }
    if (this.eletricalConductivityForPDF && this.edSevForPDF == '4') {
      var fillColor = '#DA291C';
    }
    return fillColor;
  }

  getExcessiveContaminationSevColor() {
    if (this.excessiveContaminationForPDF && this.ecSevForPDF == '1') {
      var fillColor = '#0AB50A';
    }
    if (this.excessiveContaminationForPDF && this.ecSevForPDF == '2') {
      var fillColor = '#F8E71C';
    }
    if (this.excessiveContaminationForPDF && this.ecSevForPDF == '3') {
      var fillColor = '#F19806';
    }
    if (this.excessiveContaminationForPDF && this.ecSevForPDF == '4') {
      var fillColor = '#DA291C';
    }
    return fillColor;
  }
  getSulfurContaminationSevColor() {
    if (this.currentItem.testLevel == 'Quality' || this.currentItem.testLevel == 'Properties') {
      if (this.sulfurContaminationForPDF && this.sulfurSevForPDF == '1') {
        var fillColor = '#0AB50A';
      }
      if (this.sulfurContaminationForPDF && this.sulfurSevForPDF == '2') {
        var fillColor = '#F8E71C';
      }
      if (this.sulfurContaminationForPDF && this.sulfurSevForPDF == '3') {
        var fillColor = '#F19806';
      }
      if (this.sulfurContaminationForPDF && this.sulfurSevForPDF == '4') {
        var fillColor = '#DA291C';
      }
      return fillColor;
    }
    else if (this.currentItem.testLevel == 'Cleanliness') {
      var fillColor = 'lightgrey';

      return fillColor;
    }
  }
  getBacteriaContentSevColor() {
    if (this.currentItem.testLevel == 'Quality' || this.currentItem.testLevel == 'Cleanliness') {
      if (this.bacteriaContentForPDF && this.bcSevForPDF == '1') {
        var fillColor = '#0AB50A';
      }
      if (this.bacteriaContentForPDF && this.bcSevForPDF == '2') {
        var fillColor = '#F8E71C';
      }
      if (this.bacteriaContentForPDF && this.bcSevForPDF == '3') {
        var fillColor = '#F19806';
      }
      if (this.bacteriaContentForPDF && this.bcSevForPDF == '4') {
        var fillColor = '#DA291C';
      }
      return fillColor;

    } else if (this.currentItem.testLevel == 'Properties') {
      var fillColor = 'lightgrey';

      return fillColor;
    }

  }
  getTraceMetalsSevColor() {
    if (this.currentItem.testLevel == 'Quality') {
      if (this.traceMetalsForPDF && this.tmcSevForPDF == '1') {
        var fillColor = '#0AB50A';
      }
      if (this.traceMetalsForPDF && this.tmcSevForPDF == '2') {
        var fillColor = '#F8E71C';
      }
      if (this.traceMetalsForPDF && this.tmcSevForPDF == '3') {
        var fillColor = '#F19806';
      }
      if (this.traceMetalsForPDF && this.tmcSevForPDF == '4') {
        var fillColor = '#DA291C';
      }
      return fillColor;
    }
    else if (this.currentItem.testLevel == 'Properties' || this.currentItem.testLevel == 'Cleanliness') {
      var fillColor = 'lightgrey';
      
      return fillColor;
    }
  }
  getDegradedFuelSevColor() {
    if (this.currentItem.testLevel == 'Quality') {
      if (this.degradedFuelForPDF && this.dfcSevForPDF == '1') {
        var fillColor = '#0AB50A';
      }
      if (this.degradedFuelForPDF && this.dfcSevForPDF == '2') {
        var fillColor = '#F8E71C';
      }
      if (this.degradedFuelForPDF && this.dfcSevForPDF == '3') {
        var fillColor = '#F19806';
      }
      if (this.degradedFuelForPDF && this.dfcSevForPDF == '4') {
        var fillColor = '#DA291C';
      }
      return fillColor;
    } else if (this.currentItem.testLevel == 'Properties' || this.currentItem.testLevel == 'Cleanliness') {
      var fillColor = 'lightgrey';

      return fillColor;
    }
  }
  getFuelCleanlinessSevColor() {
    if (this.currentItem.testLevel == 'Quality' || this.currentItem.testLevel == 'Cleanliness') {
      if (this.fuelCleanlinessForPDF && this.fclSevForPDF == '1') {
        var fillColor = '#0AB50A';
      }
      if (this.fuelCleanlinessForPDF && this.fclSevForPDF == '2') {
        var fillColor = '#F8E71C';
      }
      if (this.fuelCleanlinessForPDF && this.fclSevForPDF == '3') {
        var fillColor = '#F19806';
      }
      if (this.fuelCleanlinessForPDF && this.fclSevForPDF == '4') {
        var fillColor = '#DA291C';
      }
      return fillColor;
    }
    else if (this.currentItem.testLevel == 'Properties') {
      var fillColor = 'lightgrey';

      return fillColor;
    }
  }
  getFuelCharacteristicsSevColor() {
    if (this.currentItem.testLevel == 'Quality' || this.currentItem.testLevel == 'Properties') {
      if (this.fuelCharacteristicsForPDF && this.fchSevForPDF == '1') {
        var fillColor = '#0AB50A';
      }
      if (this.fuelCharacteristicsForPDF && this.fchSevForPDF == '2') {
        var fillColor = '#F8E71C';
      }
      if (this.fuelCharacteristicsForPDF && this.fchSevForPDF == '3') {
        var fillColor = '#F19806';
      }
      if (this.fuelCharacteristicsForPDF && this.fchSevForPDF == '4') {
        var fillColor = '#DA291C';
      }
      return fillColor;
    }
    else if (this.currentItem.testLevel == 'Cleanliness') {
      var fillColor = 'lightgrey';

      return fillColor;
    }
  }
  showMoreInforItemArr: any = [];

  downloadPDFWithFourGraph() {
    this.loaderService.show();
    document.getElementById('metalInfo').style.overflow = 'visible';
    document.getElementById('metalInfo').style.width = '1458.7px';

    let self = this;
    html2canvas(document.getElementById('oilHealth')).then(function (canvas) {
      const oilHealthImage = canvas.toDataURL('image/png');
      self.AddImagesOilHealthInfo(oilHealthImage);

      html2canvas(document.getElementById('metalInfo')).then(function (canvas) {
        document.getElementById('metalInfo').style.overflow = 'auto';
        document.getElementById('metalInfo').style.width = 'auto';

        const allMetalInfoTable = canvas.toDataURL('image/png');
        self.AddImagesAllMetalInfo(allMetalInfoTable);
        self.generatePdfWIthFourGraph();
        self.loaderService.hide();
      });
    });

  }
  generatePdfWIthFourGraph() {
    this.oilHealthForPdfFinalArray = [];
    this.showMoreInforItemArr = [];
    this.allMetalForPdfArrar = [];
    this.showMoreInforItemArr.push(this.showMoreInformationData);

    for (let i = 0; i < this.oilHealth.length; i++) {
      this.oilHealthArrForPdf['sampleId'] = this.oilHealth[i].sampleId;
      this.oilHealthArrForPdf['sampledDate'] = this.oilHealth[i].sampledDate;
      this.oilHealthArrForPdf['engineMiles'] = this.oilHealth[i].engineMiles;
      this.oilHealthArrForPdf['oilMiles'] = this.oilHealth[i].oilMiles;
      this.oilHealthArrForPdf['nitration'] = this.oilHealth[i].nitration.value;
      this.oilHealthArrForPdf['oxidation'] = this.oilHealth[i].oxidation.value;
      this.oilHealthArrForPdf['soot'] = this.oilHealth[i].soot.value;
      this.oilHealthArrForPdf['fuelDilution'] = this.oilHealth[i].fuelDilution.value;
      this.oilHealthArrForPdf['tan'] = this.oilHealth[i].tan.value;
      this.oilHealthArrForPdf['tbn'] = this.oilHealth[i].tbn.value;
      this.oilHealthArrForPdf['vis40'] = this.oilHealth[i].vis40.value;
      this.oilHealthArrForPdf['vis100'] = this.oilHealth[i].vis100.value;
      this.oilHealthArrForPdf['water'] = this.oilHealth[i].water.value;

      this.oilHealthArrForPdf['niSev'] = this.oilHealth[i].nitration.severity;
      this.oilHealthArrForPdf['oxSev'] = this.oilHealth[i].oxidation.severity;
      this.oilHealthArrForPdf['fuelSev'] = this.oilHealth[i].fuelDilution.severity;
      this.oilHealthArrForPdf['vis40Sev'] = this.oilHealth[i].vis40.severity;
      this.oilHealthArrForPdf['vis100Sev'] = this.oilHealth[i].vis100.severity;
      this.oilHealthArrForPdf['sootSev'] = this.oilHealth[i].soot.severity;
      this.oilHealthArrForPdf['tanSev'] = this.oilHealth[i].tan.severity;
      this.oilHealthArrForPdf['tbnSev'] = this.oilHealth[i].tbn.severity;
      this.oilHealthArrForPdf['waterSev'] = this.oilHealth[i].water.severity;

      this.oilHealthForPdfFinalArray.push(this.oilHealthArrForPdf);
      this.oilHealthArrForPdf = {};

    }

    for (let i = 0; i < this.allMetalInfo.length; i++) {
      this.allMetaForPdfObj['sampleId'] = this.allMetalInfo[i].sampleId;
      this.allMetaForPdfObj['sampledDate'] = this.allMetalInfo[i].sampledDate;
      this.allMetaForPdfObj['ag'] = this.allMetalInfo[i].ag.value;
      this.allMetaForPdfObj['al'] = this.allMetalInfo[i].al.value;
      this.allMetaForPdfObj['b'] = this.allMetalInfo[i].b.value;
      this.allMetaForPdfObj['ba'] = this.allMetalInfo[i].ba.value;
      this.allMetaForPdfObj['bi'] = this.allMetalInfo[i].bi.value;
      this.allMetaForPdfObj['ca'] = this.allMetalInfo[i].ca.value;
      this.allMetaForPdfObj['cr'] = this.allMetalInfo[i].cr.value;
      this.allMetaForPdfObj['cu'] = this.allMetalInfo[i].cu.value;
      this.allMetaForPdfObj['fe'] = this.allMetalInfo[i].fe.value;
      this.allMetaForPdfObj['in'] = this.allMetalInfo[i].in.value;
      this.allMetaForPdfObj['k'] = this.allMetalInfo[i].k.value;

      this.allMetaForPdfObj['mg'] = this.allMetalInfo[i].mg.value;
      this.allMetaForPdfObj['mn'] = this.allMetalInfo[i].mn.value;
      this.allMetaForPdfObj['mo'] = this.allMetalInfo[i].mo.value;
      this.allMetaForPdfObj['na'] = this.allMetalInfo[i].na.value;
      this.allMetaForPdfObj['ni'] = this.allMetalInfo[i].ni.value;
      this.allMetaForPdfObj['p'] = this.allMetalInfo[i].p.value;
      this.allMetaForPdfObj['pb'] = this.allMetalInfo[i].pb.value;
      this.allMetaForPdfObj['si'] = this.allMetalInfo[i].si.value;
      this.allMetaForPdfObj['sn'] = this.allMetalInfo[i].sn.value;
      this.allMetaForPdfObj['zn'] = this.allMetalInfo[i].zn.value;

      this.allMetaForPdfObj['agSev'] = this.allMetalInfo[i].ag.severity;
      this.allMetaForPdfObj['alSev'] = this.allMetalInfo[i].al.severity;

      this.allMetaForPdfObj['bSev'] = this.allMetalInfo[i].b.severity;
      this.allMetaForPdfObj['baSev'] = this.allMetalInfo[i].ba.severity;
      this.allMetaForPdfObj['biSev'] = this.allMetalInfo[i].bi.severity;
      this.allMetaForPdfObj['caSev'] = this.allMetalInfo[i].ca.severity;
      this.allMetaForPdfObj['crSev'] = this.allMetalInfo[i].cr.severity;

      this.allMetaForPdfObj['feSev'] = this.allMetalInfo[i].fe.severity;
      this.allMetaForPdfObj['cuSev'] = this.allMetalInfo[i].cu.severity;

      this.allMetaForPdfObj['inSev'] = this.allMetalInfo[i].in.severity;
      this.allMetaForPdfObj['kSev'] = this.allMetalInfo[i].k.severity;
      this.allMetaForPdfObj['mgSev'] = this.allMetalInfo[i].mg.severity;
      this.allMetaForPdfObj['mnSev'] = this.allMetalInfo[i].mn.severity;
      this.allMetaForPdfObj['moSev'] = this.allMetalInfo[i].mo.severity;

      this.allMetaForPdfObj['naSev'] = this.allMetalInfo[i].na.severity;
      this.allMetaForPdfObj['niSev'] = this.allMetalInfo[i].ni.severity;
      this.allMetaForPdfObj['pSev'] = this.allMetalInfo[i].p.severity;
      this.allMetaForPdfObj['pbSev'] = this.allMetalInfo[i].pb.severity;

      this.allMetaForPdfObj['siSev'] = this.allMetalInfo[i].si.severity;
      this.allMetaForPdfObj['snSev'] = this.allMetalInfo[i].sn.severity;
      this.allMetaForPdfObj['znSev'] = this.allMetalInfo[i].zn.severity;

      this.allMetalForPdfArrar.push(this.allMetaForPdfObj);
      this.allMetaForPdfObj = {};
    }

    let pdfDocument = {
      footer: {
        columns: [
          {
            image: 'data:image/png;base64,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',
            width: 30,
            margin: [40, -5, 40, 0]
          },

          { fontSize: 6, margin: [75, 0, 40, 0], text: "* Indicates results recorded via FT-IR.\n Disclaimer: All information including recommended actions are provided on an “as is” basis.  No warranty is expressed or implied. Cummins expressly disclaims any and all warranties and liability arising from or otherwise related to information provided herein.  See the Marketplace Terms and Conditions of Use for more details regarding such disclaimers. \n FluidWatch® \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t fluidwatch.laboratory@cummins.com", alignment: 'justify' }
        ]
      },
      content: [

        {
          table: {
            body: [
              [

                {
                  fontSize: 10, bold: true, border: [true, true, false, false],
                  table: {
                    widths: [110],
                    //heights: [29],

                    body: [
                      [
                        {
                          image: this.getAddressImage(),
                          width: 110,
                          //height: 50,
                          border: [false, false, false, false]
                        },
                      ]
                    ]
                  }, layout: {
                    hLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    },

                  }
                },
                {
                  fontSize: 10, bold: true, border: [false, true, false, false],
                  table: {
                    widths: [70, 70, 70],
                    body: this.getHeaderBody()
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.body.length) ? 2 : 2;
                    },
                    vLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.widths.length) ? 2 : 2;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    },

                  }
                }
                ,
                {
                  fontSize: 8, bold: true, border: [false, true, true, false],
                  table: {
                    widths: [24, 33, 37],

                    body: [
                      [{ fillColor: '#DA291C', text: '' }, 'Red', 'Warning'],
                      [{ fillColor: '#F19806', text: '' }, 'Orange', 'Caution'],
                      [{ fillColor: '#F8E71C', text: '' }, 'Yellow', 'Watch'],
                      [{ fillColor: '#0AB50A', text: '' }, 'Green', 'Normal'],
                    ]
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.body.length) ? 2 : 2;
                    },
                    vLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.widths.length) ? 2 : 2;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    },

                  }
                }
              ]
            ]
          },

        },
        {
          style: 'tableContentSmi', margin: [0, 0, 0, 0],
          table: {
            body: [
              [{
                fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Customer & Unit Information',
                border: [false, true, true, false]

              },

              {
                fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Fluid & Filter Information',
                border: [false, true, true, false]
              }
                , {
                fillColor: '#696969', color: '#FFFFFF', alignment: 'center', bold: true, text: 'Sample Information',
                border: [false, true, false, false], margin: [0, 0, 0, 0]
              }],
              [{
                border: [false, false, false, false], margin: [-4.5, -2, -4.5, -4],
                table: {
                  widths: [78, 78],
                  body: [

                    ['Company ID', this.buildTableBody(this.showMoreInforItemArr, ['companyId'])],
                    ['Company Name', this.buildTableBody(this.showMoreInforItemArr, ['companyName'])],
                    ['Customer Name', this.buildTableBody(this.showMoreInforItemArr, ['customerName'])],
                    ['Phone Number', this.buildTableBody(this.showMoreInforItemArr, ['phoneNumber'])],
                    ['Component ID', this.buildTableBody(this.showMoreInforItemArr, ['componentId'])],
                    ['Unit Make', this.buildTableBody(this.showMoreInforItemArr, ['unitMake'])],
                    ['Unit Model', this.buildTableBody(this.showMoreInforItemArr, ['unitModel'])],
                    ['Unit Year', this.buildTableBody(this.showMoreInforItemArr, ['unitYear'])],
                    ['Equipment Serial No', this.buildTableBody(this.showMoreInforItemArr, ['esn'])]

                  ]
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
                  },
                  vLineWidth: function (i, node) {
                    return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
                  },
                  hLineColor: function (i, node) {
                    return 'lightGray';
                  },
                  vLineColor: function (i, node) {
                    return 'lightGray';
                  },

                  fillColor: function (rowIndex, node, columnIndex) {
                    return (rowIndex % 2 != 0) ? '#CCCCCC' : null;
                  }
                }
              },
              {
                border: [false, false, false, false], margin: [-4.5, -2, -4.5, -3],

                table: {
                  widths: [78, 78],

                  body: [

                    ['Fluid Brand', this.buildTableBody(this.showMoreInforItemArr, ['fluidBrand'])],
                    ['Fluid Product', this.buildTableBody(this.showMoreInforItemArr, ['fluidProduct'])],
                    ['Fluid Grade', this.buildTableBody(this.showMoreInforItemArr, ['fluidGrade'])],
                    ['Filter Brand', this.buildTableBody(this.showMoreInforItemArr, ['filterBrand'])],
                    ['Filter Product', this.buildTableBody(this.showMoreInforItemArr, ['filterProduct'])],
                    ['Sampled Location', this.buildTableBody(this.showMoreInforItemArr, ['sampledLocation'])],
                    ['Tracking Number', this.buildTableBody(this.showMoreInforItemArr, ['trackingNumber'])],
                    ['Sample Remarks', this.buildTableBody(this.showMoreInforItemArr, ['sampleRemarks'])]

                  ]
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
                  },
                  vLineWidth: function (i, node) {
                    return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
                  },
                  hLineColor: function (i, node) {
                    return 'lightGray';
                  },
                  vLineColor: function (i, node) {
                    return 'lightGray';
                  },

                  fillColor: function (rowIndex, node, columnIndex) {
                    return (rowIndex % 2 != 0) ? '#CCCCCC' : null;
                  }
                }
              },
              {
                border: [false, false, false, false], margin: [-4.5, -2, -5, -4],

                table: {

                  widths: [78, 77],

                  body: [

                    ['Sample ID', this.buildTableBody(this.showMoreInforItemArr, ['sampleId'])],
                    ['QR Code	', this.buildTableBody(this.showMoreInforItemArr, ['qrCodeId'])],
                    ['Sampled Date', this.buildTableBody(this.showMoreInforItemArr, ['sampledDate'])],
                    ['Received Date', this.buildTableBody(this.showMoreInforItemArr, ['receivedDate'])],
                    ['Completed Date', this.buildTableBody(this.showMoreInforItemArr, ['completedDate'])],
                    ['Component Make', this.buildTableBody(this.showMoreInforItemArr, ['engineMake'])],

                    ['Component Model', this.buildTableBody(this.showMoreInforItemArr, ['engineModel'])],
                    ['Component Year', this.buildTableBody(this.showMoreInforItemArr, ['engineYear'])],

                    ['Component Serial No', this.buildTableBody(this.showMoreInforItemArr, ['gsn'])]
                  ]
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
                  },
                  vLineWidth: function (i, node) {
                    return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
                  },
                  hLineColor: function (i, node) {
                    return 'lightGray';
                  },
                  vLineColor: function (i, node) {
                    return 'lightGray';
                  },

                  fillColor: function (rowIndex, node, columnIndex) {
                    return (rowIndex % 2 != 0) ? '#CCCCCC' : null;
                  }
                }
              }],
            ]
          },
        },

        {
          style: 'analysisAndAction', margin: [0, 0, 0, 0],
          table: {
            widths: [336.7, 163.3],

            body: [
              [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Analysis' },
              { fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Recommended Actions' }],
              [
                {
                  fontSize: 8, heights: 50, bold: false, text: [this.analysisComment,

                  ]

                },

                {
                  fontSize: 8, heights: 50, bold: false, text: [this.actionComment
                  ]
                }
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }

          }
        },


        {
          style: 'analysisAndAction', margin: [0, 0, 0, 0],

          table: {
            widths: [508],

            body: [
              [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Oil Health' },
              ],
              [
                {
                  image: this.oilHealthInfoImg,
                  width: 515,
                  margin: [-3.5, -2, 0, 0]
                },

              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }

          }
        },
        {
          style: 'analysisAndAction', margin: [0, 0, 0, 0],

          table: {
            widths: [508],

            body: [
              [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'All Metals Information (ppm)' },
              ],
              [
                {
                  image: this.allMetalInfoImg,
                  width: 515,
                  margin: [-3.5, -2, 0, 0]
                },

              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }

          }
        },

        {
          style: 'analysisAndAction', margin: [0, 0, 0, 0], pageBreak: 'before',
          border: [true, false, false, false],

          table: {
            widths: [250, 250],

            body: [
              [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: this.yAxisLabelPDF1 },
              { fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: this.yAxisLabelPDF2 }],
              [
                {
                  image: this.imageData1,
                  width: 250,
                  margin: [10, 0, 0, 0]
                },

                {
                  image: this.imageData2,
                  width: 250

                }
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }

          }
        },

        {
          style: 'analysisAndAction', margin: [0, 0, 0, 0],
          border: [true, false, false, false],

          table: {
            widths: [250, 250],

            body: [
              [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: this.yAxisLabelPDF3 },
              { fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: this.yAxisLabelPDF4 }],
              [
                {
                  image: this.imageData3,
                  width: 250,
                  margin: [10, 0, 0, 0]
                },

                {
                  image: this.imageData4,
                  width: 250

                }
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }

          }
        },

      ],

      styles: {
        header: {
          fontSize: 8,
          bold: true,
        },
        tableContentSmi: {
          fontSize: 8
        },
        tableContentOilHealth: {
          fontSize: 6.8,
          alignment: 'center'

        },
        tableContentMetal: {
          fontSize: 6.5,
          alignment: 'center',
          border: true
        },
        analysisAndAction: {
          fontSize: 8,
          bold: true
        },
        disclaimer: {
          fontSize: 6,
          bold: true
        }
      }

    };

    pdfMake.createPdf(pdfDocument).download(this.currentItem.sampleId);
  }

  downloadPDFWithTwoGraph() {
    this.loaderService.show();

    document.getElementById('metalInfo').style.overflow = 'visible';
    document.getElementById('metalInfo').style.width = '1458.7px';

    let self = this;
    html2canvas(document.getElementById('oilHealth')).then(function (canvas) {
      const oilHealthImage = canvas.toDataURL('image/png');
      self.AddImagesOilHealthInfo(oilHealthImage);

      html2canvas(document.getElementById('metalInfo')).then(function (canvas) {
        document.getElementById('metalInfo').style.overflow = 'auto';
        document.getElementById('metalInfo').style.width = 'auto';

        const allMetalInfoTable = canvas.toDataURL('image/png');
        self.AddImagesAllMetalInfo(allMetalInfoTable);
        self.generatePdfWIthTwoGraph();
        self.loaderService.hide();
      });

    });
  }

  generatePdfWIthTwoGraph() {

    this.oilHealthForPdfFinalArray = [];
    this.showMoreInforItemArr = [];
    this.allMetalForPdfArrar = [];
    this.showMoreInforItemArr.push(this.showMoreInformationData);

    for (let i = 0; i < this.oilHealth.length; i++) {
      this.oilHealthArrForPdf['sampleId'] = this.oilHealth[i].sampleId;
      this.oilHealthArrForPdf['sampledDate'] = this.oilHealth[i].sampledDate;
      this.oilHealthArrForPdf['engineMiles'] = this.oilHealth[i].engineMiles;
      this.oilHealthArrForPdf['oilMiles'] = this.oilHealth[i].oilMiles;
      this.oilHealthArrForPdf['nitration'] = this.oilHealth[i].nitration.value;
      this.oilHealthArrForPdf['oxidation'] = this.oilHealth[i].oxidation.value;
      this.oilHealthArrForPdf['soot'] = this.oilHealth[i].soot.value;
      this.oilHealthArrForPdf['fuelDilution'] = this.oilHealth[i].fuelDilution.value;
      this.oilHealthArrForPdf['tan'] = this.oilHealth[i].tan.value;
      this.oilHealthArrForPdf['tbn'] = this.oilHealth[i].tbn.value;
      this.oilHealthArrForPdf['vis40'] = this.oilHealth[i].vis40.value;
      this.oilHealthArrForPdf['vis100'] = this.oilHealth[i].vis100.value;
      this.oilHealthArrForPdf['water'] = this.oilHealth[i].water.value;

      this.oilHealthArrForPdf['niSev'] = this.oilHealth[i].nitration.severity;
      this.oilHealthArrForPdf['oxSev'] = this.oilHealth[i].oxidation.severity;
      this.oilHealthArrForPdf['fuelSev'] = this.oilHealth[i].fuelDilution.severity;
      this.oilHealthArrForPdf['vis40Sev'] = this.oilHealth[i].vis40.severity;
      this.oilHealthArrForPdf['vis100Sev'] = this.oilHealth[i].vis100.severity;
      this.oilHealthArrForPdf['sootSev'] = this.oilHealth[i].soot.severity;
      this.oilHealthArrForPdf['tanSev'] = this.oilHealth[i].tan.severity;
      this.oilHealthArrForPdf['tbnSev'] = this.oilHealth[i].tbn.severity;
      this.oilHealthArrForPdf['waterSev'] = this.oilHealth[i].water.severity;

      this.oilHealthForPdfFinalArray.push(this.oilHealthArrForPdf);
      this.oilHealthArrForPdf = {};
    }


    for (let i = 0; i < this.allMetalInfo.length; i++) {
      this.allMetaForPdfObj['sampleId'] = this.allMetalInfo[i].sampleId;
      this.allMetaForPdfObj['sampledDate'] = this.allMetalInfo[i].sampledDate;
      this.allMetaForPdfObj['ag'] = this.allMetalInfo[i].ag.value;
      this.allMetaForPdfObj['al'] = this.allMetalInfo[i].al.value;
      this.allMetaForPdfObj['b'] = this.allMetalInfo[i].b.value;
      this.allMetaForPdfObj['ba'] = this.allMetalInfo[i].ba.value;
      this.allMetaForPdfObj['bi'] = this.allMetalInfo[i].bi.value;
      this.allMetaForPdfObj['ca'] = this.allMetalInfo[i].ca.value;
      this.allMetaForPdfObj['cr'] = this.allMetalInfo[i].cr.value;
      this.allMetaForPdfObj['cu'] = this.allMetalInfo[i].cu.value;
      this.allMetaForPdfObj['fe'] = this.allMetalInfo[i].fe.value;
      this.allMetaForPdfObj['in'] = this.allMetalInfo[i].in.value;
      this.allMetaForPdfObj['k'] = this.allMetalInfo[i].k.value;

      this.allMetaForPdfObj['mg'] = this.allMetalInfo[i].mg.value;
      this.allMetaForPdfObj['mn'] = this.allMetalInfo[i].mn.value;
      this.allMetaForPdfObj['mo'] = this.allMetalInfo[i].mo.value;
      this.allMetaForPdfObj['na'] = this.allMetalInfo[i].na.value;
      this.allMetaForPdfObj['ni'] = this.allMetalInfo[i].ni.value;
      this.allMetaForPdfObj['p'] = this.allMetalInfo[i].p.value;
      this.allMetaForPdfObj['pb'] = this.allMetalInfo[i].pb.value;
      this.allMetaForPdfObj['si'] = this.allMetalInfo[i].si.value;
      this.allMetaForPdfObj['sn'] = this.allMetalInfo[i].sn.value;
      this.allMetaForPdfObj['zn'] = this.allMetalInfo[i].zn.value;

      this.allMetaForPdfObj['agSev'] = this.allMetalInfo[i].ag.severity;
      this.allMetaForPdfObj['alSev'] = this.allMetalInfo[i].al.severity;

      this.allMetaForPdfObj['bSev'] = this.allMetalInfo[i].b.severity;
      this.allMetaForPdfObj['baSev'] = this.allMetalInfo[i].ba.severity;
      this.allMetaForPdfObj['biSev'] = this.allMetalInfo[i].bi.severity;
      this.allMetaForPdfObj['caSev'] = this.allMetalInfo[i].ca.severity;
      this.allMetaForPdfObj['crSev'] = this.allMetalInfo[i].cr.severity;

      this.allMetaForPdfObj['feSev'] = this.allMetalInfo[i].fe.severity;
      this.allMetaForPdfObj['cuSev'] = this.allMetalInfo[i].cu.severity;

      this.allMetaForPdfObj['inSev'] = this.allMetalInfo[i].in.severity;
      this.allMetaForPdfObj['kSev'] = this.allMetalInfo[i].k.severity;
      this.allMetaForPdfObj['mgSev'] = this.allMetalInfo[i].mg.severity;
      this.allMetaForPdfObj['mnSev'] = this.allMetalInfo[i].mn.severity;
      this.allMetaForPdfObj['moSev'] = this.allMetalInfo[i].mo.severity;

      this.allMetaForPdfObj['naSev'] = this.allMetalInfo[i].na.severity;
      this.allMetaForPdfObj['niSev'] = this.allMetalInfo[i].ni.severity;
      this.allMetaForPdfObj['pSev'] = this.allMetalInfo[i].p.severity;
      this.allMetaForPdfObj['pbSev'] = this.allMetalInfo[i].pb.severity;

      this.allMetaForPdfObj['siSev'] = this.allMetalInfo[i].si.severity;
      this.allMetaForPdfObj['snSev'] = this.allMetalInfo[i].sn.severity;
      this.allMetaForPdfObj['znSev'] = this.allMetalInfo[i].zn.severity;

      this.allMetalForPdfArrar.push(this.allMetaForPdfObj);
      this.allMetaForPdfObj = {};
    }

    let document = {
      footer: {
        columns: [
          {
            image: 'data:image/png;base64,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',
            width: 30,
            margin: [40, -5, 40, 0]
          },

          { fontSize: 6, margin: [75, 0, 40, 0], text: "* Indicates results recorded via FT-IR.\n Disclaimer: All information including recommended actions are provided on an “as is” basis.  No warranty is expressed or implied. Cummins expressly disclaims any and all warranties and liability arising from or otherwise related to information provided herein.  See the Marketplace Terms and Conditions of Use for more details regarding such disclaimers. \n FluidWatch® \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t fluidwatch.laboratory@cummins.com", alignment: 'justify' }
        ]
      },
      content: [
        {
          table: {
            body: [
              [

                {
                  fontSize: 10, bold: true, border: [true, true, false, false],
                  table: {
                    widths: [110],
                    //heights: [29],

                    body: [
                      [
                        {
                          image: this.getAddressImage(),
                          width: 110,
                          //height: 50,
                          border: [false, false, false, false]
                        },
                      ]
                    ]
                  }, layout: {
                    hLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    },

                  }
                },
                {
                  fontSize: 10, bold: true, border: [false, true, false, false],
                  table: {
                    widths: [70, 70, 70],
                    body: this.getHeaderBody()
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.body.length) ? 2 : 2;
                    },
                    vLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.widths.length) ? 2 : 2;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    },

                  }
                }
                ,
                {
                  fontSize: 8, bold: true, border: [false, true, true, false],
                  table: {
                    widths: [24, 33, 37],

                    body: [
                      [{ fillColor: '#DA291C', text: '' }, 'Red', 'Warning'],
                      [{ fillColor: '#F19806', text: '' }, 'Orange', 'Caution'],
                      [{ fillColor: '#F8E71C', text: '' }, 'Yellow', 'Watch'],
                      [{ fillColor: '#0AB50A', text: '' }, 'Green', 'Normal'],
                    ]
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.body.length) ? 2 : 2;
                    },
                    vLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.widths.length) ? 2 : 2;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    },

                  }
                }
              ]
            ]
          },

        },
        {
          style: 'tableContentSmi', margin: [0, 0, 0, 0],
          table: {
            body: [[{
              fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Customer & Unit Information',
              border: [false, true, true, false]
            },
            {
              fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Fluid & Filter Information',
              border: [false, true, true, false]
            }
              , {
              fillColor: '#696969', color: '#FFFFFF', alignment: 'center', bold: true, text: 'Sample Information',
              border: [false, true, false, false]
            }],
            [{
              border: [false, false, false, false], margin: [-4.5, -2, -4.5, -4],
              table: {
                widths: [78, 78],
                body: [

                  ['Company ID', this.buildTableBody(this.showMoreInforItemArr, ['companyId'])],
                  ['Company Name', this.buildTableBody(this.showMoreInforItemArr, ['companyName'])],
                  ['Customer Name', this.buildTableBody(this.showMoreInforItemArr, ['customerName'])],
                  ['Phone Number', this.buildTableBody(this.showMoreInforItemArr, ['phoneNumber'])],
                  ['Component ID', this.buildTableBody(this.showMoreInforItemArr, ['componentId'])],
                  ['Unit Make', this.buildTableBody(this.showMoreInforItemArr, ['unitMake'])],
                  ['Unit Model', this.buildTableBody(this.showMoreInforItemArr, ['unitModel'])],
                  ['Unit Year', this.buildTableBody(this.showMoreInforItemArr, ['unitYear'])],
                  ['Equipment Serial No', this.buildTableBody(this.showMoreInforItemArr, ['esn'])]

                ]
              },
              layout: {
                hLineWidth: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
                },
                vLineWidth: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
                },
                hLineColor: function (i, node) {
                  return 'lightGray';
                },
                vLineColor: function (i, node) {
                  return 'lightGray';
                },

                fillColor: function (rowIndex, node, columnIndex) {
                  return (rowIndex % 2 != 0) ? '#CCCCCC' : null;
                }
              }
            },
            {
              border: [false, false, false, false], margin: [-4.5, -2, -4.5, -3],

              table: {
                widths: [78, 78],

                body: [

                  ['Fluid Brand', this.buildTableBody(this.showMoreInforItemArr, ['fluidBrand'])],
                  ['Fluid Product', this.buildTableBody(this.showMoreInforItemArr, ['fluidProduct'])],
                  ['Fluid Grade', this.buildTableBody(this.showMoreInforItemArr, ['fluidGrade'])],
                  ['Filter Brand', this.buildTableBody(this.showMoreInforItemArr, ['filterBrand'])],
                  ['Filter Product', this.buildTableBody(this.showMoreInforItemArr, ['filterProduct'])],
                  ['Sampled Location', this.buildTableBody(this.showMoreInforItemArr, ['sampledLocation'])],
                  ['Tracking Number', this.buildTableBody(this.showMoreInforItemArr, ['trackingNumber'])],
                  ['Sample Remarks', this.buildTableBody(this.showMoreInforItemArr, ['sampleRemarks'])]

                ]
              },
              layout: {
                hLineWidth: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
                },
                vLineWidth: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
                },
                hLineColor: function (i, node) {
                  return 'lightGray';
                },
                vLineColor: function (i, node) {
                  return 'lightGray';
                },

                fillColor: function (rowIndex, node, columnIndex) {
                  return (rowIndex % 2 != 0) ? '#CCCCCC' : null;
                }
              }
            },
            {
              border: [false, false, false, false], margin: [-4.5, -2, -5, -4],

              table: {

                widths: [78, 77],

                body: [

                  ['Sample ID', this.buildTableBody(this.showMoreInforItemArr, ['sampleId'])],
                  ['QR Code	', this.buildTableBody(this.showMoreInforItemArr, ['qrCodeId'])],
                  ['Sampled Date', this.buildTableBody(this.showMoreInforItemArr, ['sampledDate'])],
                  ['Received Date', this.buildTableBody(this.showMoreInforItemArr, ['receivedDate'])],
                  ['Completed Date', this.buildTableBody(this.showMoreInforItemArr, ['completedDate'])],
                  ['Component Make', this.buildTableBody(this.showMoreInforItemArr, ['engineMake'])],

                  ['Component Model', this.buildTableBody(this.showMoreInforItemArr, ['engineModel'])],
                  ['Component Year', this.buildTableBody(this.showMoreInforItemArr, ['engineYear'])],

                  ['Component Serial No', this.buildTableBody(this.showMoreInforItemArr, ['gsn'])]

                ]
              },
              layout: {
                hLineWidth: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
                },
                vLineWidth: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
                },
                hLineColor: function (i, node) {
                  return 'lightGray';
                },
                vLineColor: function (i, node) {
                  return 'lightGray';
                },

                fillColor: function (rowIndex, node, columnIndex) {
                  return (rowIndex % 2 != 0) ? '#CCCCCC' : null;
                }
              }
            }],
            ]
          }
        },

        {
          style: 'analysisAndAction', margin: [0, 0, 0, 0],
          border: [true, false, false, false],

          table: {
            widths: [336.7, 163.3],

            body: [
              [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Analysis' },
              { fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Recommended Actions' }],
              [
                {
                  fontSize: 8, heights: 50, bold: false, text: [this.analysisComment,

                  ]

                },

                {
                  fontSize: 8, heights: 50, bold: false, text: [this.actionComment
                  ]
                }
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }
          }
        },

        //two graph
        {
          style: 'analysisAndAction', margin: [0, 0, 0, 0],
          border: [true, false, false, false],

          table: {
            widths: [250, 250],

            body: [
              [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: this.yAxisLabelPDF1 },
              { fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: this.yAxisLabelPDF2 }],
              [
                {
                  image: this.imageData1,
                  width: 250,
                  margin: [10, 0, 0, 0]
                },

                {
                  image: this.imageData2,
                  width: 250

                }
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }

          }
        },
        {
          style: 'analysisAndAction', margin: [0, 0, 0, 0],
          //border: [true, false, false, false],

          table: {
            widths: [508],

            body: [
              [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Oil Health' },
              ],
              [
                {
                  image: this.oilHealthInfoImg,
                  width: 515,
                  margin: [-3.5, -2, 0, 0]
                },

              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }

          }
        },
        {
          style: 'analysisAndAction', margin: [0, 0, 0, 0],
          //border: [true, false, false, false],

          table: {
            widths: [508],

            body: [
              [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'All Metals Information (ppm)' },
              ],
              [
                {
                  image: this.allMetalInfoImg,
                  width: 515,
                  margin: [-3.5, -2, 0, 0]
                },

              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }

          }
        },

      ],

      styles: {
        header: {
          fontSize: 8,
          bold: true,
        },
        tableContentSmi: {
          fontSize: 8
        },
        tableContentOilHealth: {
          fontSize: 7,
          alignment: 'center'

        },
        tableContentMetal: {
          fontSize: 6.35,
          alignment: 'center',
          border: true
        },
        analysisAndAction: {
          fontSize: 8,
          bold: true,

        },
        disclaimer: {
          fontSize: 6,
          bold: true
        }
      }

    };
    pdfMake.createPdf(document).download(this.currentItem.sampleId);

  }
  backButton() {
    this.displayBackButton = false;
    this.viewGraph.emit();
  }

  downloadPDFForCoolant() {
    this.isDisabledSelectThumbnails = true;
    this.loaderService.show();
    document.getElementById('analysisAction').style.overflow = 'visible';
    // document.getElementById('analysisAction').style.width = 'auto';
    document.getElementById('coolant1').style.overflow = 'visible';
    document.getElementById('coolant1').style.width = '1458.7px';
    document.getElementById('coolant2').style.overflow = 'visible';
    document.getElementById('coolant2').style.width = '1458.7px';
    document.getElementById('coolant0').style.overflow = 'visible';
    document.getElementById('coolant0').style.width = '1458.7px';
    document.getElementById('coolant3').style.overflow = 'visible';
    document.getElementById('coolant3').style.width = '1458.7px';

    let self = this;
    html2canvas(document.getElementById('analysisAction')).then(function (canvas) {
      const analysisactionImage = canvas.toDataURL('image/png');
      self.addanalysisactionImg(analysisactionImage);
      html2canvas(document.getElementById('coolant1')).then(function (canvas) {
        const coolant1Image = canvas.toDataURL('image/png');
        self.addCoolant1Img(coolant1Image);
        html2canvas(document.getElementById('coolant2')).then(function (canvas) {
          const coolant2Image = canvas.toDataURL('image/png');
          self.addCoolant2Img(coolant2Image);
          html2canvas(document.getElementById('coolant0')).then(function (canvas) {
            const coolant0Image = canvas.toDataURL('image/png');
            self.addCoolant0Img(coolant0Image);
            html2canvas(document.getElementById('coolant3')).then(function (canvas) {
              const coolant3Image = canvas.toDataURL('image/png');
              self.addCoolant3Img(coolant3Image);
              html2canvas(document.getElementById('coolant4')).then(function (canvas) {
                document.getElementById('analysisAction').style.overflow = 'auto';
                document.getElementById('analysisAction').style.width = 'auto';
                document.getElementById('coolant1').style.overflow = 'auto';
                document.getElementById('coolant1').style.width = 'auto';
                document.getElementById('coolant2').style.overflow = 'auto';
                document.getElementById('coolant2').style.width = 'auto';
                document.getElementById('coolant0').style.overflow = 'auto';
                document.getElementById('coolant0').style.width = 'auto';
                document.getElementById('coolant3').style.overflow = 'auto';
                document.getElementById('coolant3').style.width = 'auto';
                const coolant4Image = canvas.toDataURL('image/png');
                self.addCoolant4Img(coolant4Image);
                self.generatePdfForCoolant();
                self.loaderService.hide();
              });
            });
          });
        });
      });
    });

  }

  generatePdfForCoolant() {
    this.showMoreInforItemArr = [];
    this.showMoreInforItemArr.push(this.showMoreInformationData);
    let self = this;
    let pdfDocument = {
      pageMargins: [40, 110, 40, 40],
      header: function (page) {
        if (page != 1) {
          return {
            columns: [
              {
                image: self.coolant0Img,
                width: 516,
                margin: [40, 40, 40, 5],
                height: 70,
                border: [true, true, true, true]
              }
            ]
          };
        }

      },

      footer: {
        columns: [
          {
            image: this.addressImageService.getFooterLogo(),
            width: 30,
            margin: [40, -5, 40, 0]
          },
          { fontSize: 6, margin: [75, 0, 40, 0], text: "* Indicates results recorded via test strip method.\n Disclaimer: All information including recommended actions are provided on an “as is” basis.  No warranty is expressed or implied. Cummins expressly disclaims any and all warranties and liability arising from or otherwise related to information provided herein.  See the Marketplace Terms and Conditions of Use for more details regarding such disclaimers. \n FluidWatch® \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t fluidwatch.laboratory@cummins.com", alignment: 'justify' }
        ]
      },
      content: [
        {
          margin: [0, -70, 0, 0],
          table: {
            body: [
              [

                {
                  fontSize: 10, bold: true, border: [true, true, false, false],
                  table: {
                    widths: [110],
                    //heights: [29],

                    body: [
                      [
                        {
                          image: this.getAddressImage(),
                          width: 110,
                          //height: 50,
                          border: [false, false, false, false]
                        },
                      ]
                    ]
                  }, layout: {
                    hLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    },

                  }
                },
                {
                  fontSize: 10, bold: true, border: [false, true, false, false],
                  table: {
                    widths: [70, 70, 70],
                    body: this.getHeaderBody()
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.body.length) ? 2 : 2;
                    },
                    vLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.widths.length) ? 2 : 2;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    },

                  }
                }
                ,
                {
                  fontSize: 8, bold: true, border: [false, true, true, false],
                  table: {
                    widths: [24, 33, 37],

                    body: [
                      [{ fillColor: '#DA291C', text: '' }, 'Red', 'Warning'],
                      [{ fillColor: '#F19806', text: '' }, 'Orange', 'Caution'],
                      [{ fillColor: '#F8E71C', text: '' }, 'Yellow', 'Watch'],
                      [{ fillColor: '#0AB50A', text: '' }, 'Green', 'Normal'],
                    ]
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.body.length) ? 2 : 2;
                    },
                    vLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.widths.length) ? 2 : 2;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    },

                  }
                }
              ]
            ]
          },

        },
        {
          style: 'tableContentSmi', margin: [0, 0, 0, 0],
          table: {
            body: [
              [{
                fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Customer & Unit Information',
                border: [false, true, true, false]

              },

              {
                fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Fluid & Filter Information',
                border: [false, true, true, false]
              }
                , {
                fillColor: '#696969', color: '#FFFFFF', alignment: 'center', bold: true, text: 'Sample Information',
                border: [false, true, false, false], margin: [0, 0, 0, 0]
              }],
              [{
                border: [false, false, false, false], margin: [-4.5, -2, -4.5, -4],
                table: {
                  widths: [78, 78],
                  body: [

                    ['Company ID', this.buildTableBody(this.showMoreInforItemArr, ['companyId'])],
                    ['Company Name', this.buildTableBody(this.showMoreInforItemArr, ['companyName'])],
                    ['Customer Name', this.buildTableBody(this.showMoreInforItemArr, ['customerName'])],
                    ['Phone Number', this.buildTableBody(this.showMoreInforItemArr, ['phoneNumber'])],
                    ['Component ID', this.buildTableBody(this.showMoreInforItemArr, ['componentId'])],
                    ['Unit Make', this.buildTableBody(this.showMoreInforItemArr, ['unitMake'])],
                    ['Unit Model', this.buildTableBody(this.showMoreInforItemArr, ['unitModel'])],
                    ['Unit Year', this.buildTableBody(this.showMoreInforItemArr, ['unitYear'])],
                    ['Equipment Serial No', this.buildTableBody(this.showMoreInforItemArr, ['esn'])]

                  ]
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
                  },
                  vLineWidth: function (i, node) {
                    return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
                  },
                  hLineColor: function (i, node) {
                    return 'lightGray';
                  },
                  vLineColor: function (i, node) {
                    return 'lightGray';
                  },

                  fillColor: function (rowIndex, node, columnIndex) {
                    return (rowIndex % 2 != 0) ? '#CCCCCC' : null;
                  }
                }
              },
              {
                border: [false, false, false, false], margin: [-4.5, -2, -4.5, -3],

                table: {
                  widths: [78, 78],

                  body: [

                    ['Fluid Brand', this.buildTableBody(this.showMoreInforItemArr, ['fluidBrand'])],
                    ['Fluid Product', this.buildTableBody(this.showMoreInforItemArr, ['fluidProduct'])],
                    ['Fluid Grade', this.buildTableBody(this.showMoreInforItemArr, ['fluidGrade'])],
                    ['Filter Brand', this.buildTableBody(this.showMoreInforItemArr, ['filterBrand'])],
                    ['Filter Product', this.buildTableBody(this.showMoreInforItemArr, ['filterProduct'])],
                    ['Sampled Location', this.buildTableBody(this.showMoreInforItemArr, ['sampledLocation'])],
                    ['Tracking Number', this.buildTableBody(this.showMoreInforItemArr, ['trackingNumber'])],
                    ['Sample Remarks', this.buildTableBody(this.showMoreInforItemArr, ['sampleRemarks'])]

                  ]
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
                  },
                  vLineWidth: function (i, node) {
                    return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
                  },
                  hLineColor: function (i, node) {
                    return 'lightGray';
                  },
                  vLineColor: function (i, node) {
                    return 'lightGray';
                  },

                  fillColor: function (rowIndex, node, columnIndex) {
                    return (rowIndex % 2 != 0) ? '#CCCCCC' : null;
                  }
                }
              },
              {
                border: [false, false, false, false], margin: [-4.5, -2, -5, -4],

                table: {

                  widths: [78, 77],

                  body: [

                    ['Sample ID', this.buildTableBody(this.showMoreInforItemArr, ['sampleId'])],
                    ['QR Code	', this.buildTableBody(this.showMoreInforItemArr, ['qrCodeId'])],
                    ['Sampled Date', this.buildTableBody(this.showMoreInforItemArr, ['sampledDate'])],
                    ['Received Date', this.buildTableBody(this.showMoreInforItemArr, ['receivedDate'])],
                    ['Completed Date', this.buildTableBody(this.showMoreInforItemArr, ['completedDate'])],
                    ['Component Make', this.buildTableBody(this.showMoreInforItemArr, ['engineMake'])],

                    ['Component Model', this.buildTableBody(this.showMoreInforItemArr, ['engineModel'])],
                    ['Component Year', this.buildTableBody(this.showMoreInforItemArr, ['engineYear'])],

                    ['Component Serial No', this.buildTableBody(this.showMoreInforItemArr, ['gsn'])]

                  ]
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
                  },
                  vLineWidth: function (i, node) {
                    return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
                  },
                  hLineColor: function (i, node) {
                    return 'lightGray';
                  },
                  vLineColor: function (i, node) {
                    return 'lightGray';
                  },

                  fillColor: function (rowIndex, node, columnIndex) {
                    return (rowIndex % 2 != 0) ? '#CCCCCC' : null;
                  }
                }
              }],
            ]
          },
        },

        {
          style: 'analysisAndAction', margin: [0, 0, 0, 0],
          table: {
            widths: [336.7, 163.3],

            // body: [
            //   [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Analysis' },
            //   { fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Recommended Actions' }],
            //   [
            //     {
            //       fontSize: 8, heights: 50, bold: false, text: [this.analysisComment,

            //       ]

            //     },

            //     {
            //       fontSize: 8, heights: 50, bold: false, text: [this.actionComment
            //       ]
            //     }
            //   ]
            // ]

            //superscript img
            body: [
              [
                {
                  image: self.analysisactionImg,
                  width: 516,
                  heights: 50,
                  fontSize: 8,
                  bold: false,
                  margin: [-3.5, -2, 5.0, 0],
                  border: [true, true, true, true]
                },
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }

          }
        },

        {
          style: 'analysisAndAction', margin: [0, 0, 0, 0],

          table: {
            widths: [508],

            body: [
              // [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Oil Health' },
              // ],
              [
                {
                  image: this.coolant1Img,
                  width: 515,
                  margin: [-3.5, -2, 0, 0]
                },

              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }

          }
        },
        {
          //style: 'analysisAndAction', 
          margin: [0, 0, 0, 0],

          table: {
            widths: [508],

            body: [
              // [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'All Metals Information (ppm)' },
              // ],
              [
                {
                  image: this.coolant2Img,
                  width: 515,
                  margin: [-3.5, -2, 0, -2]
                },

              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }

          }
        },

        {
          style: 'analysisAndAction',
          margin: [0, 0, 0, 0],

          table: {
            widths: [508],

            body: [
              // [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'All Metals Information (ppm)' },
              // ],
              [
                {
                  image: this.coolant3Img,
                  width: 515,
                  margin: [-3.5, -2, 0, -2]
                },

              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }

          }
        },
        {
          style: 'analysisAndAction', margin: [0, 0, 0, 0],

          table: {
            widths: [508],

            body: [
              // [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'All Metals Information (ppm)' },
              // ],
              [
                {
                  image: this.coolant4Img,
                  width: 515,
                  margin: [-3.5, -2, 0, 0]
                },

              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }

          }
        },

        this.buildTwoGraphForCoolant(),
        this.buildFourGraphForCoolant(),

      ],

      styles: {
        header: {
          fontSize: 8,
          bold: true,
        },
        tableContentSmi: {
          fontSize: 8
        },
        tableContentOilHealth: {
          fontSize: 6.8,
          alignment: 'center'

        },
        tableContentMetal: {
          fontSize: 6.5,
          alignment: 'center',
          border: true
        },
        analysisAndAction: {
          fontSize: 8,
          bold: true
        },
        disclaimer: {
          fontSize: 6,
          bold: true
        }
      }

    };

    // console.log(pdfDocument);

    pdfMake.createPdf(pdfDocument).download(this.currentItem.sampleId);
    this.isDisabledSelectThumbnails = false;
  }

  downloadPDFForLubricants() {
    this.isDisabledSelectThumbnails = true;
    this.loaderService.show();

    document.getElementById('metalInfoLubricant').style.overflow = 'visible';
    document.getElementById('metalInfoLubricant').style.width = '1458.7px';

    let self = this;
    html2canvas(document.getElementById('oilHealthLubricant')).then(function (canvas) {
      const oilHealthLubricantImage = canvas.toDataURL('image/png');
      self.AddImagesOilHealthInfoLubricant(oilHealthLubricantImage);

      html2canvas(document.getElementById('metalInfoLubricant')).then(function (canvas) {
        document.getElementById('metalInfoLubricant').style.overflow = 'auto';
        document.getElementById('metalInfoLubricant').style.width = 'auto';

        const allMetalInfoTable = canvas.toDataURL('image/png');
        self.AddImagesAllMetalInfoLubricant(allMetalInfoTable);
        self.generatePdfForLubricant();
        self.loaderService.hide();
      });

    });
  }

  generatePdfForLubricant() {
    this.oilHealthForPdfFinalArray = [];
    this.showMoreInforItemArr = [];
    this.allMetalForPdfArrar = [];
    this.showMoreInforItemArr.push(this.showMoreInformationData);

    for (let i = 0; i < this.oilHealth.length; i++) {
      this.oilHealthArrForPdf['sampleId'] = this.oilHealth[i].sampleId;
      this.oilHealthArrForPdf['sampledDate'] = this.oilHealth[i].sampledDate;
      this.oilHealthArrForPdf['engineMiles'] = this.oilHealth[i].engineMiles;
      this.oilHealthArrForPdf['oilMiles'] = this.oilHealth[i].oilMiles;
      this.oilHealthArrForPdf['nitration'] = this.oilHealth[i].nitration.value;
      this.oilHealthArrForPdf['oxidation'] = this.oilHealth[i].oxidation.value;
      // this.oilHealthArrForPdf['soot'] = this.oilHealth[i].soot.value;
      // this.oilHealthArrForPdf['fuelDilution'] = this.oilHealth[i].fuelDilution.value;
      this.oilHealthArrForPdf['tan'] = this.oilHealth[i].tan.value;
      // this.oilHealthArrForPdf['tbn'] = this.oilHealth[i].tbn.value;
      this.oilHealthArrForPdf['vis40'] = this.oilHealth[i].vis40.value;
      // this.oilHealthArrForPdf['vis100'] = this.oilHealth[i].vis100.value;
      this.oilHealthArrForPdf['water'] = this.oilHealth[i].water.value;
      this.oilHealthArrForPdf['waterFTIR'] = this.oilHealth[i].water_FTIR.value;

      this.oilHealthArrForPdf['niSev'] = this.oilHealth[i].nitration.severity;
      this.oilHealthArrForPdf['oxSev'] = this.oilHealth[i].oxidation.severity;
      this.oilHealthArrForPdf['pcSev'] = this.oilHealth[i].particle_count.severity;
      this.oilHealthArrForPdf['vis40Sev'] = this.oilHealth[i].vis40.severity;
      // this.oilHealthArrForPdf['vis100Sev'] = this.oilHealth[i].vis100.severity;
      // this.oilHealthArrForPdf['sootSev'] = this.oilHealth[i].soot.severity;
      this.oilHealthArrForPdf['tanSev'] = this.oilHealth[i].tan.severity;
      // this.oilHealthArrForPdf['tbnSev'] = this.oilHealth[i].tbn.severity;
      this.oilHealthArrForPdf['waterSev'] = this.oilHealth[i].water.severity;
      this.oilHealthArrForPdf['waterFTIRSev'] = this.oilHealth[i].water_FTIR.severity;

      this.oilHealthForPdfFinalArray.push(this.oilHealthArrForPdf);
      this.oilHealthArrForPdf = {};
    }

    for (let i = 0; i < this.allMetalInfo.length; i++) {
      this.allMetaForPdfObj['sampleId'] = this.allMetalInfo[i].sampleId;
      this.allMetaForPdfObj['sampledDate'] = this.allMetalInfo[i].sampledDate;
      this.allMetaForPdfObj['ag'] = this.allMetalInfo[i].ag.value;
      this.allMetaForPdfObj['al'] = this.allMetalInfo[i].al.value;
      this.allMetaForPdfObj['b'] = this.allMetalInfo[i].b.value;
      this.allMetaForPdfObj['ba'] = this.allMetalInfo[i].ba.value;
      this.allMetaForPdfObj['bi'] = this.allMetalInfo[i].bi.value;
      this.allMetaForPdfObj['ca'] = this.allMetalInfo[i].ca.value;
      this.allMetaForPdfObj['cr'] = this.allMetalInfo[i].cr.value;
      this.allMetaForPdfObj['cu'] = this.allMetalInfo[i].cu.value;
      this.allMetaForPdfObj['fe'] = this.allMetalInfo[i].fe.value;
      this.allMetaForPdfObj['in'] = this.allMetalInfo[i].in.value;
      this.allMetaForPdfObj['k'] = this.allMetalInfo[i].k.value;

      this.allMetaForPdfObj['mg'] = this.allMetalInfo[i].mg.value;
      this.allMetaForPdfObj['mn'] = this.allMetalInfo[i].mn.value;
      this.allMetaForPdfObj['mo'] = this.allMetalInfo[i].mo.value;
      this.allMetaForPdfObj['na'] = this.allMetalInfo[i].na.value;
      this.allMetaForPdfObj['ni'] = this.allMetalInfo[i].ni.value;
      this.allMetaForPdfObj['p'] = this.allMetalInfo[i].p.value;
      this.allMetaForPdfObj['pb'] = this.allMetalInfo[i].pb.value;
      this.allMetaForPdfObj['si'] = this.allMetalInfo[i].si.value;
      this.allMetaForPdfObj['sn'] = this.allMetalInfo[i].sn.value;
      this.allMetaForPdfObj['zn'] = this.allMetalInfo[i].zn.value;

      this.allMetaForPdfObj['agSev'] = this.allMetalInfo[i].ag.severity;
      this.allMetaForPdfObj['alSev'] = this.allMetalInfo[i].al.severity;

      this.allMetaForPdfObj['bSev'] = this.allMetalInfo[i].b.severity;
      this.allMetaForPdfObj['baSev'] = this.allMetalInfo[i].ba.severity;
      this.allMetaForPdfObj['biSev'] = this.allMetalInfo[i].bi.severity;
      this.allMetaForPdfObj['caSev'] = this.allMetalInfo[i].ca.severity;
      this.allMetaForPdfObj['crSev'] = this.allMetalInfo[i].cr.severity;

      this.allMetaForPdfObj['feSev'] = this.allMetalInfo[i].fe.severity;
      this.allMetaForPdfObj['cuSev'] = this.allMetalInfo[i].cu.severity;

      this.allMetaForPdfObj['inSev'] = this.allMetalInfo[i].in.severity;
      this.allMetaForPdfObj['kSev'] = this.allMetalInfo[i].k.severity;
      this.allMetaForPdfObj['mgSev'] = this.allMetalInfo[i].mg.severity;
      this.allMetaForPdfObj['mnSev'] = this.allMetalInfo[i].mn.severity;
      this.allMetaForPdfObj['moSev'] = this.allMetalInfo[i].mo.severity;

      this.allMetaForPdfObj['naSev'] = this.allMetalInfo[i].na.severity;
      this.allMetaForPdfObj['niSev'] = this.allMetalInfo[i].ni.severity;
      this.allMetaForPdfObj['pSev'] = this.allMetalInfo[i].p.severity;
      this.allMetaForPdfObj['pbSev'] = this.allMetalInfo[i].pb.severity;

      this.allMetaForPdfObj['siSev'] = this.allMetalInfo[i].si.severity;
      this.allMetaForPdfObj['snSev'] = this.allMetalInfo[i].sn.severity;
      this.allMetaForPdfObj['znSev'] = this.allMetalInfo[i].zn.severity;

      this.allMetalForPdfArrar.push(this.allMetaForPdfObj);
      this.allMetaForPdfObj = {};
    }

    let pdfDocument = {
      footer: {
        columns: [
          {
            image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWgAAAFMCAYAAADm2Cb1AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAJ2VJREFUeNrsnT9020a2h8dxCm+1XFfuQp9t/KqVOr/KVOetInVJZbJLZ6l8laRqz6tkV7uuRFf7Ukmq9qUSXb1sJblLij2mu2xlukuqvLnihQPTAAjMDIAB8X3nwJT5BwQHgx/u3Ln3zi0D0BB//GK4ZR8Gum3p079P/W1WXoO4OLfbS7td/+vtfB6wX8g5P7TbfgfaYGZ/+05TX/Y5fQ5qEOCRPvVIH0e0TqdZ2G3PCtOshj6zax9O7DakmRFoCHNRjfSCGqoID7nANpaZivMicB+S/nLKzRuBBn8xFsv4T/qI+6E/TK0wT2roU0f24amOtgCBhgpWzUjFeIQYI8413OxP6FcINJS7YLZUiB/pRTOkVcAsJ8ImFfvSIHVTv9Z9LFKvdWUSEIGG1gRZLpRdFeQRggwZ3EwIVuxX+yrAaZfF3D6/o4J9anBnINCQayU/MbgsoByTKhOCtn+J+I4zXpKb/1UJYZ7Z7ZU+pvlSjYleGxG36I8bKcq7qQ6O5QJlkfjm7Yr97MzheySe+kIe190M7HeI+J9E1I+JgwZEGVrhecX3VxmRzXX/51WSXOx7p7Zvz/RG0LsRIAKNKAOkLdsqlHGFTO320ifJRQRd/dmXfRNpXBzdE2XpoE8RZQjM3Arh/Yp9Ufrfm4x+KFEckhI+DZngon3/suV+j4sDPumYQxVkEeYhLQJ1CLSDZbtQy/ZQn3qlAnZdxwHKfu33HZulTxoLGloXZhHlJyrOABtjGXpeF2JFj7CgoY3OJ8O3MdYyNEyXfLvPTU9qeHxGv4xGmIcaU/rOUN0LmmegrrTosRasTGbOEWhoQphHOmR7Y7ID/gGaokuutFkfTggujvaEWcT4EEsZAiOWpUzSvU49lyyKsM4tIG61Zx35nW8RaECYoQtIKNvULOONrwv6XlKLJa//iZttLMkhHbGgDzf9xBLF0Ywoy4UhBWWeIMwQGAk7e1Y13jinwFEi9vdDF+hfuUEktcXlOy5cbghq6Jy2cWMgimPzLOaYagnAZiCW8sQ15th+7pmmUJ+aT9eElLTqnUD9PxHlpGDXKrv2PY8cak/3wtBhkrBGYbbbG0OpRQiPWJw7vgkh+vkdFfs0I40o8un/u6mopHVLW40dIkge9eFE4+IIL8wsggm1inMNK51IX80qDSrCvVe2uFGqtK1LmdCdsvU69HjftNT+uDg6KsxiIRwaFsGEDomzWtJSjEiK9F+uvCSC+8a+Jha7lAe9Tov1ynqVvrVh5hXeO+7LCceCDmN9HBpimKFertXKXNTYl2Xk18ayVFKCdK/kMeYVaNpICxoftHtnHujqxFeIMzTAQZ3irBybT/3RXmJmt/tr9nkz2Vlhn72a00Gg3cR5V4X50DAB2BdEvPZa+u5zn3rKZdEbQCgXitxQdtQlIhbnNOM9z6qMCjQiqleFw3BxVBPmoVlOAFJdrj+IwEwSgWzJDbDThECn+vmRcU8CKQz/U7/1zfsqrn0YQy3om1FBky4OBLp8B9nHYu4dYuEdp4VEfaAyehrWKQLmt8nmyoX0A/V3+Y1VK9xJWx3VcCyxiHPjAo2Lo0Tn0M5Kskl/EEGW8LJP/L6B3QBZ1ue2CsAsJdZtsGfKLWmVjDJ2eiDOjYNArx/quVgS0F2klOV9LWmZibobjmuw1tPJJ3sqfG8L+ufNRLUkRNntV308UivfC/Udl/mNU72pzGq4/notzrg4ijvGKcLcO6v5oEpdCEc3QJb1OckSOO2HJsufu0a8FiZApqF+T97qJQs97vOarsGxaafWRlQuDgQ622o+pCV6xUzFZu5wI7/ytNYnDoWOyliWQUQ6J+54rlZzXQWVRJhjnYjHB92SMA/VIkKc+0U6HKyqG0DE78DRWhcf956jyJWJBZbXLxMr3MPVkeVzH5oaMmY1wuPKECWFQGcMp/A19w9JnW66QP1Mrc9zx766VaGf3lSm8/VJ67FOV28SvuKftpo1fPHSUMMGgV7pGKeGinN9ZaxJR64jLhGUkwpWs7O1nqKq5ToMNCo8MB/XywhioatxJC6UfbojAr1qicgFNqYb9JrTqhZmasRVViyTOhptLSe173ojWuPqSER63+H6oxwvAl14gV3i0gAVh9OS/UZGXGcOohJy2O466XcawNUxM5+uWSj7PJHRxLqbgOYUnKSEGXfGGnoXxaEuDaxmWGVSFGKn4uNj7QWrRmeP5Z3jcZSuGrfm+4vma+T3iZCnF619pO/fBEu50SiO2z0S5sHdweD/7J+P0SLIYGT7x7fv3i8WGf3mL2o53vHY/z27PbD7/9b3QO3x/M64RVE8sJ99a4/h2vP7/2kfvsl5WdrogR5fsg092y4m5rb9XuLiCCvON4XHcWlAFVdHKuyrrI/1JnzOLOObs9jVOHtfnpnyadirnDgsL7Xq6hCBP6bLINAhxHlsspfzAfjEik4EVB+rhH2lU8QnBQJ6mKro5iqQyY0gyI3I8RiOTHt1QhDoDRHnExNnuijEy2HFhKUk5flD0kmJgkpnNU3YVb4ReTLxsOShBBvpg1a/4V9Nvp8MoIh7Jd8nIvnnrDoa794vfrB9UET4Ycbnbvy0vv5o+/nv7HfsVjjej0TafvbC7uMnj+9f2H382/Qr8w8ftK84G+KboX7KJJ2Inzbv9V2X+OEcK9aVEK6OqcHVgUCXFOck+YTJQKiLpGbzWvdCCV/xYcsTdlvqBvS55o4MK9nXxsa4OFLiPOS0Qk3IiiFfV3ELyHvvDga3ckRMXB1bvkNm+/mZ/Y6RY99/aD/7yu5jXvV6s5/7h/3zq571AVwcHuJMpAbUclEajxVD9HN5sccxTNhVyjJU1wzFxRDoUp1lF3GGmnkeYMWQdaF3vmVB5Sbi6uoQy/ukxLVWtUAUeNJpF4fGOP/dbE6WEsSJuAG+84x4EFfHLyY/k/WhZjL+7PEd39t9iNA/cPi4uCxeS/RJwbV25rjvjRpN4eIoL87EOEMThErukInFPEtchDVEWdCgrg6PAlHQV4FGnKEFthrwFe8HyjJ0Db0bqJWcXGfiPpQSCaxw0hKdc3EgztAioZI7fjT50Q/yHS89XR1FSTLrGErUid2+NP4FojYRXByIM0RMqCWk8goqDQP18aIkmXWIq4UVTiKgMwKdqscL0CZDE85XnCeguzWtgAIdoxMuDg1BOmO4BaGGqWrBXtjtud1e2O2tWcYqSx9bV9vCKbljxQ3xs0RNmPySBI/t6y88XR3zgiQZcOw7Tbo4ol9RhSQUCMjULGOar9f0ObGSn6p45vU7sVDv+66QoqnWee6EIKt3rFkBBarR6IoqUbs4EGcIKMwippN14qzugbndZBXrbZMfFhck9M4sfcVFWYZtF1QCXByZ4pyE/Aw5TeCIWLdfW7H979WlrEq6CBYynC1wE3gvIaWujqIlpB5mLcVV8TskSea9Ybm3zrk4orSgUyVDGZaBK8kiree+O9JaGnlWaN1LSH0Um+zxHUVJMhApsbo4ThBnCCDO16F2qHWPpzkCGmoJqbzj9U6S0QQYrikE2tt6FnEec2rAkWQJquBLMYkPO0dEQ/mK90zggkqaqn1imMtBoAOIswgzAfLgwySk5Zy1/xwRPWmgIt1ZxbKgcjxXXFMIdAhx3jIkooAf0xA+5zUiWuQvDlVQqSjL8LDk9XSk4jykW3SXKKI41CqQzkQiCrgiVu2ffRI7yqJlPUcZ4ndPIj5khROf/UtpU7OM6si6HgqTZHq80klT9DKKA/8Y+HJeh9+5gDxXx2EDFekyXR3qByf6aYNoXaB1AoMOBb48b/LL1F+cJ6KngQoqTXNe/ihyRCcCk5VOMHQQ6GDiPDZMYECAYWfNE4NFIprlLx6aMMtCSTbjPOe1m4JKqZrNI7oBAh1SnLcMa5tBGGZr+tqR3d7Y7VfdrnyrxaXIc3WMG6hId6YbVjMCHRyW0IFQvM0R5oEWCjo0H0/o3VRHtK+FiLoQEd3L6+MBXB1y83nGKe4nrURxqN+ZZXSgDOK6+F+zLA36Sre53twT8ZNVTr5fFWezfsJMIh6G9rMXPgeoZT2zVjCRKIwH9vVvPff/nd2/XC/36A6t02gUx+ctiLN0NPzOUHgR2E0ugqlOxuX1pZFax1lW6r4pN/ksrogkS9CHYzU6hivPi594X+ObfXhuyBPoHY3Wg1ar5g2uDchB3AXPtS5FlX41XBVy8Tmbakkae75JLqnMvazftV10s1mz3yMTZhUX8Gej60Hjd4YiV8ZOVXEWcoRvWLVv1liVzqmgkgh+yocOPaQxgVbXBn5nyOLcBK4+50DdVelGVSrSkXQCjQm0ujbwn0EW4mfeqyEL0MWdUHdVurUV6Ug6gTYsaFwbkMV1gMm5IqvchcOaq9Llht6RdAKNCzSuDchBLMw6J1tcU79DuTryVjAR8T/MsJpJOoFmBRrXBhRwUGdxoxK1lYvwXsFEyXN17CcFlfTxCiMGsqg1UeXuYPBX82nwPsC8RtfGB6Tsp0eCx6iorGfJ75cFYX802aU/Zf9D+/g3rOZu9d2NKDeqlsGY8wkZHDf4XUXLSK0jVFW6vIJKJGxBOwJtKIQES7LE8bypL/d0dYiIhohBltHCnK4AUQi0hioRvwkyUbZtPo4Lvm64sH7RhF0Z9gNVpTumO0BVgtfi0CEhmU/9RqzFiVZikz4hFmSyas6ioO+M7MNT85tPVvbzPFACi7g6XMsMiKtj5npjUYOFawKisKAPDZMefUbcF9uJOKsFKQJ7kFjQOSJ2oiIu1upIt7HdrkJEVJSorVyEa6p2Ej5H0gk4ETSKQ2sZ/A/N2ktEAL+2QnictXCrfe5aoxburZbf1LrM3xTsexSoLOgPdj/ienvg8PEH9rNv5XeUvBZ2DanaGzk67HIUBzHP/USs5fslqsGJFf16RcjGply0zzhQbLLPhN3JuoJKajXLdUDSCcQj0Oo/HNGkvbOaJeFkp4x/Vt6TUa3uSYXvO2xgGSlnV0cq6WRM14DYLGgmQfpFUh7UtxB91Zt628tIZRZUSvnQh3QNiEqgsZ57x7EVue2WyoOGqpVxYHImLEtwkhRUStVsJukEorWgSUrpFyHjmF1Ecld91774pJufqk9cxJmJQIhToPVCoYP2ixNfX3CKmccxeLkTClZAKcMnVekAYrSg6aT95NS3brLSdlnQI4+bBEC8Aq2+5yHN2EsGJsyE3dwEnrBzQFwdC04pbJoFjfXcb8SCDjH/IG4G7wk7z5vEAacTNkagidwAZew7YecZmyyEcHVMTYNV9gDqtqCxniFtxQ49BfLaw4rd0jhkX3B1QFTccrSe5WJ8Q/NtBDK8n9ntlfk0BVpcB49MueWYpNqb9xqDuqK168hsJ12kyfH75bee0S2gzn5et0DLkHLMuep2RzPLUp7nJc63TATKZFy6FGgWxxmp3C43/yvjVsdCbjDbHmVB5YZ0aggbha4KtF6s7zhPnbaYJy6Wporn6RoL1zvDUH3arn7lqct6hxoNQsIVRCXQLj5oLOfuMjUrtZqrINEO2jmnBW8LEXon+3edsBtXSaKRm466VRBniA4XgX5Ks3USqTo3CbHclFqoeSIdKsPOZ8Ku1E1CLfUrQzQSbIJAq2UypNk6Kc7PQu5QRTrPEt/XMEyf/ddZFjRZ6eTUULMZNsiCfkKTdY5paHFOsVdg5YZwdYibw/XYd3PKgoqRIRFIu3QN2BiB1gkiOnW3uHaZMAtk5Q5NmBV2JMtw7vjZwyQ+W61m8TOz0glspAWNOHePSd1fsMbK3Y1hBZTUSifUbIaNFWgmB7vFtMGC+kVWbqgVUFzLgoo4s9IJbK5AawA/HbxbPG/qi9ZYuQMTIDNPE2CuOa2AQGM9d53rppejWmPlUhYUoEaBxv/cLS7KjIrENxuo6H4ZK/cwQFlQnxVQADZPoHWSh1nvbjErOJ8iyhJmJpNm4pu9kv8HXMKqyNURoizoM8MKKIBAf+BLmqlzzHPEeWyyJ8zk/2daBMtXQIvKhm7pQqshbgK4OmDjWVssyV5Q77Cgo+FarcfXKRGWc7OlN9ItFclbOSOhMpN10xCx02vKhoYoqERZUGhldNpksaTPS1wEiHP7TM2ylOc853WJRT7SeN+8OhhliwFJsaHXAbIPReTzyoaKte5TFlT2+YhuAZvOOhcH7o2W79Z2u69FjuYl3AuZd3eHxX3rXudvaBwLKulxkXQCCLShylebSIGjnTLCXBN1r/NXuaCS+q+vDDH50HeBJjmlNWTYv1NjgaOyNLHO31nJsqByLFeGdTABgf4Asc/tifMs8H5drfBQZUP3cl5eG3qnCS4y4cgyVIBAp8D/3DyTOjIA1U3iut9QtTSKCiqNM4Q5vdIJE9WAQKcujgEWS+M8K7OAqweuGXhDU3/Z0JOkLKj2Pxm9sdIJINA5z3NhNMvc1JzCrOI/c/x4qLKhha6O1Eon1GwGMPlx0Lg3muU4xFqBJRCBfOMofiKgM5/jFPeN3YfciA5zjILQq8WLW4eMQwjdpxojM5NQazUMOReN8YeGBNo3Ay9IFpVGZGwFvGBke5uMEGqYZAVohayU4KFaWVAP85Wb37kVlL0mD0DD51wTPbwXoNUQzksHS36hIvzKLEuqIsSw0XyeM9SEeoZGSUxwOgX6dQvHIm4G1xXaD9XV4TzUU1fHdcm+Jjc08Z9fIMiAQFPjoA4kQuMgZUFOUm6G6xwrUwT8RIU0EXMRqmPfUDxxp9j97+mNoipJ7PK2o/U81N++tcZSlt/6vOmFBwBi4vbqE3cHgyP7cI+mCebO2LMi8yL95Lv3ix9sO4vQPbTbC/v/eYYL4Epfv5N66YHdvrGffWs/4yVc9vM/2f3cchwx3ZPP2n1Usmg16eTvBZa7/Kb/su31td33hRwjXQj6zK0Mq+0dzRKEqVn6axcFgnWlFvH5ijiX8c9OtNaFF54TdqXKhmq/Oiu4Gcy0HXBhAKRYjYMmOcWfhVrNkxKRGVmTg2Uz506zMvAc8Cl+v7aWhkaNvMkRZxk57GhRKMQZoMjFYYetY8MkoQ8iMv9Z1m9qh/ALcXekxEyG/lUiJEb2nH3n4wpQV8cv9s/HDh8Xcb5j9/FdltVs9yvujCPzsZsmuYklrow53QagnAX9J5rE2WpOyoP6xDMPHQSy7XX+PimopP8X10lW9qG4c+5HUK0PABdHDxALcLtFwQm1zt+eCeDq0BjrrHUPk5vYXlNJOQBd51Z6SGqYIHQWtxCFjjyThNpe529mflsfMesmtkfIHIC7BY317M6p7xJR6moQIXMVsbMAZUHPTf4KKOsY5fSh6xA3D4C+C/SI5iiFuDJW61EMQgik8tzxc2J9h1hxZGLcC/yvIiuEb+PSAPAX6C9ojkJEtGQS8EBDwo4zBDLUOn4zx4/vByoLOgkkzhO6DUAYgR7SHLmc6zB9lhKyowx3xK5my4WwYl2tzrpXQEGcAVoQ6BHN8QlJ0kle5EGWkJ74+qPVF+0qcKFC7w6Mmz9cPnNA1wHw5yZRRaMH9mmOjxArsjDppCDJ47F9/qV9/WfXL9d6HXJeXMT+QYh6HXYf/7QP31T4yFzbDJ8zQEALekhTfGQ1l046yUnykPYMMWF3YNwn7D5a58/RihaBn1b4CDHOADUINCF2vw3PdxySTrKSPNqesPN2dWjSybjk248JpQMIy20dysoQfdTztjjW2hCV61qIK8O24Y/2z69WXhJXxwtPV8c8VZq0KkP72fd2H99XFOYt+7l/mOxU7cwbm7QdlxNAPRZ032twiBvBK1U7J8mj7Qk7odKkpaaNVy1BSsQGQI0C3fcl7oemviSP3YBlQV1Ze5MQf7XdLh3aYYprA6AeEheHWI93et4WD207vPIpf6muDlljcFWQpSzot1Je1GPfviugDLLKgqo4JyudPKi4X/k9f/Zx4QAAFnRZzmpK8gjl6hD3w8zx41llQQd2k+JIJ4594DlRGwA1CnSIIj+OiKUqNS2mEbVHECE1yzTw1WH/KFBZ0CBZhqmVTnwiTaZcQgD1WtBtWM9iYSap0z6xvnXg7TMuCI87DJRleOz48aFZThrKTejM89xP9VgAoEaBbpIkdfrDYqoBi/OEJFSSR5aQhloBxbUs6NiUj20u4iWXD0D9Aj1q6LuSpY7OMwRn5mEV5uFTEyKkz3jV1bGlCSC++Lg6fJmzyCvAZljQNxbyuqWOcsTMlWOtQyyWpmt88yhQZbq8LEOvG2PLI49zLh2A7gu0WFnbWuO4rFXoZdnp9x2lxdo0lOSRI6TznNHBaaAVUKYt9BvcGwANCfSjmvadFByaVxAcH7dEMvF4HdjSrMtnPDTL8DbvdjbNTrIuSEwB6K4FnaxB5+RayKkOVygYZmXiMUf4XX3cWzWGx40jWgGlyqgIADoo0Inv19fCKjsBljvxmCFkRx7iclijzzjUCijHDfWZV1w2AN0SaBli76z4fn0EZ26KXR2lJh49hN/UJKRZPuObBWd99qtW+NOG+gzuDYCGuH13MJh67mOqLoYfQh6YrAZij00m6B5kDLH/7BLmJbUwclZAKYMI6T27jwuf3yX1PsyyLGla7F3Lgg7s5/5ilv73RmqpsNYgQHPcshf5r46fTazY2kKu1GJ9kxIzmaD6Q4D9isXq6vvd8/3N6i65zGjP7bKTqroPmcAcNthfJP75PpcNQNwujsSlUWs8rLov0pbyIIIkj9MaCyqVcnXopOWlaX6psjmXDEDcAp1EadTqi0zVJ161dNtO8qizCH9hxIjEZNtNiukfttRfEGiAiAU6WbOv1hRjzeATIRrVaMX6JHns1phlmFlQSb9Pblhtrh/5lksGIE6BntctzhXqEw9N+0keIQoqzc2a0LvUSMK1ZjMAdBSJ4jgq8b6blTPqLC+poWJVLERZ2PT1u/cL5+iRghVQyrJl9+GV9izHn7Eo7D273bHP/84+yuKtDyLpL8992hsAqlE2imNSoZ5GZavZLH2qLi4DuXHc97Xq1e/r6te9H+LGpVbyKPL+skMVO4C4XBznNYqzCNKVozgbU29Z0LLsBmqOPUMSCABUEOja6jwEDBULNWHnE9URijldEgDKCnTwRUFrChU7DLQCykEbJyE1ktilSwJAGYGeh6qtkRKiJHwudKiYdz0LFemqlfSSUUYMIwkA6JFAPw8ozOlQsboIVRZ0r4LoyvvOHduk7aQTAOioQIvwTAOJ85YpTjoJSYhVs+W375QU6QOXCI4aRxJ1s8UlA9C+QJ+H8D2rWF6aZhMsQmQZXqtIF4lvbuih/f5xiyOJOiFRBiACgb7w3bGK5GULF/VWCLeBivS2WRbCTwu1uDS2C8RZRgqfrGWoot3USKIufs8lA9Acn+c8Pwuw7zZTk6Wg0oVvUoWOIo50q3KDGKglv5NY9WYzIjRwcQC0bEHPAmTmDY17+nQovF0djjxKiZlElrwxmxM+N+SSAWhXoENks40j+G1DEyDLsOKNabAixiOzWX5bBBqgYYFetZbfB7Qi22bXd9XsDt6Y6r4JjbhsAJoT6FWLeRZgvzFdxKe+WYYVrOc+xDTjhwZoUKA3nSAFlUrQl3rNj7hsABBoH6ZmGR73waIPVFApz3oemx64NyIcHQFsvEDXsULKoqXfI98rq25PtI7ILG3h+mYZFojzaY/6zKBhvz5ArwX6dQ37baOusSSQ3F9ZaXy1rsZlSJHuoTgnfMmlA9CMQK8yDLDfiwZ/gwiw1MTYW43fzli9exBCpHXtxNOeirOw21KMOUDvBHpRg0CfN3T8M7NMu36W94aM1btFWK5cK9+lUrbHPe43q/HeAFADsmjsnRWxWbx7v/jWZ6f28wu7X7FS61zs9Fh8zfJd695oj+WVffjKfBxlMbLPj+323m5zWUC2yGK27/nKbmfaVliP9kZu2+wFzQBQH7c08eAy9ZwU6r/vu2ONPX5TwzGLf3uixYyqHM/q78yyxl+tPCfFgeRGM6KrZMIisgA1W9DymA5BE2vxwlpHPwWwoiUr8XHA432m4jx3OJ65PR75sQ/zLEIV4vT20JDevM6KfkkzANQk0CqkRyvP/2if/95357IPu++h8c8+E0GWScAXRa6IEsfznT0e8Z3e49SHEWjbnq9tu/5AUwCEJ4niWPXjPgn1BeInNn6rsyT1l0MNpSec9qCcENEBUJMFLf9YK+jxylD+Xgg3R8pyvRBLyyzdHXdKfkxuGl9bYT72sZozjuUneyy3DH7lUIg435HRCU0B0IwFLTwN+UUa7iaTjwemOJFlru9ZTToJeSxHJkxRKFiyT5U7gPCIJWk0JjirEtt9lwm5MmiUx1AtsIEK87yu78v4/mQxWwjDQvvLgqYACMPnKas1CxHtWny2KsTzNn60WnunnP6gyE1W4sR3aAqAMCQ+aLm4xhmvb4X0RbeNJpz8xf75N0OySR1IVIeE3l3QFAD+JD7oIp/wRlia6tKQRJV9TnutjLVOCQCEsKAlSiIjFjpBIjpu2ffMOizO8tv+boh/bootLGmAQAIt2AtqZPKz5kZddHXIRKQ9brGav+JUI9IAXSNdbnS+5r1nXUpI0BVUJEqDNfTaQ9wdZySyAPgL9LrC/WJdX3ZAmKVWsxxnX9YIjB1Jrb+sYzUbgE0n7eJYLTuaxb2Yh626FJOI8wNObVSI71/Ktf7b9p1rmgOgHLfSlqd9eFfyc1OtsRGN1WyW0SYUkY8fyQ49aCohCWAjLGiN5BiXdAvIBFAycfhzmz9Ak07+YfLLiEJcyOhGFkr4JUTFRIBeCLSgkRxl3QNDuz22n/lnG9EdJJ10mjvad25WtMHtAVBOoP/DVKvylvgWG7WGUlbzY05hp7lZ2xChBsjmVobwuUZqzMxyncBZjcIsVrtEZ+Br3kzmdntulnMcFF0CBHrVbWDKTxTmMbXby5BCrTeOpwhzr5B+dFFXyVmAzgm0imGo5A4Zrsp6decuM/YaN/tERXnIqeotYkmLSL/SvoRlDb0WaAlXG9cwdBWL+q3JL5Q/1O2R3iCY+IO8G/9MBXuGYEPfBFrEmWpk0BXmur1K/T0nzho2VaDFin1D08AGWdxY2RCsP9mb/0FTX/b56hNieViRFutjyLmADYAaINBZPst5fkbTAADEKdCvaBoAgDgFmthTAIAYBVpDl0i7BQCI0IIWZjQPAECcAv2S5gEAiFCg//V2TvwoAECkFrTAZCEAQKQCfUETAQBEKNCUegQAiNeCFhBpAIBIBRo3BwBAxBY00RwAALEJtGYV4uYAAIjQghZwcwAAxCjQGs2BmwMAIEILWpjSXAAAcQo0tTkAAGIUaK3NQQlSAIAILWjhOU0GABCnQDNZCAAQo0BrTPSUZgMAiM+CFnBzAADEKNDWip4blsMCAIjSghaOaToAgAgF2lrRYkHPaT4AgPgsaKxoAIBYBdpa0VOsaACAOC1ogYgOAIBIBVqsaBJXAABiE2hNXMGKBgCI0IIWnmFFAwBEKNBY0QAA8VrQWNEAALEKtFrRBzQnAEB8FjRx0QAAsQq0QnYhAECMAq1W9IxmBQCIz4LGigYAiFWgtdLdlKYFAIjPghYkooOwOwCA2ARaw+5wdQAARGhBi0hL8so1TQwAEJlAKySvAAA4crvOnb97v5jfHQwG9s+HNDUAbABzq2svN8WCFsQXPee8AgBEJtDU6QAAiNeCFpE+tw/nNDcAQGQCrUwMrg4AgPgEWl0dE5ocAKAct5v8MqI6AKDjbFwUxyoS1UECCwBAbAKdcnVQqwMAoIDbbXypHSL8dHcw+MX++ZhTAAAdolEXx+22fqX9kd9bkR7aP7c45wCAQH/KZy3/WElgwR8NABCbQOOPBgCI14IWkb42pIIDAHzC7RgO4t37xTXx0QDQAXrlg05b0mJFU68DACA2gVbEH82kIQBAbAKtk4Z7hklDAIDoLGgR6bl92EGkAQCBjhAiOwAAIhVoFempoTwpAPSY2zEfHOF3ABAZ/QyzK7CkxdUxpV8AQN/4rAsHaUV6gkgDAAKNSAMAINCINADAhgh0SqTJNgQABDpSkd7GkgYABDpuSxqRBgAEGpEGAECgEWkAgE0Q6JRIP+N0AgACHadIS8YhtTsAAIGOVKSniDQAINBxi7SE4VFPGgAQ6AhFWhJZpOg/CS0AgEBHLNIzTjMAINDxifTCbiLSRHgAAAIdqVAT4QEACHTEIj01y8nDOacdABDo+ET6WkV6xqkHgNi53bcf/O794mdZU+zuYHDL/ndEFwCACrAmYUPW9JFZRnnM6XMAECOf9fnHW5GemaXL45yuAACxcbvvDaAuj2/vDgbv7X8f2u0O3QIAcsDF0ZI1/cwwgQgAWNDRWtMLJhABAAs6bmv6SK1pankAABZ0hNb0T3Z7gW8aALCg47Wm8U0DQCsg0OVEeq5Fl/YMcdMAgEBHKdTnak0f0xoAgEDHJ9ILnUS8b3B7AAACHaVQJ24P0sUBAIGOVKhndhNrWupNsw4iACDQEQr11CzdHscINQCEgDjogGhdj9ndweCF/e8vhmxEgE2j0ThoBLpeoZYTObDbFq0CgEBXBRdHjehEovimxfUxpUUAoAq3aILm+OMXQ7Gm9+32VC1rAOgWM43eqnrtj+zDE7N0ew7TFrlZhuu+1Pr0CHREQv1k5WQBwAYJtL3W5fo+Nb/NR12rIEuNn9/r84kLVJ4/0LVTEehIxHqsFjV+aoANEmh7bcs1famj5XMV33mOiB/aTbRAIsB2EpFGoOMR6mQINKY1ALot0Cq6VyrOEw3DLWOsnaZF+nPaOw7U/zSzJ+lYRRr3B0B3OV0VZ3tt/5rz3vPkffY9yWdPRKSxoOO2qndVqHdpDYBuWNA6Gr5cfa8KtIh1EqYnavylXt/n9r17+r4zfW4PCzpuq1rurOc6qZhY1fiqAeLmiT5mVb18uxKtIVbz5YoRdqz/f0IcdDeEWiroPbOblDqVTRYRmNMyAFEiFvQiK2wuh8XK9X6t1/cIC7p7Yi0nT7YDnSV+qndb4qoB4mBo8ksRf6EukLSY37g4Vt6HQG+IWEum4kTFOvFXD2kdgCgZm08jtW4MrpXnXiHQm21Zi1DLBAQ+a4B4mJrlJKEYURKt8WFycIVH8g8CvdlifaQTjLt6wnGFANTPosAw+jBJaK/NmwgOcXlk+KtFwBdMEm6+WMtkxVSKNtntD2Y5ySjDqXND3WqAOpBra7Dia84iWeTjVA0po8K9pQI9Q6B7aF1rRMhehmDPaSEAb5I458N1xpNee8OV9yZ/X5CoAh+hKapyB3+kjyNaBeADZVO9L/XaWc0kPNZFp7Peu2N+802LIbWNQEMZ0U6GXIlwDw2RIoBAr7tmkkJJZWtx7Ko4Cze1OBBo8BHuUUqs/6SdEYsbei/QGSI9Vet5njNqTVezO0gEHYGGOsXbpAQ7EXCWAINeCHRKpE9TfT5dD9roiHSUem1CPWiIUcjNGvH+wuBWgfYR3/CBQz8X6/hLFeN0qOtCBfsiyw3y/wIMAAQUqSfO31wrAAAAAElFTkSuQmCC',
            width: 30,
            margin: [40, -5, 40, 0]
          },
          { fontSize: 6, margin: [75, 0, 40, 0], text: "* Indicates results recorded via FTIR.\n Disclaimer: All information including recommended actions are provided on an “as is” basis.  No warranty is expressed or implied. Cummins expressly disclaims any and all warranties and liability arising from or otherwise related to information provided herein.  See the Marketplace Terms and Conditions of Use for more details regarding such disclaimers. \n FluidWatch® \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t fluidwatch.laboratory@cummins.com", alignment: 'justify' }
        ]
      },
      content: [
        {
          table: {
            body: [
              [

                {
                  fontSize: 10, bold: true, border: [true, true, false, false],
                  table: {
                    widths: [110],
                    //heights: [29],

                    body: [
                      [
                        {
                          image: this.getAddressImage(),
                          width: 110,
                          //height: 50,
                          border: [false, false, false, false]
                        },
                      ]
                    ]
                  }, layout: {
                    hLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    },

                  }
                },
                {
                  fontSize: 10, bold: true, border: [false, true, false, false],
                  table: {
                    widths: [70, 70, 70],
                    body: this.getHeaderBody()
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.body.length) ? 2 : 2;
                    },
                    vLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.widths.length) ? 2 : 2;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    },

                  }
                }
                ,
                {
                  fontSize: 8, bold: true, border: [false, true, true, false],
                  table: {
                    widths: [24, 33, 37],

                    body: [
                      [{ fillColor: '#DA291C', text: '' }, 'Red', 'Warning'],
                      [{ fillColor: '#F19806', text: '' }, 'Orange', 'Caution'],
                      [{ fillColor: '#F8E71C', text: '' }, 'Yellow', 'Watch'],
                      [{ fillColor: '#0AB50A', text: '' }, 'Green', 'Normal'],
                    ]
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.body.length) ? 2 : 2;
                    },
                    vLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.widths.length) ? 2 : 2;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    },

                  }
                }
              ]
            ]
          },

        },
        {
          style: 'tableContentSmi', margin: [0, 0, 0, 0],
          table: {
            body: [[{
              fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Customer & Unit Information',
              border: [false, true, true, false]
            },
            {
              fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Fluid & Filter Information',
              border: [false, true, true, false]
            }
              , {
              fillColor: '#696969', color: '#FFFFFF', alignment: 'center', bold: true, text: 'Sample Information',
              border: [false, true, false, false]
            }],
            [{
              border: [false, false, false, false], margin: [-4.5, -2, -4.5, -4],
              table: {
                widths: [78, 78],
                body: [

                  ['Company ID', this.buildTableBody(this.showMoreInforItemArr, ['companyId'])],
                  ['Company Name', this.buildTableBody(this.showMoreInforItemArr, ['companyName'])],
                  ['Customer Name', this.buildTableBody(this.showMoreInforItemArr, ['customerName'])],
                  ['Phone Number', this.buildTableBody(this.showMoreInforItemArr, ['phoneNumber'])],
                  ['Component ID', this.buildTableBody(this.showMoreInforItemArr, ['componentId'])],
                  ['Unit Make', this.buildTableBody(this.showMoreInforItemArr, ['unitMake'])],
                  ['Unit Model', this.buildTableBody(this.showMoreInforItemArr, ['unitModel'])],
                  ['Unit Year', this.buildTableBody(this.showMoreInforItemArr, ['unitYear'])],
                  ['Equipment Serial No', this.buildTableBody(this.showMoreInforItemArr, ['esn'])]

                ]
              },
              layout: {
                hLineWidth: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
                },
                vLineWidth: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
                },
                hLineColor: function (i, node) {
                  return 'lightGray';
                },
                vLineColor: function (i, node) {
                  return 'lightGray';
                },

                fillColor: function (rowIndex, node, columnIndex) {
                  return (rowIndex % 2 != 0) ? '#CCCCCC' : null;
                }
              }
            },
            {
              border: [false, false, false, false], margin: [-4.5, -2, -4.5, -3],

              table: {
                widths: [78, 78],

                body: [

                  ['Fluid Brand', this.buildTableBody(this.showMoreInforItemArr, ['fluidBrand'])],
                  ['Fluid Product', this.buildTableBody(this.showMoreInforItemArr, ['fluidProduct'])],
                  ['Fluid Grade', this.buildTableBody(this.showMoreInforItemArr, ['fluidGrade'])],
                  ['Filter Brand', this.buildTableBody(this.showMoreInforItemArr, ['filterBrand'])],
                  ['Filter Product', this.buildTableBody(this.showMoreInforItemArr, ['filterProduct'])],
                  ['Sampled Location', this.buildTableBody(this.showMoreInforItemArr, ['sampledLocation'])],
                  ['Tracking Number', this.buildTableBody(this.showMoreInforItemArr, ['trackingNumber'])],
                  ['Sample Remarks', this.buildTableBody(this.showMoreInforItemArr, ['sampleRemarks'])]

                ]
              },
              layout: {
                hLineWidth: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
                },
                vLineWidth: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
                },
                hLineColor: function (i, node) {
                  return 'lightGray';
                },
                vLineColor: function (i, node) {
                  return 'lightGray';
                },

                fillColor: function (rowIndex, node, columnIndex) {
                  return (rowIndex % 2 != 0) ? '#CCCCCC' : null;
                }
              }
            },
            {
              border: [false, false, false, false], margin: [-4.5, -2, -5, -4],

              table: {

                widths: [78, 77],

                body: [

                  ['Sample ID', this.buildTableBody(this.showMoreInforItemArr, ['sampleId'])],
                  ['QR Code	', this.buildTableBody(this.showMoreInforItemArr, ['qrCodeId'])],
                  ['Sampled Date', this.buildTableBody(this.showMoreInforItemArr, ['sampledDate'])],
                  ['Received Date', this.buildTableBody(this.showMoreInforItemArr, ['receivedDate'])],
                  ['Completed Date', this.buildTableBody(this.showMoreInforItemArr, ['completedDate'])],
                  ['Component Make', this.buildTableBody(this.showMoreInforItemArr, ['engineMake'])],

                  ['Component Model', this.buildTableBody(this.showMoreInforItemArr, ['engineModel'])],
                  ['Component Year', this.buildTableBody(this.showMoreInforItemArr, ['engineYear'])],

                  ['Component Serial No', this.buildTableBody(this.showMoreInforItemArr, ['gsn'])]

                ]
              },
              layout: {
                hLineWidth: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
                },
                vLineWidth: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
                },
                hLineColor: function (i, node) {
                  return 'lightGray';
                },
                vLineColor: function (i, node) {
                  return 'lightGray';
                },

                fillColor: function (rowIndex, node, columnIndex) {
                  return (rowIndex % 2 != 0) ? '#CCCCCC' : null;
                }
              }
            }],
            ]
          }
        },

        {
          style: 'analysisAndAction', margin: [0, 0, 0, 0],
          border: [true, false, false, false],

          table: {
            widths: [336.7, 163.3],

            body: [
              [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Analysis' },
              { fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Recommended Actions' }],
              [
                {
                  fontSize: 8, heights: 50, bold: false, text: [this.analysisComment,

                  ]

                },

                {
                  fontSize: 8, heights: 50, bold: false, text: [this.actionComment
                  ]
                }
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }
          }
        },

        //two graph
        // {
        //   style: 'analysisAndAction', margin: [0, 0, 0, 0],
        //   border: [true, false, false, false],

        //   table: {
        //     widths: [250, 250],

        //     body: [
        //       [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: this.yAxisLabelPDF1 },
        //       { fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: this.yAxisLabelPDF2 }],
        //       [
        //         {
        //           image: this.imageData1,
        //           width: 250,
        //           margin: [10, 0, 0, 0]
        //         },

        //         {
        //           image: this.imageData2,
        //           width: 250

        //         }
        //       ]
        //     ]
        //   },
        //   layout: {
        //     hLineWidth: function (i, node) {
        //       return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
        //     },
        //     vLineWidth: function (i, node) {
        //       return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
        //     },
        //     hLineColor: function (i, node) {
        //       return 'lightGray';
        //     },
        //     vLineColor: function (i, node) {
        //       return 'lightGray';
        //     }

        //   }
        // },
        {
          style: 'analysisAndAction', margin: [0, 0, 0, 0],
          //border: [true, false, false, false],

          table: {
            widths: [508],

            body: [
              [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Oil Health' },
              ],
              [
                {
                  image: this.oilHealthInfoImgLubricant,
                  width: 515,
                  margin: [-3.5, -2, 0, 0]
                },

              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }

          }
        },
        {
          style: 'analysisAndAction', margin: [0, 0, 0, 0],
          //border: [true, false, false, false],

          table: {
            widths: [508],

            body: [
              [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'All Metals Information (ppm)' },
              ],
              [
                {
                  image: this.allMetalInfoImgLubricant,
                  width: 515,
                  margin: [-3.5, -2, 0, 0]
                },

              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }

          }
        },
        this.buildTwoGraphForLubricant(),
        this.buildFourGraphForLubricants(),
      ],

      styles: {
        header: {
          fontSize: 8,
          bold: true,
        },
        tableContentSmi: {
          fontSize: 8
        },
        tableContentOilHealth: {
          fontSize: 7,
          alignment: 'center'

        },
        tableContentMetal: {
          fontSize: 6.35,
          alignment: 'center',
          border: true
        },
        analysisAndAction: {
          fontSize: 8,
          bold: true,

        },
        disclaimer: {
          fontSize: 6,
          bold: true
        }
      }

    };

    pdfMake.createPdf(pdfDocument).download(this.currentItem.sampleId);
    this.isDisabledSelectThumbnails = false;
  }

  buildFourGraphForLubricants() {
    if (this.imageData3 == '' || this.imageData4 == '' ||
      this.imageData3 == undefined || this.imageData4 == undefined) {
      return {};
    } else {
      return {
        style: 'analysisAndAction', margin: [0, 0, 0, 0],
        unbreakable: true,
        border: [true, false, false, false],

        table: {
          widths: [250, 250],

          body: [
            [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: this.yAxisLabelPDF3 },
            { fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: this.yAxisLabelPDF4 }],
            [
              {
                image: this.imageData3,
                width: 250,
                margin: [10, 0, 0, 0]
              },

              {
                image: this.imageData4,
                width: 250

              }
            ]
          ]
        },
        layout: {
          hLineWidth: function (i, node) {
            return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
          },
          vLineWidth: function (i, node) {
            return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
          },
          hLineColor: function (i, node) {
            return 'lightGray';
          },
          vLineColor: function (i, node) {
            return 'lightGray';
          }

        }
      }
    };
  }

  buildTwoGraphForLubricant() {
    if (this.imageData1 == '' || this.imageData2 == '' ||
      this.imageData1 == undefined || this.imageData2 == undefined) {
      return {};
    } else {
      return {
        style: 'analysisAndAction', margin: [0, 0, 0, 0],
        //pageBreak: 'before',
        unbreakable: true,
        border: [true, false, false, false],

        table: {
          widths: [250, 250],

          body: [
            [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: this.yAxisLabelPDF1 },
            { fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: this.yAxisLabelPDF2 }],
            [
              {
                image: this.imageData1,
                width: 250,
                margin: [10, 0, 0, 0]
              },

              {
                image: this.imageData2,
                width: 250

              }
            ]
          ]
        },
        layout: {
          hLineWidth: function (i, node) {
            return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
          },
          vLineWidth: function (i, node) {
            return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
          },
          hLineColor: function (i, node) {
            return 'lightGray';
          },
          vLineColor: function (i, node) {
            return 'lightGray';
          }

        }
      };
    }
  }

  buildTwoGraphForCoolant() {
    if (this.imageData1 == '' || this.imageData2 == '' ||
      this.imageData1 == undefined || this.imageData2 == undefined) {
      return {};
    } else {
      return {
        style: 'analysisAndAction', margin: [0, 0, 0, 0],
        //pageBreak: 'before',
        unbreakable: true,
        border: [true, false, false, false],

        table: {
          widths: [250, 250],

          body: [
            [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: this.yAxisLabelPDF1 },
            { fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: this.yAxisLabelPDF2 }],
            [
              {
                image: this.imageData1,
                width: 250,
                margin: [10, 0, 0, 0]
              },

              {
                image: this.imageData2,
                width: 250

              }
            ]
          ]
        },
        layout: {
          hLineWidth: function (i, node) {
            return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
          },
          vLineWidth: function (i, node) {
            return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
          },
          hLineColor: function (i, node) {
            return 'lightGray';
          },
          vLineColor: function (i, node) {
            return 'lightGray';
          }

        }
      };
    }
  }

  buildFourGraphForCoolant() {
    if (this.imageData3 == '' || this.imageData4 == '' ||
      this.imageData3 == undefined || this.imageData4 == undefined) {
      return {};
    } else {
      return {
        style: 'analysisAndAction', margin: [0, 0, 0, 0],
        unbreakable: true,
        border: [true, false, false, false],

        table: {
          widths: [250, 250],

          body: [
            [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: this.yAxisLabelPDF3 },
            { fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: this.yAxisLabelPDF4 }],
            [
              {
                image: this.imageData3,
                width: 250,
                margin: [10, 0, 0, 0]
              },

              {
                image: this.imageData4,
                width: 250

              }
            ]
          ]
        },
        layout: {
          hLineWidth: function (i, node) {
            return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
          },
          vLineWidth: function (i, node) {
            return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
          },
          hLineColor: function (i, node) {
            return 'lightGray';
          },
          vLineColor: function (i, node) {
            return 'lightGray';
          }

        }
      }
    };
  }

  downloadPDFForFuel() {
    this.isDisabledSelectThumbnails = true;
    this.loaderService.show();
    document.getElementById('fuel1').style.overflow = 'visible';
    document.getElementById('fuel1').style.width = '1800px';
    document.getElementById('fuel2').style.overflow = 'visible';
    document.getElementById('fuel2').style.width = '1800px';
    document.getElementById('fuel3').style.overflow = 'visible';
    document.getElementById('fuel3').style.width = '1800px';

    let self = this;
    html2canvas(document.getElementById('fuel1')).then(function (canvas) {
      const fuel1Image = canvas.toDataURL('image/png');
      self.addFuel1Img(fuel1Image);
      html2canvas(document.getElementById('fuel2')).then(function (canvas) {
        const fuel2Image = canvas.toDataURL('image/png');
        self.addFuel2Img(fuel2Image);
        html2canvas(document.getElementById('fuel3')).then(function (canvas) {
          const fuel3Image = canvas.toDataURL('image/png');
          self.addFuel3Img(fuel3Image);
          document.getElementById('fuel1').style.overflow = 'auto';
          document.getElementById('fuel1').style.width = 'auto';
          document.getElementById('fuel2').style.overflow = 'auto';
          document.getElementById('fuel2').style.width = 'auto';
          document.getElementById('fuel3').style.overflow = 'auto';
          document.getElementById('fuel3').style.width = 'auto';

          self.generatePdfForFuel();
          self.loaderService.hide();
        });
      });
    });

  }

  generatePdfForFuel() {
    this.showMoreInforItemArr = [];
    this.showMoreInforItemArr.push(this.showMoreInformationData);
    let self = this;
    let pdfDocument = {

      footer: {
        columns: [
          {
            image: this.addressImageService.getFooterLogo(),
            width: 30,
            margin: [40, -5, 40, 0]
          },

          { fontSize: 6, margin: [75, 0, 40, 0], text: "Disclaimer: All information including recommended actions are provided on an “as is” basis.  No warranty is expressed or implied. Cummins expressly disclaims any and all warranties and liability arising from or otherwise related to information provided herein.  See the Marketplace Terms and Conditions of Use for more details regarding such disclaimers. \n FluidWatch® \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t fluidwatch.laboratory@cummins.com", alignment: 'justify' }
        ]
      },
      content: [
        {
          table: {
            body: [
              [

                {
                  fontSize: 10, bold: true, border: [true, true, false, false],
                  table: {
                    widths: [110],
                    //heights: [29],

                    body: [
                      [
                        {
                          image: this.getAddressImage(),
                          width: 110,
                          //height: 50,
                          border: [false, false, false, false]
                        },
                      ]
                    ]
                  }, layout: {
                    hLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    },

                  }
                },
                {
                  fontSize: 10, bold: true, border: [false, true, false, false],
                  table: {
                    widths: [70, 70, 70],
                    body: this.getHeaderBody()
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.body.length) ? 2 : 2;
                    },
                    vLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.widths.length) ? 2 : 2;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    },

                  }
                }
                ,
                {
                  fontSize: 8, bold: true, border: [false, true, true, false],
                  table: {
                    widths: [24, 33, 37],

                    body: [
                      [{ fillColor: '#DA291C', text: '' }, 'Red', 'Warning'],
                      [{ fillColor: '#F19806', text: '' }, 'Orange', 'Caution'],
                      [{ fillColor: '#F8E71C', text: '' }, 'Yellow', 'Watch'],
                      [{ fillColor: '#0AB50A', text: '' }, 'Green', 'Normal'],
                    ]
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.body.length) ? 2 : 2;
                    },
                    vLineWidth: function (i, node) {
                      return (i === 0 || i === node.table.widths.length) ? 2 : 2;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    },

                  }
                }
              ]
            ]
          },

        },
        {
          style: 'tableContentSmi', margin: [0, 0, 0, 0],
          table: {
            body: [
              [{
                fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Customer & Unit Information',
                border: [false, true, true, false]

              },

              {
                fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Fluid & Filter Information',
                border: [false, true, true, false]
              }
                , {
                fillColor: '#696969', color: '#FFFFFF', alignment: 'center', bold: true, text: 'Sample Information',
                border: [false, true, false, false], margin: [0, 0, 0, 0]
              }],
              [{
                border: [false, false, false, false], margin: [-4.5, -2, -4.5, -4],
                table: {
                  widths: [78, 78],
                  body: [

                    ['Company ID', this.buildTableBody(this.showMoreInforItemArr, ['companyId'])],
                    ['Company Name', this.buildTableBody(this.showMoreInforItemArr, ['companyName'])],
                    ['Customer Name', this.buildTableBody(this.showMoreInforItemArr, ['customerName'])],
                    ['Phone Number', this.buildTableBody(this.showMoreInforItemArr, ['phoneNumber'])],
                    ['Component ID', this.buildTableBody(this.showMoreInforItemArr, ['componentId'])],
                    ['Unit Make', this.buildTableBody(this.showMoreInforItemArr, ['unitMake'])],
                    ['Unit Model', this.buildTableBody(this.showMoreInforItemArr, ['unitModel'])],
                    ['Unit Year', this.buildTableBody(this.showMoreInforItemArr, ['unitYear'])],
                    ['GSN', this.buildTableBody(this.showMoreInforItemArr, ['gsn'])]

                  ]
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
                  },
                  vLineWidth: function (i, node) {
                    return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
                  },
                  hLineColor: function (i, node) {
                    return 'lightGray';
                  },
                  vLineColor: function (i, node) {
                    return 'lightGray';
                  },

                  fillColor: function (rowIndex, node, columnIndex) {
                    return (rowIndex % 2 != 0) ? '#CCCCCC' : null;
                  }
                }
              },
              {
                border: [false, false, false, false], margin: [-4.5, -2, -4.5, -3],
                table: {
                  widths: [78, 78],
                  body: [
                    ['Diesel Fuel', this.buildTableBody(this.showMoreInforItemArr, ['fluidGrade'])],
                    ['Filter Brand', this.buildTableBody(this.showMoreInforItemArr, ['filterBrand'])],
                    ['Filter Product', this.buildTableBody(this.showMoreInforItemArr, ['filterProduct'])],
                    ['Sampled Location', this.buildTableBody(this.showMoreInforItemArr, ['sampledLocation'])],
                    ['Geographic Location	', this.buildTableBody(this.showMoreInforItemArr, ['geographicLocation'])],
                    ['Tracking Number', this.buildTableBody(this.showMoreInforItemArr, ['trackingNumber'])],
                    ['Sample Remarks', this.buildTableBody(this.showMoreInforItemArr, ['sampleRemarks'])]

                  ]
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
                  },
                  vLineWidth: function (i, node) {
                    return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
                  },
                  hLineColor: function (i, node) {
                    return 'lightGray';
                  },
                  vLineColor: function (i, node) {
                    return 'lightGray';
                  },

                  fillColor: function (rowIndex, node, columnIndex) {
                    return (rowIndex % 2 != 0) ? '#CCCCCC' : null;
                  }
                }
              },
              {
                border: [false, false, false, false], margin: [-4.5, -2, -5, -4],
                table: {
                  widths: [78, 77],
                  body: [

                    ['Sample ID', this.buildTableBody(this.showMoreInforItemArr, ['sampleId'])],
                    ['QR Code	', this.buildTableBody(this.showMoreInforItemArr, ['qrCodeId'])],
                    ['Sampled Date', this.buildTableBody(this.showMoreInforItemArr, ['sampledDate'])],
                    ['Received Date', this.buildTableBody(this.showMoreInforItemArr, ['receivedDate'])],
                    ['Completed Date', this.buildTableBody(this.showMoreInforItemArr, ['completedDate'])],
                    ['Component Make', this.buildTableBody(this.showMoreInforItemArr, ['engineMake'])],

                    ['Component Model', this.buildTableBody(this.showMoreInforItemArr, ['engineModel'])],
                    ['Component Year', this.buildTableBody(this.showMoreInforItemArr, ['engineYear'])],
                    ['Component Serial No', this.buildTableBody(this.showMoreInforItemArr, ['gsn'])]
                  ]
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
                  },
                  vLineWidth: function (i, node) {
                    return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
                  },
                  hLineColor: function (i, node) {
                    return 'lightGray';
                  },
                  vLineColor: function (i, node) {
                    return 'lightGray';
                  },

                  fillColor: function (rowIndex, node, columnIndex) {
                    return (rowIndex % 2 != 0) ? '#CCCCCC' : null;
                  }
                }
              }],
            ]
          },
        },

        {
          style: 'analysisAndAction', margin: [0, 0, 0, 0],
          table: {
            widths: [336.7, 163.3],

            body: [
              [{ fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Analysis' },
              { fillColor: '#696969', color: '#FFFFFF', bold: true, alignment: 'center', text: 'Recommended Actions' }],
              [
                {
                  fontSize: 8, heights: 50, bold: false, text: [this.analysisComment,

                  ]

                },

                {
                  fontSize: 8, heights: 50, bold: false, text: [this.actionComment
                  ]
                }
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }
          }
        },

        {
          style: 'analysisAndAction', margin: [0, 0, 0, 0],
          table: {
            widths: [508],
            body: [

              [
                {
                  image: this.fuel1Img,
                  width: 515,
                  margin: [-3.5, -2, 0, 0]
                },

              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }
          }
        },
        {
          margin: [0, 0, 0, 0],
          table: {
            widths: [508],
            body: [
              [
                {
                  image: this.fuel2Img,
                  width: 515,
                  margin: [-3.5, -2, 0, -2]
                },

              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }

          }
        },

        {
          style: 'analysisAndAction', margin: [0, 0, 0, 0],

          table: {
            widths: [508],

            body: [
              [
                {
                  image: this.fuel3Img,
                  width: 515,
                  margin: [-3.5, -2, 0, 0]
                },

              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 0.1 : 0.1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 0.1 : 0.1;
            },
            hLineColor: function (i, node) {
              return 'lightGray';
            },
            vLineColor: function (i, node) {
              return 'lightGray';
            }

          }
        },
      ],

      styles: {
        header: {
          fontSize: 8,
          bold: true,
        },
        tableContentSmi: {
          fontSize: 8
        },
        tableContentOilHealth: {
          fontSize: 6.8,
          alignment: 'center'

        },
        tableContentMetal: {
          fontSize: 6.5,
          alignment: 'center',
          border: true
        },
        analysisAndAction: {
          fontSize: 8,
          bold: true
        },
        disclaimer: {
          fontSize: 6,
          bold: true
        }
      }

    };

    pdfMake.createPdf(pdfDocument).download(this.currentItem.sampleId);
    this.isDisabledSelectThumbnails = false;
  }



  getHeaderLable(paramName, paramDesc) {
    let headerLabel = '';
    if (paramName == 'Fe' || paramName == 'Cu' || paramName == 'Pb' || paramName == 'Cr'
      || paramName == 'Al' || paramName == 'K' || paramName == 'Na' || paramName == 'Ca'
      || paramName == 'Sn' || paramName == 'Zn' || paramName == 'Mg' || paramName == 'P'
      || paramName == 'Pb' || paramName == 'Mo' || paramName == 'Si' || paramName == 'Mn'
      || paramName == 'Ag' || paramName == 'Ba' || paramName == 'Bi' || paramName == 'In'
      || paramName == 'Ni' || paramName == 'B' || paramName == 'Water'
      || paramName == 'Glycolate' || paramName == 'Formate' || paramName == 'Oxalate' || paramName == 'Chloride'
      || paramName == 'Fluoride' || paramName == 'Bromide' || paramName == 'Sulfate' || paramName == 'S'
      || paramName == 'BT' || paramName == 'NaTT' || paramName == 'NaMBT' || paramName == '2-EHA'
      || paramName == 'BA' || paramName == '4-tBA' || paramName == 'AA' || paramName == 'SA'
      || paramName == 'DDA' || paramName == 'Nitrate' || paramName == 'Nitrite' || paramName == 'Phosphate'
      || paramName == 'Molybdate' || paramName == 'PToluicAcid') {
      headerLabel = paramDesc + ' ' + '(ppm)';
    } else if ((paramName == 'Soot') || (paramName == 'Fuel Dilution') || (paramName == 'FuelDilution')) {
      headerLabel = paramDesc + ' ' + ' (%)';
    } else if (paramName == 'Vis40' || paramName == 'Vis100' || paramName == 'VIS 40' || paramName == 'VIS 100') {
      headerLabel = paramDesc + ' ' + ' (cSt)';
    } else if ((paramName == 'TAN') || (paramName == 'TBN')) {
      headerLabel = paramDesc + ' ' + ' (mg KOH/g)';
    } else if (paramName == 'pH') {
      headerLabel = paramDesc;
    } else if (paramName == 'Glycol') {
      headerLabel = paramDesc + ' ' + ' (%)';
    } else if (paramName == 'SCA') {
      headerLabel = paramDesc + ' ' + ' (units/gal)';
    } else {
      headerLabel = paramName + ' ' + ' (abs/cm)';
    }
    return headerLabel;
  }

  showReasonCommentHistory() {
    this.isExpanded = true;
  }
  hideReasonCommentHistory() {
    this.isExpanded = false;
  }

  getAddressImage() {
    if (this.currentItem.analysisType == 'Engine Oil (Liquid Fuel)') {
      return this.addressImageService.getDieselEngineOilImage();
    } else if (this.currentItem.analysisType == 'Lubricants') {
      return this.addressImageService.getLubricantImage();
    } else if (this.currentItem.analysisType == 'Engine Oil (Gaseous Fuel)') {
      return this.addressImageService.getNaturalGasEngineOilImage();
    } else if (this.currentItem.analysisType == 'Coolant') {
      return this.addressImageService.getCoolantImage();
    } else if (this.currentItem.analysisType == 'Diesel Fuel') {
      return this.addressImageService.getFuelImage(this.currentItem.testLevel);
    } else if (this.currentItem.analysisType == 'Diesel Exhaust Fluid') {
      return this.addressImageService.getDieselExhaustFluidImage();
    }
  }

  getHeaderBody() {
    if (this.currentItem.analysisType == 'Engine Oil (Liquid Fuel)') {
      return [
        [{
          fillColor: this.getCoolantContaminationSevColor(), text: this.coolantContaminationForPDF,
          border: [false, false, true, true], alignment: 'center'
        },
        { fillColor: this.getDustContaminationSevColor(), text: this.dustContaminationForPDF, border: [true, false, true, true], alignment: 'center' },
        { fillColor: this.getSootContaminationSevColor(), text: this.sootContaminationForPDF, border: [true, false, true, true], alignment: 'center' }],
        [{ fillColor: this.getDOContaminationSevColor(), text: this.degradedOilForPDF, border: [false, true, true, false], alignment: 'center', margin: [0, 7, 0, 0] },
        { fillColor: this.getFuelContaminationSevColor(), text: this.fuelContaminationForPDF, border: [true, true, true, false], alignment: 'center' },
        { fillColor: this.getEWContaminationSevColor(), text: this.engineWearForPDF, border: [true, true, true, false], alignment: 'center', margin: [0, 7, 0, 0] }],
      ];
    } else if (this.currentItem.analysisType == 'Engine Oil (Gaseous Fuel)') {
      return [
        [{
          fillColor: this.getCoolantContaminationSevColor(), text: this.coolantContaminationForPDF,
          border: [false, false, true, true], alignment: 'center'
        },
        { fillColor: this.getDustContaminationSevColor(), text: this.dustContaminationForPDF, border: [true, false, true, true], alignment: 'center' },
        { fillColor: this.getEWContaminationSevColor(), text: this.engineWearForPDF, border: [true, false, true, true], alignment: 'center', margin: [0, 7, 0, 0] }],
        [{ fillColor: this.getDOContaminationSevColor(), text: this.degradedOilForPDF, border: [false, true, true, false], alignment: 'center', margin: [0, 7, 0, 0] },
        { fillColor: this.getWaterContaminationSevColor(), text: this.waterContaminationForPDF, border: [true, true, true, false], alignment: 'center' },
        {}],
      ];
    } else if (this.currentItem.analysisType == 'Lubricants') {
      return [
        [{
          fillColor: this.getCoolantContaminationSevColor(), text: this.coolantContaminationForPDF,
          border: [false, false, true, true], alignment: 'center'
        },
        { fillColor: this.getParticleContaminationSevColor(), text: this.particleContaminationForPDF, border: [true, false, true, true], alignment: 'center' },
        { fillColor: this.getMetalWearSevColor(), text: this.metalWearForPDF, border: [true, false, true, true], alignment: 'center', margin: [0, 7, 0, 0] }],
        [{ fillColor: this.getDOContaminationSevColor(), text: this.degradedOilForPDF, border: [false, true, true, false], alignment: 'center', margin: [0, 7, 0, 0] },
        { fillColor: this.getWaterContaminationSevColor(), text: this.waterContaminationForPDF, border: [true, true, true, false], alignment: 'center' },
        {}],
      ];
    } else if (this.currentItem.analysisType == 'Coolant') {
        return [
          [{
            fillColor: this.getSystemContaminationSevColor(), text: this.systemcorrosionContaminationForPDF,
            border: [true, true, true, false], alignment: 'center'
          },
          { fillColor: this.getHardParticleContaminationSevColor(), text: this.hardparticleContaminationForPDF, border: [false, true, true, false], alignment: 'center', margin: [0, 7, 0, 0] },
          { fillColor: this.getElectricalConductivitySevColor(), text: this.eletricalConductivityForPDF, border: [true, true, true, false], alignment: 'center',margin: [0, 0, 0, 0] }
        ],
          // { fillColor: '#696969', text: '', border: [false, true, true, false], alignment: 'center', margin: [0, 7, 0, 0] }],
        [
          { fillColor: this.getDegradedContaminationSevColor(), text: this.degradedcoolantContaminationForPDF, border: [true, true, true, false], alignment: 'center' },
          { fillColor: this.getExcessiveContaminationSevColor(), text: this.excessiveContaminationForPDF, border: [true, true, true, false], alignment: 'center', margin: [0, 0, 0, 0] },
          { fillColor: '#696969', text: '', border: [true, true, true, false], alignment: 'center' }
        ],
      ];
        
    } else if (this.currentItem.analysisType == 'Diesel Fuel') {
      return [
        [
          { fillColor: this.getFuelCharacteristicsSevColor(), text: this.fuelCharacteristicsForPDF, border: [true, true, true, false], alignment: 'center' },
          {
            fillColor: this.getSulfurContaminationSevColor(), text: this.sulfurContaminationForPDF,
            border: [false, true, true, false], alignment: 'center', margin: [0, 7, 0, 0]
          },
          { fillColor: this.getDegradedFuelSevColor(), text: this.degradedFuelForPDF, border: [false, true, true, false], alignment: 'center', margin: [0, 7, 0, 0] }
        ],
        [
          { fillColor: this.getFuelCleanlinessSevColor(), text: this.fuelCleanlinessForPDF, border: [true, true, true, false], alignment: 'center' },
          { fillColor: this.getTraceMetalsSevColor(), text: this.traceMetalsForPDF, border: [true, true, true, false], alignment: 'center', margin: [0, 7, 0, 0] },
          { fillColor: this.getBacteriaContentSevColor(), text: this.bacteriaContentForPDF, border: [true, true, true, false], alignment: 'center', }
        ],
      ];
    } else if (this.currentItem.analysisType == 'Diesel Exhaust Fluid') {
      return [];
    }
  }

  closeAction() {
    if (this.userRole == USERTYPE.DATA_SCIENTIST || this.userRole == USERTYPE.FLUIDWATCH_MANAGER) {
      this.router.navigate(['/analyzeSample']);
    } else if (this.userRole == USERTYPE.EXTERNAL) {
      this.router.navigate(['/analyzeSample']);
    } else {
      this.router.navigate(['/viewReportHome']);

    }
  }

}
